// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../node_modules/css-loader/dist/runtime/api.js";
import ___CSS_LOADER_GET_URL_IMPORT___ from "../../node_modules/css-loader/dist/runtime/getUrl.js";
var ___CSS_LOADER_URL_IMPORT_0___ = new URL("data:image/svg+xml,<svg xmlns=\"http://www.w3.org/2000/svg\" width=\"24\" height=\"24\" viewBox=\"0 0 24 24\" fill=\"none\" stroke=\"%230E1218\" stroke-width=\"2\" stroke-linecap=\"round\" stroke-linejoin=\"round\" class=\"feather feather-chevron-down\"><polyline points=\"6 9 12 15 18 9\"></polyline></svg>", import.meta.url);
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
var ___CSS_LOADER_URL_REPLACEMENT_0___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_0___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/* ###------------------CSS BASED ON FIGMA START-------------------### */
* {
    padding: 0;
    margin: 0;
    box-sizing: border-box;
}

body {
    font-family: "Inter", sans-serif;
    margin: 0px;
    background: var(--color-FDFCFA);
}

html {
    scroll-behavior: smooth;
}

html,
body,
div,
span,
applet,
object,
iframe,
h1,
h2,
h3,
h4,
h5,
h6,
p,
blockquote,
pre,
a,
abbr,
acronym,
address,
big,
cite,
code,
del,
dfn,
em,
img,
ins,
kbd,
q,
s,
samp,
small,
strike,
strong,
sub,
sup,
tt,
var,
b,
u,
i,
center,
dl,
dt,
dd,
ol,
ul,
li,
fieldset,
form,
label,
legend,
table,
caption,
tbody,
tfoot,
thead,
tr,
th,
td,
article,
aside,
canvas,
details,
embed,
figure,
figcaption,
footer,
header,
hgroup,
menu,
nav,
output,
ruby,
section,
summary,
time,
mark,
audio,
video {
    margin: 0;
    padding: 0;
    border: 0;
    font-size: 100%;
    font: inherit;
    vertical-align: baseline;
    font-family: var(--fontInter);
}

ol,
ul {
    list-style-type: none;
    padding: 0;
    margin: 0;
}

a {
    text-decoration: none !important;
}

img {
    vertical-align: middle;
}

html,
body {
    overflow-x: clip;
    scrollbar-gutter: stable;
}

:root {

    --fontInter: "Inter", sans-serif;
    --fontSpaceGroTesk: "Space Grotesk", sans-serif;
    --fontJetBrainsMono: "JetBrains Mono", monospace;
    --color-E57600: #E57600;
    --color-E5760014: #E5760014;
    --color-0E1218: #0E1218;
    --color-5F636A: #5F636A;
    --color-FDFCFA: #FDFCFA;
    --color-0069A8: #0069A8;
    --color-007A55: #007A55;
    --color-24A965: #24A965;
    --color-ECAA0B: #ECAA0B;
    --color-a78bfa: #a78bfa;
    --color-D4D2D2: #D4D2D2;
    --color-161616: #161616;
    --color-1A1A1A: #1A1A1A;
    --color-5F6567: #5F6567;
    --color-EFEFEF: #EFEFEF;
    --color-ffffff: #ffffff;
    --color-E7E4E0: #E7E4E0;
    --color-06b6d4: #06b6d4;
    --color-F5F3F0: #F5F3F0;
    --color-E52F0F: #E52F0F;
    --orange-bg: #E5760014;
    --success-bg: #24A9651A;
    --failed-bg: #ef444414;
    --info-bg: #3b82f61a;
    --darkGreen-bg: #007A551A;

}

* {
    scrollbar-width: auto;
    scrollbar-color: var(--color-E57600);
}


/* ## common css ## */
::-webkit-scrollbar {
    width: 5px;
    height: 6px;
    border-radius: 5px;
}

::-webkit-scrollbar-thumb {
    background: var(--color-E57600);
    border-radius: 6px;
}

::-webkit-scrollbar-thumb:hover {
    background: var(--color-E57600) !important;
}

::-webkit-scrollbar-track {
    background: var(--color-ffffff);
}

/* ############## Heading css class Start ##############*/

.h1 {
    font-size: 34px;
    line-height: 41px;
    font-family: var(--fontSpaceGroTesk);
    letter-spacing: -0.85px;
}

.h2 {
    font-size: 30px;
    line-height: 36px;
    font-family: var(--fontSpaceGroTesk);
    letter-spacing: -0.75px;
}

.h3 {
    font-size: 24px;
    line-height: 32px;
    font-family: var(--fontSpaceGroTesk);
    letter-spacing: -0.6px;
}

.h4 {
    font-size: 16px;
    line-height: 24px;
    font-family: var(--fontSpaceGroTesk);
    letter-spacing: -0.38px;
}

.fb__20 {
    font-size: 20px;
    line-height: 30px;
    font-family: var(--fontSpaceGroTesk);
    letter-spacing: -0.6px;
}

.fb__16 {
    font-size: 16px;
    line-height: 20px;
    font-family: var(--fontInter);
    letter-spacing: 0px;
}

.fb__14 {
    font-size: 14px;
    line-height: 18px;
    font-family: var(--fontInter);
    letter-spacing: 0px;
}

.fb__13 {
    font-size: 13px;
    line-height: 20px;
    font-family: var(--fontInter);
    letter-spacing: 0px;
}

.fb__12 {
    font-size: 12px;
    line-height: 16px;
    font-family: var(--fontInter);
    letter-spacing: 0px;
}

.fb__11 {
    font-size: 11px;
    line-height: 16px;
    font-family: var(--fontInter);
    letter-spacing: 0px;
}

.fb__10 {
    font-size: 10px;
    line-height: 16px;
    font-family: var(--fontInter);
    letter-spacing: 0px;
}

p {
    font-family: var(--fontInter);
}

.wrapper__container__1010 {
    max-width: 1040px;
    width: 100%;
    margin-left: auto;
    margin-right: auto;
    padding: 0px 15px;
}

/* ############## Heading css class End ##############*/

/* ############## color css class start ##############*/
.fc__E57600 {
    color: var(--color-E57600);
}

.fc__0E1218 {
    color: var(--color-0E1218);
}

.fc__5F636A {
    color: var(--color-5F636A);
}

.fc__FDFCFA {
    color: var(--color-FDFCFA);
}

.fc__0069A8 {
    color: var(--color-0069A8);
}

.fc__007A55 {
    color: var(--color-007A55);
}

.fc__ECAA0B {
    color: var(--color-ECAA0B);
}

.fc__D4D2D2 {
    color: var(--color-D4D2D2);
}

.fc__161616 {
    color: var(--color-161616);
}

.fc__1A1A1A {
    color: var(--color-1A1A1A);
}

.fc__5F6567 {
    color: var(--color-5F6567);
}

.fc__FFFFFF {
    color: var(--color-ffffff);
}

.fc__EFEFEF {
    color: var(--color-EFEFEF);
}

.fc__06b6d4 {
    color: var(--color-06b6d4);
}

.fc__E52F0F {
    color: var(--color-E52F0F);
}

/* ############## color css class End ##############*/


/* ############## Back ground color css class start ##############*/
.bg__E57600 {
    background-color: var(--color-E57600);
}

.bg__0E1218 {
    background-color: var(--color-0E1218);
}

.bg__5F636A {
    background-color: var(--color-5F636A);
}

.bg__FDFCFA {
    background-color: var(--color-FDFCFA);
}

.bg__0069A8 {
    background-color: var(--color-0069A8);
}

.bg__007A55 {
    background-color: var(--color-007A55);
}

.bg__ECAA0B {
    background-color: var(--color-ECAA0B);
}

.bg__D4D2D2 {
    background-color: var(--color-D4D2D2);
}

.bg__161616 {
    background-color: var(--color-161616);
}

.bg__1A1A1A {
    background-color: var(--color-1A1A1A);
}

.bg__5F6567 {
    background-color: var(--color-5F6567);
}

.bg__FFFFFF {
    background-color: var(--color-ffffff);
}

.bg__EFEFEF {
    background-color: var(--color-EFEFEF);
}

.bg__E5760014 {
    background-color: var(--color-E5760014);
}

.bg__F5F3F0 {
    background-color: var(--color-F5F3F0);
}

/* ############## Back ground color css class End ##############*/

/* ## common fonts weights ## */
.fw__300 {
    font-weight: 300 !important;
}

.fw__400 {
    font-weight: 400 !important;
}

.fw__500 {
    font-weight: 500 !important;
}

.fw__600 {
    font-weight: 600 !important;
}

.fw__700 {
    font-weight: 700 !important;
}

.fw__800 {
    font-weight: 800 !important;
}

/* ## common spacing ## */

/* Margin Common Css Class Start */
.mlr__5 {
    margin-left: 5px;
    margin-right: 5px;
}

.mb__0 {
    margin-bottom: 0;
}

.mb__2 {
    margin-bottom: 2px;
}

.mb__4 {
    margin-bottom: 4px;
}

.mb__6 {
    margin-bottom: 6px;
}

.mb__8 {
    margin-bottom: 8px;
}

.mb__10 {
    margin-bottom: 10px;
}

.mb__12 {
    margin-bottom: 12px;
}

.mb__14 {
    margin-bottom: 14px;
}

.mb__16 {
    margin-bottom: 16px;
}

.mb__17 {
    margin-bottom: 17px;
}

.mb__18 {
    margin-bottom: 18px;
}

.mb__20 {
    margin-bottom: 20px;
}

.mb__21 {
    margin-bottom: 21px;
}

.mb__22 {
    margin-bottom: 22px;
}

.mb__24 {
    margin-bottom: 24px;
}

.mb__25 {
    margin-bottom: 25px
}

.mb__26 {
    margin-bottom: 26px
}

.mb__28 {
    margin-bottom: 28px
}

.mb__30 {
    margin-bottom: 30px;
}

.mb__32 {
    margin-bottom: 32px;
}

.mb__40 {
    margin-bottom: 40px;
}

.mb__44 {
    margin-bottom: 44px;
}

.mb__50 {
    margin-bottom: 50px;
}

.mb__52 {
    margin-bottom: 52px;
}

.mb__60 {
    margin-bottom: 60px;
}

.mb__64 {
    margin-bottom: 64px;
}

.mb__70 {
    margin-bottom: 70px;
}

.mb__80 {
    margin-bottom: 80px;
}

.mb__102 {
    margin-bottom: 102px;
}

.mr__4 {
    margin-right: 4px;
}

.mr__12 {
    margin-right: 12px;
}

.mr__14 {
    margin-right: 14px;
}

.mr__16 {
    margin-right: 16px;
}

.mr__18 {
    margin-right: 18px;
}

.mt__4 {
    margin-top: 4px;
}

.mt__8 {
    margin-top: 8px;
}

.mt__9 {
    margin-top: 9px;
}

.mt__5 {
    margin-top: 5px;
}

.mt__16 {
    margin-top: 16px;
}

.mt__18 {
    margin-top: 18px;
}

.mt__24 {
    margin-top: 24px;
}

.mt__38 {
    margin-top: 38px;
}

.mt__40 {
    margin-top: 40px;
}

.mt__44 {
    margin-top: 44px;
}

.ml__12 {
    margin-left: 12px;
}

.ml__18 {
    margin-left: 18px;
}

.text__center {
    text-align: center;
}

.transform__none {
    text-transform: none !important;
}

/* Padding Common Css Class End */
.in-flex {
    display: inline-flex !important;
}

.d-flex {
    display: flex !important;
}

.flex-column {
    flex-direction: column !important;
}

.flex-wrap {
    flex-wrap: wrap !important;
}

.align-items-center {
    align-items: center !important;
}

.justify-content-between {
    justify-content: space-between !important;
}

.justify-content-center {
    justify-content: center !important;
}

.flex-start {
    justify-content: flex-start !important;
}

.flex-end {
    justify-content: flex-end !important;
}

.flex-srink-0 {
    flex-shrink: 0;
}

.img-fluid {
    max-width: 100%;
    height: auto;
}

.mx__auto {
    margin: 0 auto;
}

.mw__672 {
    max-width: 672px;
    width: 100%;
    margin-left: auto;
    margin-right: auto;
}

.mw__230 {
    max-width: 230px;
}

.common__btn {
    height: 32px;
    border-radius: 12px;
    display: inline-flex;
    align-items: center;
    justify-content: center;
    padding: 8px 16px;
    font-size: 14px;
    line-height: 24px;
    font-family: var(--fontInter);
    font-weight: 600;
    color: var(--color-ffffff);
    transition: all 0.3s ease;
    cursor: pointer;
    outline: none;
    overflow: hidden;
    white-space: nowrap;
    position: relative;
    border: none;
    z-index: 1;
}

.common__org__btn {
    background: var(--color-E57600);
    color: var(--color-ffffff);
    border: 1px solid var(--color-E57600);
    box-shadow: 0px 6px 20px -6px #E5760080;
}

.common__org__btn:hover {
    background: transparent;
    color: var(--color-E57600);
}

.common__blk__btn {
    background: var(--color-0E1218);
    color: var(--color-ffffff);
    border: 1px solid var(--color-0E1218);
}

.common__blk__btn:hover {
    background: transparent;
    color: var(--color-0E1218);
}


.common__transp__btn {
    background: transparent;
    color: var(--color-0E1218);
    border: 1px solid var(--color-E7E4E0);
}

.common__transp__btn:hover {
    background: var(--color-0E1218);
    color: var(--color-ffffff);
    border: 1px solid var(--color-0E1218);
}

.close__btn {
    background: transparent;
    border: none !important;
    padding: 0px;
    color: var(--color-0E1218);
    width: 20px;
    height: 20px;
}

.ntf__button__area .close__btn img,
.close__btn img {
    width: 12px;
    height: 12px;
    cursor: pointer;
}

.custom__row {
    display: flex;
    flex-wrap: wrap;
}

.mw__900 {
    max-width: 900px;
    margin-left: auto;
    margin-right: auto;
}

.pos__rel {
    position: relative;
}

.w__100 {
    width: 100%;
}

.d__none {
    display: none;
}

.d__block {
    display: block;
}

.text__right {
    text-align: right;
}

.gap__4 {
    gap: 4px;
}

.gap__5 {
    gap: 5px;
}

.gap__8 {
    gap: 8px;
}

.gap__12 {
    gap: 12px;
}

.gap__16 {
    gap: 16px;
}

.gap__20 {
    gap: 20px;
}

code {
    font-family: var(--fontJetBrainsMono);
}

.ff__inter {
    font-family: var(--fontInter);
}

.ff__spaceGrotesk {
    font-family: var(--fontSpaceGroTesk);
}

.ff__jetBrainsMono {
    font-family: var(--fontJetBrainsMono);
}

.pos__rel {
    position: relative;
}

body::before,
body::after {
    opacity: 0 !important;
    visibility: hidden;
}

/* ## Login/Register Page ## */
.login__footer {
    position: absolute;
    bottom: 0px;
    left: 0px;
    right: 0px;
    padding: 16px 24px;
    display: flex;
    align-items: center;
    justify-content: center;
    gap: 6px;
    flex-wrap: wrap;
    font-size: 11px;
    color: var(--color-FDFCFA);
    border-top: 1px solid var(--border);
    background: rgba(8, 17, 31, 0.6);
    backdrop-filter: blur(12px);
}

.login__footer a:hover {
    color: var(--color-E57600) !important;
}

.login__form input {
    border: 1px solid rgba(6, 182, 212, 0.2);
}

.betaTag {
    position: absolute;
    top: -6px;
    right: -34px;
    background: linear-gradient(135deg, rgb(6, 182, 212), rgb(139, 92, 246));
    color: rgb(255, 255, 255);
    font-size: 9px;
    font-weight: 700;
    letter-spacing: 0.08em;
    padding: 2px 6px;
    border-radius: 4px;
    text-transform: uppercase;
    line-height: 1;
}

.login__logo__col {
    max-width: 170px;
    margin-left: auto;
    margin-right: auto;
}

.sidebar__brand {
    outline: none;
    display: inline-flex;
    align-items: center;
    padding-left: 8px;
}

.wrapper__root__page {
    min-height: 100vh;
    display: flex;
    align-items: center;
    justify-content: center;
    position: relative;
    overflow: hidden;
    padding-bottom: 56px;
    background-repeat: no-repeat;
    width: 100%;
    background-size: cover;
}

.wrapper__login__card {
    position: relative;
    border-radius: 24px;
    overflow: hidden;
    border: 0px;
}

.wrapper__login__card::before {
    display: none;
}

.wrapper__login__card::after {
    content: "";
    position: absolute;
    inset: 0;

    border-radius: 24px;

    background: linear-gradient(270deg,
            #06B2D0 0%,
            #E57600 37.98%,
            #E57600 63.46%,
            #00F0FF 94.71%);

    padding: 2px;

    /* Keep only the border area */
    -webkit-mask:
        linear-gradient(#fff 0 0) content-box,
        linear-gradient(#fff 0 0);
    -webkit-mask-composite: xor;

    mask:
        linear-gradient(#fff 0 0) content-box,
        linear-gradient(#fff 0 0);
    mask-composite: exclude;

    /* Show only top + rounded corners */
    clip-path: inset(0 0 calc(100% - 26px) 0);
}

.wrapper__login__card .common__btn {
    height: 45px;
}

.wrapper__app__main {
    display: flex;
    min-height: 100vh;
    position: relative;
}

aside.app-sidebar {
    position: fixed;
    height: 100%;
    left: 0;
    top: 0;
    z-index: 99;
    max-width: 257px;
    width: 100%;
    border-right: 1px solid #E7E4E0;
    background: var(--color-ffffff);
}

aside.app-sidebar.app-sidebar--collapsed {
    max-width: 78px;
}
aside.app-sidebar.app-sidebar--collapsed nav.sidebar-nav {
    padding-top: 40px;
}
.wrapper__app__side__left {
    height: 100%;
    display: flex;
    flex-direction: column;
    justify-content: space-between;
}

main.app-main {
    max-width: calc(100% - 257px);
    width: 100%;
    margin-left: 257px;
}

.wrapper__side__navigation {
    padding: 16px 8px 0px;

}

.sidebar-footer {
    border-top: 1px solid #E7E4E0;
    padding: 12px;

}

.site__footer {
    border: 0px;
    background: #E5760014;
    padding: 18px 0;
    width: 100%;
    /* position: absolute;
    right: 0;
    z-index: 99;
    left: 0; */
}

.site__footer__inner {
    max-width: 1280px;
    margin: 0 auto;
    padding: 0 28px;
    display: flex;
    align-items: center;
    justify-content: center;
    gap: 16px;
    flex-wrap: wrap;
}

.site__footer__inner>* {
    color: #5F636A !important;
    opacity: unset !important;
}

.site-footer-link:hover {
    color: var(--color-E57600) !important;
}

nav.sidebar-nav {
    display: flex;
    flex-direction: column;
    align-items: flex-start;
}

nav.sidebar-nav .sidebar-nav-item {
    width: 100%;
    text-align: left;
    border: none;
    background: transparent;
    display: flex;
    align-items: center;
    padding: 10px 12px;
    border-radius: 12px;
    transition: all 0.3s ease;
    cursor: pointer;
    gap: 12px;
    outline: none;
    font-size: 16px;
    font-weight: 500;
    font-family: var(--fontInter);
    color: var(--color-5F636A);
}

nav.sidebar-nav .sidebar-nav-item .nav__title {
    transition: all 0.3s ease;
}

.sidebar-nav-item .total__agents {
    background: #F5F3F0;
    border-radius: 4px;
    display: inline-flex;
    align-items: center;
    justify-content: center;
    padding: 6px;
    font-size: 14px;
    font-weight: 700;
    color: #5F636A;
    font-family: var(--fontJetBrainsMono);
    margin-left: auto;
}

.wrapper__sidenav__item a img {
    width: 20px;
    height: 20px;
}

.wrapper__sidenav__item a.active,
.wrapper__sidenav__item a:hover {
    background: #E5760014;
}

.wrapper__sidenav__item a.active svg {
    filter: brightness(0) saturate(100%) invert(44%) sepia(61%) saturate(2190%) hue-rotate(10deg) brightness(99%) contrast(102%);
}

.wrapper__sidenav__item a.active .nav__title,
.wrapper__sidenav__item a:hover .nav__title {
    color: var(--color-E57600);
}

.wrapper__sidenav__item a.active img,
.wrapper__sidenav__item a:hover img {
    filter: brightness(0) saturate(100%) invert(46%) sepia(89%) saturate(2430%) hue-rotate(10deg) brightness(99%) contrast(101%);
}

.sidebar-nav-item.active .total__agents {
    background: transparent;
}

.wrapper__common__header {
    padding: 12px 32px;
    border-bottom: 1px solid #E7E4E0;
    position: sticky;
    top: 0;
    background: #fff;
    z-index: 3;
    display: flex;
    align-items: center;
    width: 100%;
    gap: 15px;
    justify-content: space-between;
}

.wrapper__right {
    display: flex;
    align-items: center;
    gap: 8px;
}

.wrapper__notify__btn {
    background: transparent;
    outline: none;
    border: 0px;
    cursor: pointer;
}

.workSpace {
    text-transform: uppercase;
    font-size: 14px;
    font-weight: 600;
    line-height: 24px;
    letter-spacing: 1.2px;
    font-family: var(--fontInter);
    color: #5F636AB2;
    padding: 16px 0px 8px;
    padding-left: 12px;
}

/* .wrapper__app__main__content {
    height: 100%;
} */

section.wrapper__os__mainScreen {
    padding: 32px 0px;
    height: 100%;
    display: flex;
    flex-direction: column;
    align-items: center;
    justify-content: center;
}

.wrapper__search__input {
    background: radial-gradient(50% 50% at 50% 50%, rgba(229, 118, 0, 0.18) 0%, rgba(229, 118, 0, 0) 70%);
    padding: 10px 0px 64px;
    position: relative;
}

.wrapper__search__input input {
    width: 100%;
    height: 53px;
    outline: none;
    box-shadow: 0px 24px 60px -30px #00000040;
    border: 1px solid #E7E4E0;
    border-radius: 20px;
    padding: 10px 12px;
    font-size: 16px;
    font-weight: 400;
    color: var(--color-0E1218);
    font-family: var(--fontInter);
    padding-left: 50px;
}

.wrapper__search__input button.btn-pick-assistant {
    position: absolute;
    left: 12px;
    top: 21px;
    background: transparent;
    border: none;
    outline: none;
    display: flex;
    align-items: center;
    cursor: pointer;
}

.breadcrumb__list {
    display: flex;
    align-items: center;
}

.breadcrumb__list li.breadcrumb-item a {
    font-size: 12px;
    font-weight: 400;
    line-height: 22px;
    color: var(--color-5F636A);
    font-family: var(--fontInter);
}

.breadcrumb__list .breadcrumb-sep {
    display: inline-block;
    margin: 0px 6px;
    color: #E7E4E0;
}

.breadcrumb-item .breadcrumb-current {
    font-size: 13px;
    font-weight: 500;
    line-height: 20px;
    color: var(--color-0E1218);
    font-family: var(--fontInter);
}

.userDropdown__btn {
    display: inline-flex;
    align-items: center;
    gap: 12px;
    border: none;
    background: transparent;
    cursor: pointer;
}

.username__initial {
    background: #E576001A;
    color: var(--color-E57600);
    padding: 8px;
    text-transform: uppercase;
    font-size: 14px;
    font-weight: 600;
    font-family: var(--fontInter);
    line-height: 22px;
    display: inline-flex;
    align-items: center;
    justify-content: center;
    width: 32px;
    height: 32px;
    border-radius: 50%;
}

.grayDot {
    background: var(--color-5F636A);
    width: 5px;
    height: 5px;
    display: inline-block;
    border-radius: 50%;
    margin: 0px 5px;
}

.wrapper__dropdown__menu {
    position: absolute;
    left: 0;
    top: calc(100% + 6px);
    width: 220px;
    border-radius: 12px;
    box-shadow: 0 8px 32px rgba(0, 0, 0, 0.5);
    z-index: 1000;
    overflow: hidden;
    visibility: hidden;
    background: var(--color-ffffff);
}

.userInitial {
    width: 36px;
    height: 36px;
    border-radius: 50%;
    background: var(--gradient-btn);
    display: flex;
    align-items: center;
    justify-content: center;
    font-size: 15px;
    font-weight: 700;
    color: white;
    flex-shrink: 0;
}

.fc__ellipse {
    overflow: hidden;
    text-overflow: ellipsis;
    white-space: nowrap;
}

.userRole {
    margin-top: 8px;
}

.subAdmin {
    font-size: 10px;
    font-weight: 700;
    padding: 2px 8px;
    border-radius: 5px;
    background: rgba(167, 139, 250, 0.12);
    border: 1px solid rgba(167, 139, 250, 0.3);
    color: rgb(167, 139, 250);
    text-transform: uppercase;
    letter-spacing: 0.06em;
}

.role__badge {
    border: 1px solid var(--color-5F636A);
    background-color: var(--color-F5F3F0);
    color: var(--color-5F636A);
    font-size: 12px;
    font-weight: 400;
    padding: 2px 8px;
    border-radius: 5px;
    text-transform: uppercase;
    letter-spacing: 0.06em;
    font-family: var(--fontJetBrainsMono);
}

.role__badge__admin {
    color: var(--color-ECAA0B);
    background: rgba(245, 158, 11, 0.12);
    border-color: rgba(245, 158, 11, 0.3);
}

.role__badge__subadmin {
    color: var(--color-a78bfa);
    background: rgba(167, 139, 250, 0.12);
    border-color: rgba(167, 139, 250, 0.3);
}

.userRole span {
    font-size: 10px;
    font-weight: 700;
    padding: 2px 8px;
    border-radius: 5px;
    text-transform: uppercase;
    letter-spacing: 0.06em;
}

.dropdown__listing .dropdown__btn {
    display: flex;
    align-items: center;
    gap: 10px;
    width: 100%;
    padding: 10px 16px;
    border-radius: 0px;
    border: none;
    background: transparent;
    color: var(--color-0E1218);
    transition: background 0.1s ease, color 0.1s ease;
    font-size: 13px;
    font-weight: 500;
    cursor: pointer;
    text-align: left;
    text-decoration: none;
}

.dropdown__listing .dropdown__btn--active,
.dropdown__listing .dropdown__btn:hover {
    background: #06b6d4;
    color: #fff;
}

/* ## agent library ##*/
.wrapper__main {
    padding: 32px;
}

.wrapper__agents__row {
    row-gap: 12px;
    margin-left: -6px;
    margin-right: -6px;
}

.wrapper__agents__col {
    max-width: calc(100% / 4);
    width: 100%;
    padding: 0px 6px;
}

.wrapper__agent__card {
    border: 1px solid #E7E4E0;
    border-radius: 16px;
    padding: 21px;
    background: var(--color-ffffff);
    height: 100%;
    transition: all 0.3s ease;
}

.wrapper__agent__card:hover {
    /* box-shadow: var(--shadow-md), 0 0 28px rgba(6, 182, 212, 0.1); */
    transform: translateY(-3px);
}

.col__gap__6 {
    column-gap: 6px;
}

.wrapper__ag__filter {
    border: 1px solid #E7E4E0;
    padding: 5px 11px;
    border-radius: 100px;
    background: transparent;
    display: inline-flex;
    align-items: center;
    justify-content: center;
    font-size: 13px;
    font-weight: 500;
    line-height: 20px;
    column-gap: 4px;
    color: var(--color-5F636A);
    font-family: var(--fontInter);
    transition: all 0.3s ease;
    cursor: pointer;
}

.wrapper__ag__filter .filter__value {
    font-size: 12px;
    font-weight: 500;
    color: var(--color-5F636A);
    font-family: var(--fontJetBrainsMono);
    transition: all 0.3s ease;
    opacity: 70%;
}

.wrapper__ag__filter.active {
    background: var(--color-0E1218);
    color: var(--color-ffffff);
    border-color: var(--color-0E1218);
}

.wrapper__ag__filter.active .filter__value {
    color: #FDFCFA;
}

.project__run__btn {
    display: inline-flex;
    align-items: center;
    gap: 6px;
    padding: 6px 12px;
    border-radius: 8px;
    cursor: pointer;
    font-size: 12px;
    font-weight: 600;
    white-space: nowrap;
    transition: 0.15s;
    border: 1px solid var(--border);
    background: rgba(255, 255, 255, 0.04);
    color: var(--text-muted);
}

.project__run__btn.selected {
    border: 1px solid rgba(6, 182, 212, 0.4);
    background: rgba(6, 182, 212, 0.08);
    color: #06b6d4;
}

.project__run__btn.active {}

.project__run__btn__dropdown {
    position: absolute;
    top: calc(100% + 6px);
    left: 0px;
    min-width: 210px;
    background: var(--color-ffffff);
    backdrop-filter: blur(20px);
    border: 1px solid var(--border);
    border-radius: 10px;
    box-shadow: rgba(0, 0, 0, 0.5) 0px 8px 32px;
    z-index: 100;
    overflow: hidden;
}

.wrapper__projects__total {
    padding: 6px 4px;
    border-bottom: 1px solid var(--border);
    max-height: 220px;
    overflow-y: auto;
}

.wrapper__ProjectLimit {
    padding: 9px 12px;
    border-top: 1px solid #5f636a33;
}

.runProject {
    width: 100%;
    text-align: left;
    padding: 7px 12px;
    background: transparent;
    border-width: medium;
    border-style: none;
    border-color: currentcolor;
    border-image: none;
    border-radius: 6px;
    cursor: pointer;
    font-size: 12px;
    font-weight: 500;
    color: var(--color-5F636A);
    display: flex;
    align-items: center;
    gap: 8px;
    transition: background 0.1s ease, color 0.1s ease;
}

.runProject:last-child {
    margin-top: 10px;
}

.runProject:hover,
.runProject.active {
    background: #06b6d4;
    color: var(--color-ffffff);
}

.runProject:hover .p__name,
.runProject.active .p__name,
.runProject:hover .p__domain__comp,
.runProject.active .p__domain__comp {
    color: var(--color-ffffff);
}

.runProject:hover .dots::before,
.runProject.active .dots::before {
    background: var(--color-ffffff);
}


.wrapper__inner {
    flex: 1 1;
    min-width: 0px;
    overflow: hidden;
}

.p__name {
    display: block;
    overflow: hidden;
    text-overflow: ellipsis;
    white-space: nowrap;
}

.p__domain__comp {
    display: block;
    margin-top: 1px;
    overflow: hidden;
    text-overflow: ellipsis;
    white-space: nowrap;
}




.wrapper__ag__cardCat .wrapper__category {
    background: #E576001A;
    font-size: 12px;
    font-weight: 700;
    padding: 2px 6px;
    color: var(--color-E57600);
    font-family: var(--fontInter);
    text-transform: uppercase;
    border-radius: 4px;
    box-shadow: 0px 0px 0px 1px #E5760026;
    opacity: 50%;

}

.wrapper__ag__cardCat .wrapper__category.flt__selected {
    opacity: 100%;
    /* color: var(--color-0069A8);
    background: #F0F9FF;
    box-shadow: 0px 0px 0px 1px #B8E6FE99; */
}

.agent__beta {
    font-size: 9px;
    font-weight: 800;
    letter-spacing: 0.1em;
    text-transform: uppercase;
    color: #f59e0b;
    padding: 2px 7px;
    background: rgba(245, 158, 11, 0.1);
    border: 1px solid rgba(245, 158, 11, 0.3);
    border-radius: 5px;
    white-space: nowrap;
}

.wrapper__ag__footer {
    padding-top: 12px;
    border-top: 1px solid #EDEBE7;
    margin-top: 20px;
}

.wrapper__agent__card .agent__desc {
    -webkit-line-clamp: 2;
    overflow: hidden;
    display: -webkit-box;
    -webkit-box-orient: vertical;
}
.wrapper__agent__card .agent__name {
    -webkit-line-clamp: 1;
    overflow: hidden;
    display: -webkit-box;
    -webkit-box-orient: vertical;
    margin-bottom: 6px;
}

.agent__launch__btn {
    border: none;
    text-transform: capitalize;
    background: transparent;
    display: inline-flex;
    align-items: center;
    justify-content: center;
    gap: 4px;
    cursor: pointer;
}

.btn__arrow {
    /* width: 14px;
    height: 14px; */
}

.badge__category {
    gap: 6px;
}

.badge__icon {
    width: 12px;
    /* height: 12px; */
}

.agent__icon__wrap {
    box-shadow: 0px 0px 0px 1px #E7E4E0;
    background: #FFFFFF01;
    border-radius: 12px;
    width: 40px;
    height: 40px;
    display: inline-flex;
    align-items: center;
    justify-content: center;
    transition: all 0.25s ease;
    border: 1px solid #F5F3F0;

}

.wrapper__ag__cardCat {
    display: flex;
    align-items: center;
    gap: 10px;
}

.wrapper__execution__history__inner {
    /* background: #000; */
}

.input__filter input {
    border: 1px solid #E7E4E0;
    height: 46px;
    border-radius: 12px;
    min-width: 256px;
    width: 100%;
    padding: 9px;
    padding-left: 36px;
    outline: none;
}

.input__filter input::-webkit-input-placeholder {
    font-size: 12px;
    font-weight: 700;
    line-height: 16px;
    color: var(--color-5F636A);
    font-family: var(--fontInter);
}

.input__filter,
.wrapper___status__filter {
    position: relative;
}

.input__filter .serachIcon,
.status__filter__btn .statusIcon {
    position: absolute;
    left: 12px;
    top: 14px;
}

.wrapper__history__filter {
    gap: 8px;
}

.status__filter__btn {
    border: 1px solid #E7E4E0;
    padding: 12px;
    padding-left: 36px;
    background: transparent;
    border-radius: 12px;
    outline: none;
    cursor: pointer;
}

.status__filter__btn .statusIcon {
    top: 15px;
}

.projectDropdown__btn {
    display: inline-flex;
    align-items: center;
    gap: 6px;
    padding: 6px 12px;
    border-radius: 8px;
    border: 1px solid rgba(6, 182, 212, 0.4);
    background: rgba(6, 182, 212, 0.08);
    color: var(--teal-bright);
    cursor: pointer;
    font-size: 12px;
    font-weight: 600;
    white-space: nowrap;
    transition: 0.15s;
}

.recent__label {
    display: inline-flex;
    align-items: center;
    gap: 4px;
    color: var(--color-06b6d4);
    padding: 2px 8px;
    border-radius: 4px;
    background: rgba(6, 182, 212, 0.08);
    border: 1px solid rgba(6, 182, 212, 0.2);
}

.recent__left {
    gap: 5px;
}

.wrapper__project___dropdown,
.wrapper__s__Filter___dropdown {
    position: absolute;
    top: calc(100% + 6px);
    right: 0px;
    min-width: 180px;
    background: #fff;
    backdrop-filter: blur(20px);
    border: none;
    border-radius: 10px;
    box-shadow: 0 8px 32px rgba(0, 0, 0, 0.5);
    z-index: 100;
    overflow: hidden;
    padding: 6px 4px;
}

.p__dropdwn__btn,
.wrapper__s__Filter___dropdown ul li {
    width: 100%;
    text-align: left;
    padding: 10px 12px;
    border-radius: 6px;
    cursor: pointer;
    font-size: 12px;
    font-weight: 500;
    display: flex;
    align-items: center;
    gap: 8px;
    border: none;
    background: transparent;
    color: var(--color-0E1218);
    transition: all 0.3s ease;
}

button.p__dropdwn__btn.active,
.p__dropdwn__btn:hover,
.wrapper__s__Filter___dropdown ul li:hover,
.wrapper__s__Filter___dropdown ul li.s__Filter__active {
    background: rgba(6, 182, 212, 0.08);
    color: var(--color-06b6d4);
}

.p__dropdwn__btn:not(:last-child),
.wrapper__s__Filter___dropdown ul li:not(:last-child) {
    margin-bottom: 8px;
}

.wrapper__backlight__10__600 {
    display: inline-flex;
    align-items: center;
    gap: 3px;
    font-size: 10px;
    font-weight: 600;
    color: var(--color-06b6d4);
    padding: 2px 7px;
    border-radius: 4px;
    background: rgba(6, 182, 212, 0.08);
    border: 1px solid rgba(6, 182, 212, 0.2);
    white-space: nowrap;
}

.wrapper__execution__history table {
    margin-top: 0px;
    border-collapse: separate;
    border-spacing: 0;
    border-radius: 12px;
    border: 1px solid #E7E4E0;
}

/* .wrapper__execution__history table th:not(:last-child){
    border-right: 1px solid #E7E4E0;
} */
.wrapper__execution__history table thead tr th,
.wrapper__execution__history table tbody tr td {
    border-bottom: 1px solid #E7E4E0;
    background: #fff;
}


.wrapper__execution__history table thead tr th:first-child {
    border-top-left-radius: 12px;
}

.wrapper__execution__history table thead tr th:last-child {
    border-top-right-radius: 12px;
}

.wrapper__execution__history table thead tr th {
    background: #F5F3F066;
    font-size: 12px;
    font-weight: 600;
    line-height: 16px;
    text-transform: uppercase;
    color: var(--color-5F636A);
    padding: 12px 20px;
    vertical-align: middle;
    letter-spacing: 0px;
}

.wrapper__execution__history table tbody tr td {
    padding: 16px;
    font-size: 14px;
    font-weight: 700;
    line-height: 18px;
}

.wrapper__execution__history table tbody tr:last-child td {
    border-bottom: 0px;
}

.wrapper__execution__history table tbody tr:last-child td:first-child {
    border-bottom-left-radius: 12px;
}

.wrapper__execution__history table tbody tr:last-child td:last-child {
    border-bottom-right-radius: 12px;
}

.history__btn {
    padding: 6px 12px;
    font-size: 12px;
    font-weight: 400;
    line-height: 20px;
    border-radius: 6px;
    display: inline-flex;
    align-items: center;
    justify-content: center;
    cursor: pointer;
    transition: all 0.2s cubic-bezier(0.4, 0, 0.2, 1);
    text-decoration: none;
    font-family: var(--fontInter);
    border: none;
}

.history__btn.open {
    background: var(--orange-bg);
    color: var(--color-E57600);
}

.history__btn.view {
    background: rgba(59, 130, 246, 0.1);
    color: var(--color-06b6d4);
}

.history__btn.delete {
    background: rgba(239, 68, 68, 0.08);
    color: rgb(248, 113, 113);
}

.wrapper__agent__td {
    flex-direction: column;
    align-items: flex-start !important;
    justify-content: center;
    row-gap: 4px;
}

.py__5 {
    padding: 5px;
}

.py__80__20 {
    padding: 80px 20px;
}

.br__4 {
    border-radius: 4px;
}

.status__badge {
    display: inline-flex;
    align-items: center;
    padding: 2px 8px;
    border-radius: 100px;
    font-size: 12px;
    line-height: 16px;
    font-weight: 700;
    letter-spacing: 0px;
    text-transform: uppercase;
    font-family: var(--fontJetBrainsMono);
    position: relative;
}

.badgeDot {
    width: 6px;
    height: 6px;
    border-radius: 50%;
    display: inline-block;
    margin-right: 4px;
}

.badge__success {
    background: #24A9651A;
    color: var(--color-24A965);
    box-shadow: 0px 0px 0px 1px #24A96533;
}

.badge__success.badgeDot {
    background: var(--color-24A965);
}

.badge__danger {
    color: #E52F0F;
    background: #E52F0F1A;
    box-shadow: 0px 0px 0px 1px #E52F0F33;
}

.badge__danger.badgeDot {
    background: #E52F0F;
}

.badg__info {
    color: #3C8DFF;
    background: #3C8DFF1A;
    box-shadow: 0px 0px 0px 1px #3C8DFF33;
}

.badg__info.badgeDot {
    background: #3C8DFF;
}

.badge__warning {
    color: #FF8C25;
    background: #FF8C251A;
    box-shadow: 0px 0px 0px 1px #FF8C2533;

}

.badge__warning.badgeDot {
    background: #FF8C25;
}

.wrapper__execution__history .table-responsive {
    padding-right: 6px;
    max-height: 700px;
    overflow-y: auto;
}

.empty__state__title {
    font-size: 18px;
    font-weight: 600;
    color: #000;
}

.empty__state__desc {
    font-size: 14px;
    color: var(--color-5F636A);
    max-width: 320px;
}

.empty__state {
    padding: 56px 24px;
    display: flex;
    flex-direction: column;
    align-items: center;
    gap: 10px;
    text-align: center;
    box-shadow: 0 1px 2px rgba(14, 18, 24, 0.04), 0 8px 20px -14px rgba(14, 18, 24, 0.18);
    border-radius: 12px;
    background: var(--color-ffffff);
    border: 1px solid #E7E4E0;
}

.wrapper__project__left {
    max-width: 264px;
    width: 100%;
    padding-right: 24px;
}

.wrapper__project__right {
    max-width: calc(100% - 264px);
    width: 100%;
}

.wrapper__project__listing {
    border: 1px solid #E7E4E0;
    height: 100%;
    border-radius: 16px;
    padding: 12px;
}

.ls__1__2 {
    letter-spacing: 1.2px;
}

.wraper__noProject {
    text-align: center;
    padding: 16px 0px;
}

.project__btn {
    background: transparent;
    display: flex;
    flex-direction: column;
    align-items: flex-start;
    border-radius: 12px;
    padding: 8px;
    gap: 3px;
    width: 100%;
    border: 1px solid #E7E4E0;
    outline: none;
    text-align: left;
    cursor: pointer;
}

.project__btn.selected {
    font-weight: 600;
    color: var(--color-E57600);
    background: #E576000D;
}

.project__name {
    font-size: 13px;
    line-height: 20px;
    font-family: var(--fontInter);
    letter-spacing: 0px;
    color: var(--color-1A1A1A);
}

.project__name.active,
.project__btn.selected .domian {
    color: var(--color-E57600);
}

.wrapper__buttons {
    display: flex;
    flex-direction: column;
    gap: 10px;
    margin-bottom: 20px;
    max-height: 300px;
    overflow-y: auto;
}

.project__quota.active {
    padding-top: 10px;
    border-top: 1px solid #E7E4E0;
}

.wrapper__createProject {
    background: #E576000D;
    display: flex;
    align-items: center;
    width: 100%;
    outline: none;
    text-align: left;
    cursor: pointer;
    border-radius: 12px;
    padding: 12px 10px;
    font-size: 13px;
    line-height: 20px;
    font-family: var(--fontInter);
    letter-spacing: 0px;
    color: var(--color-E57600);
    font-weight: 500;
    border: var(--color-E57600);
}

.wrapper__createProject.active {
    background: var(--color-E57600);
    color: var(--color-ffffff);
}

.wrapper__project__details {
    border: 1px solid #E7E4E0;
    padding: 24px;
    background: var(--color-ffffff);
    border-radius: 16px;
}

.gap__8 {
    column-gap: 8px;
}

.uppercase {
    text-transform: uppercase;
}

.captalize {
    text-transform: capitalize;
}

.form__label {
    font-size: 12px;
    line-height: 16px;
    font-weight: 700;
    font-family: var(--fontInter);
    letter-spacing: 0px;
    color: var(--color-5F636A);
    text-transform: uppercase;
    margin-bottom: 6px;
    display: block;
}

.fb__hint {
    font-size: 12px;
    color: var(--color-5F636A);
    line-height: 1.6;
    margin: 0px 0px 8px;
}

.form__input {
    padding: 10px 12px;
    background: var(--color-FDFCFA);
    width: 100%;
    border-radius: 12px;
    border: 1px solid #E7E4E0;
    outline: none;
    font-size: 14px;
    line-height: 18px;
    font-family: var(--fontInter);
    letter-spacing: 0px;
    color: var(--color-0E1218)
}

.form__input::placeholder {
    color: #0E121880;
    font-size: 12px;
}

.form__input.error {
    border-color: rgba(239, 68, 68, 0.5);
}

.form__input.dimmed {
    opacity: 0.55;
}

textarea.form__input {
    height: 116px;
    resize: vertical;
}

.form__input.read-only {
    opacity: 0.5;
    cursor: default;
}

.form__input:focus {
    border-color: var(--color-5F636A);
}

.wrapper__fb__content textarea.form__input {
    min-height: 92px;
    padding-right: 54px;
}

.code {
    font-family: var(--fontJetBrainsMono);
    background-color: var(--color-F5F3F0);
    padding: 5px;
    border-radius: 4px;
}

.code__input,
.code__input::placeholder {
    font-family: var(--fontJetBrainsMono);
    /* color: #0E121880; */
    font-size: 12px;
}

.locked__input {
    display: flex;
    justify-content: space-between;
    align-items: center;
    gap: 10px;
    cursor: not-allowed;
}

.wrapper__locked {
    display: inline-flex;
    align-items: center;
    gap: 4px;
    letter-spacing: 0.06px;
    color: var(--color-5F6567);
}

.txt__ellipsis {
    overflow: hidden;
    text-overflow: ellipsis;
    white-space: nowrap;
}

.successConfigure {
    padding: 3px 6px;
    border-radius: 4px;
    background: var(--success-bg);
    margin-top: 5px;
    display: inline-flex;
    align-items: center;
    gap: 4px;
    color: var(--color-007A55);
    font-size: 11px;
}

.successMsg {
    padding: 10px 14px;
    border-radius: 8px;
    background: var(--success-bg);
    border: 1px solid var(--success-bg);
    color: var(--color-007A55);
}

.validateError {
    font-size: 12px;
    color: var(--color-E52F0F);
    font-family: var(--fontInter);
    line-height: 18px;
    margin-top: 5px;
}

.wrapper__competitors {
    display: flex;
    flex-direction: column;
    gap: 10px;
}

.wrapper__back__link {
    display: inline-flex;
    align-items: center;
    gap: 4px;
    cursor: pointer;
    text-transform: capitalize;
    border: none;
    background: transparent;
    outline: none;
}

.profile__details .username__initial {
    width: 56px;
    height: 56px;
    font-size: 16px;
}

.wrapper__profile__card {
    padding: 24px;
    border: 1px solid #E7E4E0;
    border-radius: 16px;
    background: var(--color-ffffff);
}

.display__name {
    text-transform: capitalize;
}

/* ## feedback model## */
.wrapper__feedback__model {
    position: fixed;
    inset: 0px;
    background: rgba(0, 0, 0, 0.65);
    backdrop-filter: blur(6px);
    z-index: 9000;
    display: flex;
    align-items: center;
    justify-content: center;
    padding: 16px;
}

.feedback__model__inner {
    background: var(--color-ffffff);
    border: 1px solid var(--border);
    border-radius: 16px;
    width: 100%;
    max-width: 460px;
    max-height: 90vh;
    overflow: auto;
    box-shadow: rgba(0, 0, 0, 0.6) 0px 24px 64px;
}

.wrapper__fb__head {
    padding: 20px 24px 16px;
    border-bottom: 1px solid var(--border);
    display: flex;
    align-items: flex-start;
    justify-content: space-between;
    gap: 12px;
}

.wrapper__fb__content {
    padding: 20px 24px;
}

.fb__send {
    position: absolute;
    right: 10px;
    bottom: 10px;
    width: 32px;
    height: 32px;
    border-radius: 10px;
    cursor: default;
    background: transparent;
    color: var(--color-5F636A);
    border: 1px solid var(--color-5F636A);
    display: inline-flex;
    align-items: center;
    justify-content: center;
    box-shadow: none;
    transition: background 0.15s, box-shadow 0.15s;
}

.fb__send.sendBtnActive {
    background: var(--color-E57600);
    color: var(--color-ffffff);
    border-color: var(--color-E57600);
    box-shadow: 0px 6px 20px -6px #E5760080;
    cursor: pointer;
}

.fb__star__rating {
    background: none;
    color: var(--color-0E1218);
    transform: scale(1);
    transition: all 0.2s ease;
    border: none;
    cursor: pointer;
    font-size: 26px;
    line-height: 36px;
    padding: 2px;
}

.fb__star__rating.active {
    color: var(--color-007A55);
    transform: scale(1.2);
}

/* ## Agent Execution Page ## */
.wrapper__back__btn {
    background: transparent;
    border: none;
    outline: none;
    column-gap: 6px;
    cursor: pointer;
}

.wrapper__agents__nameTags {
    max-width: 683px;
    width: 100%;
}

.agentCat {
    background: #F5F3F0;
    padding: 2px 6px;
    border-radius: 4px;
    font-family: var(--fontJetBrainsMono);
    text-transform: uppercase;
    color: var(--color-5F636A);
}

.agentInitials {
    width: auto;
    min-width: 56px;
    height: 56px;
    font-size: 16px;
    border-radius: 16px;
    font-weight: 700;
    line-height: 26px;
}

.agentTag {
    padding: 2px 10px;
    border: 1px solid #E7E4E0;
    border-radius: 50px;
    display: inline-flex;
    align-items: center;
    justify-content: center;
}

.wrapper__agent__header {
    align-items: flex-start;
}

.wrapper__pin {
    border-radius: 12px;
    border: 1px solid #E7E4E0;
    padding: 7px 11px;
    gap: 5px;
}

.steps__circle {
    padding: 2px 10px;
    border-radius: 50px;
    background: #E576001A;
    color: var(--color-E57600);
    font-size: 16px;
    font-weight: 500;
    line-height: 26px;
    display: inline-flex;
    align-items: center;
    justify-content: center;
}

.onboarding__grid__left {
    max-width: 750px;
    width: 100%;
    padding-right: 24px;
}

.onboarding__grid__right {
    max-width: calc(100% - 750px);
    width: 100%;
}

.wrapper__onbaording__form,
.onboarding__grid__right aside {
    border: 1px solid #E7E4E0;
    padding: 24px;
    border-radius: 16px;
    background: var(--color-ffffff);
}

.onboarding__grid__right aside {
    display: flex;
    flex-direction: column;
    gap: 18px;
    position: sticky;
    top: 10px;
}

.wrapper__project {
    white-space: nowrap;
    overflow: hidden;
    text-overflow: ellipsis;
    width: 70px;
}

.agent__new__design__grid {
    flex-direction: column-reverse;
}

.agent__exe__selection {
    max-width: 100%;
    width: 100%;
}

.agent__exe__blackScreen {
    max-width: 100%;
    width: 100%;
}

.wrapper__selection__inner {
    padding: 20px;
    border: 1px solid #E7E4E0;
    border-radius: 16px;
}

.wrapper__ai__disclaimer {
    border: 1px solid #ECAA0B33;
    background: #ECAA0B0D;
    padding: 16px;
    border-radius: 16px;
    margin-top: 11px;
}


.wrapper__credentials__warning {
    margin-bottom: 12px;
    display: flex;
    align-items: flex-start;
    gap: 9px;
    border: 1px solid var(--color-E52F0F);
    background: var(--failed-bg);
    padding: 4px 10px;
    border-radius: 16px;
}

.link {
    color: var(--color-E57600);
    text-decoration: underline;
}

.project__details__run {
    background: var(--orange-bg);
    padding: 8px 10px;
    border-radius: 16px;
    margin-bottom: 12px;
}

.list__none {
    list-style-type: none;
}

.cursor {
    cursor: pointer;
}

.hasContext {
    font-size: 12px;
    line-height: 16px;
    font-family: var(--fontInter);
    letter-spacing: 0px;
    margin-top: 9px;
    color: var(--color-5F636A);
    white-space: pre-wrap;
}

.hasContext.hasOpacity {
    opacity: 0.5;
}

.wrapper__aiRun__warning {
    border: 1px solid #ECAA0B33;
    padding: 12px;
    gap: 4px;
    border-radius: 12px;
    background: #ECAA0B0F;
}

.execution__btn button {
    height: 42px;
    gap: 8px;
}

.execution__btn button:disabled {
    pointer-events: none;
}

.execution__btn button img {
    transition: all 0.3s ease;
}

.execution__btn button:hover img {
    filter: brightness(0) saturate(100%) invert(52%) sepia(80%) saturate(2763%) hue-rotate(6deg) brightness(95%) contrast(101%);
    transition: all 0.3s ease;
}

.chat__form__row {
    margin-left: -10px;
    margin-right: -10px;
    margin-bottom: 24px;
}

.wrapper__input__col {
    padding: 0px 10px;
}

/* When there's only 1 input */
.wrapper__input__col:first-child:nth-last-child(1) {
    width: 100%;
}

/* When there are 2 inputs total */
.wrapper__input__col:first-child:nth-last-child(2),
.wrapper__input__col:first-child:nth-last-child(2)~.wrapper__input__col {
    width: 50%;
}

/* When there are 3 inputs total */
.wrapper__input__col:first-child:nth-last-child(3),
.wrapper__input__col:first-child:nth-last-child(3)~.wrapper__input__col {
    width: 33.333%;
}

/* When there are 4 inputs total */
.wrapper__input__col:first-child:nth-last-child(4),
.wrapper__input__col:first-child:nth-last-child(4)~.wrapper__input__col {
    width: 25%;
}

/* When there are 5 inputs total */
.wrapper__input__col:first-child:nth-last-child(5),
.wrapper__input__col:first-child:nth-last-child(5)~.wrapper__input__col {
    width: 20%;
}

.wrapper__doamin__list {
    margin-left: -10px;
    margin-right: -10px;
}

.wrapper__agent__notification__window {
    margin-bottom: 12px;
    display: flex;
    align-items: flex-start;
    gap: 12px;
    padding: 10px 13px;
    background: var(--darkGreen-bg);
    border: 1px solid #007A5533;
    border-radius: 12px;
    font-size: 12px;
    color: var(--color-0E1218);
    line-height: 20px;
    font-weight: 400;
    max-width: 90%;
    width: 100%;
    margin-left: auto;
    margin-right: auto;
}

.flex__1 {
    flex: 1 1;
}

.execution__btn .common__transp__btn img {
    filter: brightness(0) saturate(100%) invert(4%) sepia(10%) saturate(2610%) hue-rotate(177deg) brightness(92%) contrast(94%);
}

.execution__btn button span {
    display: inline-flex;
    align-items: center;
    gap: 8px;
}

.execution__btn .common__transp__btn:hover img {
    filter: none;
}

.error-page {
    min-height: 100vh;
    display: flex;
    flex-direction: column;
    align-items: center;
    justify-content: center;
    text-align: center;
    gap: 12px;
    padding: 24px;
}

.error-page button {
    padding: 10px 20px;
    border: 0;
    border-radius: 6px;
    cursor: pointer;
}

.agent__website__url {
    background: #E576001A;
    border: 1px solid #E576004D;
    border-radius: 20px;
    padding: 10px 16px;
}

.wrapper__execution__screen__div {
    max-width: 1010px;
    width: 100%;
    margin-left: auto;
    margin-right: auto;
    gap: 12px;
    align-items: flex-start;
    margin-bottom: 28px;
}

.runTech {
    width: 32px;
    height: 32px;
    border-radius: 50%;
    background: #E5760026;
    display: flex;
    align-items: center;
    justify-content: center;
    font-size: 11px;
    font-weight: 700;
    color: var(--color-E57600);
    flex-shrink: 0;
    letter-spacing: -0.02em;
    text-transform: uppercase;
}

.wrapper__screen__map {
    background: #0A0D12;
    box-shadow: 0px 24px 60px -30px #00000066;
    border: 1px solid #E7E4E0;
    border-radius: 16px;
    padding: 20px;
    font-family: "JetBrains Mono", monospace;
    font-size: 11px;
    max-height: 620px;
    overflow: auto;
    margin-bottom: 24px;
    transition: max-height 0.2s;
}

.wrapper__screen__map__header {
    padding-bottom: 30px;
}

.screen__run__data {
    letter-spacing: 1.58px;
    font-size: 11px;
    font-weight: 400;
    line-height: 20px;
    color: #FFFFFF80;
    font-family: var(--fontJetBrainsMono);
    text-transform: uppercase;
    gap: 11px;
}

.runStatus {
    font-size: 12px;
    line-height: 16px;
    font-family: var(--fontInter);
    letter-spacing: 0px;
}

.dots {
    position: relative;
    display: inline-flex;
    align-items: center;
    gap: 6px;
}

.dots::before {
    content: "";
    display: inline-block;
    width: 6px;
    height: 6px;
    border-radius: 50%;
    background: #000;
}

.Run__in__Queue {
    color: var(--color-0069A8);
}

.run__In__running {
    color: var(--color-E57600);
    font-size: 12px;
    display: flex;
    align-items: center;
    gap: 6px;
}

.run__Completed {
    color: var(--color-007A55);
    padding: 2px 8px;
    background: #24A9651A;
    border-radius: 35px;
    text-transform: uppercase;
    font-weight: 700;
    font-family: var(--fontJetBrainsMono);

}

.run__Failed {
    color: var(--color-E52F0F);
    font-weight: 700;
    font-family: var(--fontJetBrainsMono);
    padding: 2px 8px;
    border-radius: 35px;
    text-transform: uppercase;
    background: var(--failed-bg);
}

.run__In__running .pulse-dot {
    background: var(--color-E57600);
    box-shadow: 0 0 8px var(--color-E57600);

}

.run__In__running .pulse-dot::after {
    border-color: var(--color-E57600);
}

.screen__static__controls .controls {
    width: 10px;
    height: 10px;
    display: inline-flex;
    border-radius: 50%;
}

.run__Completed.dots::before {
    background: var(--color-007A55);
}

.run__Failed.dots::before {
    background: var(--color-E52F0F);
}

.controls.red {
    background: #FF2056B2;
}

.controls.orange {
    background: #FE9A00B2;

}

.controls.green {
    background: #00BC7DB2;

}

.notify__activated {
    background: rgba(6, 182, 212, 0.06);
    border: 1px solid rgba(6, 182, 212, 0.15);
    border-radius: 8px;
    padding: 9px 13px;
    margin-bottom: 10px;
    font-size: 12px;
    color: var(--text-secondary);
    display: flex;
    align-items: center;
    gap: 8px;
}

.wrapper__report__section {
    padding: 10px 13px;
    background: var(--darkGreen-bg);
    border: 1px solid #007A5533;
    border-radius: 12px;
    font-size: 12px;
    color: var(--color-0E1218);
    line-height: 20px;
    font-weight: 400;
}

.report__modal {
    position: fixed;
    right: 0;
    top: 0;
    bottom: 0;
    width: min(100%, 772px);
    height: 100vh;
    height: 100dvh;
    box-shadow: -2px 4px 54px 0px #00000040;
    z-index: 1050;
    background: #FDFCFA;
    transition: all 0.3s ease;
    overflow-x: hidden;
    overflow-y: auto;
    outline: 0;
}

.report__modal__inner {
    background: #FDFCFA;
    max-width: 766px;
    min-height: 100%;
    padding: 20px 20px 33px;
    width: 100%;
}

.report__head {
    padding: 10px 0px 20px;
    position: sticky;
    top: 0;
    z-index: 2;
    background: #FDFCFA;
}

.download__pdf {
    border: 1px solid #E7E4E0;
    outline: none;
    background: transparent;
    padding: 10px 16px;
    border-radius: 12px;
    cursor: pointer;
}

.wrapper__report__border {
    border: 1px solid #E7E4E0;
    box-shadow: 0px 2px 8px 0px #00000014;
    border-radius: 12px;
    padding: 30px 20px;
}

.report__model__body {
    width: 100%;
    max-width: 712px;
    margin-left: auto;
    margin-right: auto;
    padding-bottom: 33px;
}

.report__scores {
    margin-left: -7px;
    margin-right: -7px;
}

.report__score__col {
    max-width: calc(100% / 4);
    width: 100%;
    padding: 0px 7px;
}

.report__score__col__inner {
    border: 1px solid #E7E4E0;
    background: var(--color-ffffff);
    border-radius: 14px;
    padding: 12px 16px;
    height: 100%;
}

.wrapper__demo__output {
    border: 1px dashed #E7E4E0;
    background: var(--color-ffffff);
    border-radius: 12px;
    padding: 12px 13px;
}

.wrapper__report__section button.common__btn {
    gap: 4px;
}

.wrapper__report__section button.common__btn img {
    transition: all 0.3s ease;
}

.wrapper__report__section button.common__btn:hover img {
    filter: brightness(0) saturate(100%) invert(62%) sepia(44%) saturate(7316%) hue-rotate(9deg) brightness(98%) contrast(101%);
}

.report__md {
    overflow-x: auto;
    margin-bottom: 30px;
    border: 1px solid #ECAA0B33;
    background: #ECAA0B0D;
    padding: 15px 12px;
    border-radius: 12px;
}

.wrapper__generated__files .common__btn,
.download__file__btn__groups .common__btn {
    font-size: 13px;
    font-weight: 500;
    background: #E576001A;
    border: 1px solid #E576004D;
    box-shadow: none;
    color: var(--color-E57600);
    padding: 9px 9px;
    height: auto;
    gap: 6px;
}

.d__fileType {
    background: #E5760033;
    padding: 2px 6px;
    border-radius: 4px;
}

.wrapper__generated__files {
    display: flex;
    align-items: flex-end;
    gap: 12px;
    width: 100%;
    margin-top: 8px;
    flex-wrap: wrap;
}

.download__pdf__stdoutContent {
    border: 1px solid #E7E4E0;
    border-color: transparent;
    border-radius: 8px;
    padding: 10px 12px;
    margin: 0px;
    background: transparent;
    outline: none;
    cursor: pointer;
    transition: all 0.3s ease;
}

.download__pdf__stdoutContent:hover {
    border-color: #E576004D;
}

.report__md h1 {
    color: var(--color-0E1218);
    font-family: var(--fontSpaceGroTesk);
    letter-spacing: -0.6px;
    font-size: 30px;
    font-weight: 700;
    margin-bottom: 8px;
    margin-top: 0px;
}

.report__md h2 {
    color: var(--color-0E1218);
    font-family: var(--fontSpaceGroTesk);
    letter-spacing: -0.6px;
    font-size: 26px;
    letter-spacing: .08em;
    text-transform: uppercase;
    color: #E57600;
    margin: 24px 0 12px;
}

.report__md h3 {
    color: var(--color-0E1218);
    font-family: var(--fontSpaceGroTesk);
    letter-spacing: -0.6px;
    font-size: 22px;
    font-weight: 700;
    margin: 16px 0 8px;
}

.report__md h4 {
    color: var(--color-0E1218);
    font-family: var(--fontSpaceGroTesk);
    letter-spacing: -0.6px;
    font-size: 20px;
    font-weight: 700;
    margin: 16px 0 8px;
}

.report__md h5 {
    color: var(--color-0E1218);
    font-family: var(--fontSpaceGroTesk);
    letter-spacing: -0.6px;
    font-size: 18px;
    font-weight: 700;
    margin: 16px 0 8px;
}

.report__md h6 {
    color: var(--color-0E1218);
    font-family: var(--fontSpaceGroTesk);
    letter-spacing: -0.6px;
    font-size: 16px;
    font-weight: 700;
    margin: 16px 0 8px;
}

.report__md p {
    margin-bottom: 12px;
    color: #5F636A;
    font-size: 12px;
    font-weight: 400;
    line-height: 20px;
    font-family: var(--fontInter);
}

.report__md ol {
    list-style: none;
    padding: 0;
    counter-reset: item;
}

.report__md ol li {
    counter-increment: item;
    display: block;
    position: relative;
    padding-left: 40px;
    gap: 12px;
    margin-bottom: 14px;
    font-size: 12px;
    font-family: var(--fontInter);
    color: var(--color-5F636A);
}

.report__md ol li::before {
    content: counter(item);
    flex: 0 0 28px;
    width: 28px;
    height: 28px;
    border-radius: 50%;
    background: #FDEBD9;
    color: #E57600;
    display: grid;
    place-items: center;
    font-size: 12px;
    font-family: var(--fontInter);
    color: var(--color-5F636A);
    position: absolute;
    left: 0;
    top: 0;
}

.report__md ul {
    padding-left: 20px;
    margin-bottom: 12px;
}

.report__md ul li {
    list-style-type: disc;
    font-size: 12px;
    font-weight: 400;
    line-height: 20px;
    font-family: var(--fontInter);
    color: var(--color-5F636A);
}

.report__md hr {
    border: 0;
    border-top: 1px solid #eee;
    margin: 20px 0;
}

.report__md a {
    color: #E57600;
    text-decoration: underline;
}

.report__md table {
    width: 100%;
    border-collapse: collapse;
    margin: 12px 0;
    font-size: 12px;
    font-family: var(--fontInter);
}

.report__md th,
.report__md td {
    border: 1px solid #E7E4E0;
    padding: 6px 8px;
    text-align: left;
    vertical-align: top;
    color: var(--color-5F636A);
}

.report__md th {
    background: #E576001A;
    color: var(--color-0E1218);
    font-weight: 600;
}

.report__md pre,
.report__raw {
    background: var(--color-ffffff);
    border: 1px solid #E7E4E0;
    border-radius: 8px;
    padding: 10px 12px;
    margin: 10px 0;
    font-size: 11px;
    line-height: 18px;
    color: var(--color-5F636A);
    white-space: pre-wrap;
    word-break: break-word;
    overflow-x: auto;
}

.report__raw {
    margin: 0;
}

.report__md blockquote {
    border-left: 3px solid #E5760066;
    margin: 10px 0;
    padding: 2px 0 2px 12px;
    font-size: 12px;
    color: var(--color-5F636A);
}

/* The generated-file button whose report is currently open in the panel */
.wrapper__generated__files .common__btn.is__active,
.download__file__btn__groups .common__btn.is__active {
    background: #E5760033;
    border-color: var(--color-E57600);
}

.report__files {
    margin-top: 24px;
    margin-bottom: 24px;
}

.report__files button {
    gap: 6px;
}

.noGeneratedFiles {
    background: var(--orange-bg);
    padding: 8px 10px;
    border-radius: 16px;
}

.report__footer {
    border-top: 1px solid #eee;
    margin-top: 24px;
    padding-top: 12px;
    gap: 6px;
}

.wrapper__history__card,
.wrapper__findings__card {
    border: 1px solid #E7E4E0;
    border-radius: 16px;
    padding: 20px;
    background: var(--color-FDFCFA);
}

.history__priorities li {
    list-style-type: decimal;
    margin-left: 15px;
}

.history__priorities li:not(:last-child) {
    margin-bottom: 7px;
}

.history__priorities .sev {
    font-weight: 600;
}

.menu__toggle {
    display: none;
    background: transparent;
    border: none;
    /* border: 1px solid #E7E4E0;
    border-radius: 8px; */
    cursor: pointer;
}

/* ###------------------CSS BASED ON FIGMA END------------------### */
/* ── Header project switcher ─────────────────────────────────────────────
   The one project picker for Overview, Agent Library, Execution History and
   the agent chat. Sits between the breadcrumb and the right-hand actions,
   and stays outside .wrapper__right so it survives on phones, where that
   container is hidden.

   Accent is the site orange (--color-E57600) over its two tints, the same
   pairing the settings project list and the agent category chips use. */

.hdr__project__switch {
    margin-left: auto;
    display: inline-flex;
    align-items: center;
    gap: 8px;
    flex-shrink: 0;
}

.hdr__project__eyebrow {
    font-size: 11px;
    font-weight: 600;
    line-height: 20px;
    font-family: var(--fontInter);
    color: var(--color-5F636A);
    text-transform: uppercase;
    letter-spacing: 0.07em;
    white-space: nowrap;
}

.hdr__project__btn {
    display: inline-flex;
    align-items: center;
    gap: 6px;
    max-width: 240px;
    padding: 6px 12px;
    border-radius: 8px;
    border: 1px solid var(--color-E7E4E0);
    background: var(--color-ffffff);
    color: var(--color-5F636A);
    cursor: pointer;
    font-size: 12px;
    font-weight: 600;
    font-family: var(--fontInter);
    line-height: 20px;
    white-space: nowrap;
    transition: all 0.15s ease;
}

.hdr__project__btn.is__static {
    cursor: default;
}

.hdr__project__btn:hover {
    border-color: #E5760033;
    background: #E576000D;
    color: var(--color-E57600);
}

.hdr__project__btn.selected {
    border-color: #E5760033;
    background: #E576000D;
    color: var(--color-E57600);
}

.hdr__project__btn.active {
    border-color: var(--color-E57600);
    box-shadow: 0px 0px 0px 1px #E5760026;
}

.hdr__project__label {
    overflow: hidden;
    text-overflow: ellipsis;
    white-space: nowrap;
}

.hdr__project__menu {
    position: absolute;
    top: calc(100% + 6px);
    right: 0px;
    min-width: 230px;
    background: var(--color-ffffff);
    border: 1px solid var(--color-E7E4E0);
    border-radius: 10px;
    box-shadow: 0 8px 32px rgba(14, 18, 24, 0.12);
    z-index: 100;
    overflow: hidden;
}

.hdr__project__list {
    padding: 6px 4px;
    max-height: 260px;
    overflow-y: auto;
}

.hdr__project__item {
    width: 100%;
    text-align: left;
    padding: 7px 12px;
    border: none;
    border-radius: 6px;
    background: transparent;
    cursor: pointer;
    display: flex;
    align-items: center;
    gap: 8px;
    color: var(--color-0E1218);
    transition: background 0.15s ease, color 0.15s ease;
}

.hdr__project__item:hover,
.hdr__project__item.active {
    background: #E576000D;
    color: var(--color-E57600);
}

.hdr__project__item .dots::before {
    background: var(--color-5F636A);
    transition: background 0.15s ease;
}

.hdr__project__item:hover .dots::before,
.hdr__project__item.active .dots::before {
    background: var(--color-E57600);
}

.hdr__project__item .p__name {
    display: block;
    color: var(--color-0E1218);
}

.hdr__project__item .p__domain__comp {
    display: block;
    margin-top: 1px;
    color: var(--color-5F636A);
}

.hdr__project__item:hover .p__name,
.hdr__project__item.active .p__name {
    color: var(--color-E57600);
}

.hdr__project__item__inner {
    min-width: 0;
    overflow: hidden;
}

.hdr__project__item__inner .p__name,
.hdr__project__item__inner .p__domain__comp {
    overflow: hidden;
    text-overflow: ellipsis;
    white-space: nowrap;
}

.hdr__project__new {
    width: 100%;
    text-align: left;
    padding: 9px 12px;
    border: none;
    border-top: 1px solid var(--color-E7E4E0);
    background: #E576000D;
    cursor: pointer;
    font-size: 12px;
    font-weight: 600;
    font-family: var(--fontInter);
    color: var(--color-E57600);
    display: flex;
    align-items: center;
    gap: 6px;
    transition: background 0.15s ease, color 0.15s ease;
}

.hdr__project__new:hover {
    background: var(--color-E57600);
    color: var(--color-ffffff);
}

.hdr__project__limit {
    padding: 9px 12px;
    border-top: 1px solid var(--color-E7E4E0);
}


/* ## UI FEEDBACK ## */
nav.sidebar-nav ul li:not(:last-child) {
    margin-bottom: 6px;
}

nav.sidebar-nav {
    align-items: initial;
}

span.fb__12.fw__700.fc__5F636A.ff__jetBrainsMono.bg__F5F3F0.py__5.br__4 {
    display: block;
    max-width: 100%;
    overflow-wrap: anywhere;
    word-break: break-all;
    width: fit-content;
}

.sd-row.sd-empty .sd-row-main {
    display: flex;
    justify-content: space-between;
    align-items: center;
}

.sd-row.sd-empty {
    min-height: 60px;
}

.wrapper__recents__head .recent__left>span {
    line-height: 20px;
}

.wrapper__userDropdown .userName {
    font-size: 12px;
    text-align: left;
}

.wrapper__sidenav__item .expand__icon {
    margin-left: auto;
}

.wrapper__header__area {
    display: flex;
    align-items: center;
    justify-content: space-between;
    width: 100%;
    flex-wrap: wrap;
}

.report__score__grid {
    row-gap: 14px;
}

.sidebar__toggle {
    display: none;
}

.sidebar__top {
    display: flex;
    align-items: center;
    justify-content: space-between;
}

.app-sidebar--collapsed .userDetails,
.app-sidebar--collapsed .userMenu__accordion {
    display: none;
}

.app-sidebar--collapsed .userDropdown__btn {
    justify-content: center;
    padding: 8px;
}
aside.app-sidebar.app-sidebar--collapsed .sidebar__brand {
    padding: 0;
}
.app-sidebar--collapsed .wrapper__dropdown__menu {
    width: 260px;
    left: 0;
}

.app-sidebar--collapsed .sidebar__brand .logo-img--short {
    width: 24px;
    height: 24px;
}
.app__shell select{
    -webkit-appearance: none;
    -moz-appearance: none;
    background-image: url(${___CSS_LOADER_URL_REPLACEMENT_0___});
    background-repeat: no-repeat;
    background-position: right .75rem center;
    background-size: 16px 24px;
    padding-right: 30px;
}

/* ### RESPONSIVE BEHAVIOUR ### */




@media(max-width:850px) {
    .wrapper__agents__col {
        max-width: calc(100% / 1);
        width: 100%;
    }

    .wrapper__project__left,
    .wrapper__project__right {
        max-width: 100%;
    }

    .wrapper__agent__header,
    .wrapper__agents__nameTags {
        flex-wrap: wrap;
    }

    .wrapper__agent__header {
        row-gap: 20px;
    }

    .wrapper__input__col:first-child:nth-last-child(2),
    .wrapper__input__col:first-child:nth-last-child(2)~.wrapper__input__col {
        max-width: 100%;
        width: 100%;
    }

    .wrapper__doamin__list,
    .chat__form__row {
        row-gap: 20px;
    }

    .wrapper__input__col:first-child:nth-last-child(3),
    .wrapper__input__col:first-child:nth-last-child(3)~.wrapper__input__col {
        width: 100%;
        max-width: 100%;
    }

    .breadcrumb__list .breadcrumb-sep {
        margin: 0px 2px;
    }

    .wrapper__input__col:first-child:nth-last-child(4),
    .wrapper__input__col:first-child:nth-last-child(4)~.wrapper__input__col {
        max-width: 100%;
        width: 100%;
    }

    .wrapper__execution__screen__inner {
        width: 100%;
        flex: 100% 1 !important;
    }

    .wrapper__report__section {
        flex-wrap: wrap;
        justify-content: center !important;
        flex-direction: column;
        row-gap: 15px;
    }

    .wrapper__execution__screen__div {
        flex-wrap: wrap;
    }

    .report__md h1 {
        font-size: 24px;
        line-height: 34px;
    }

    .report__md h2 {
        font-size: 22px;
        line-height: 32px;
    }

    .report__md h3 {
        font-size: 20px;
        line-height: 30px;
    }

    .report__md h4 {
        font-size: 18px;
        line-height: 28px;
    }

    .report__md h5 {
        font-size: 16px;
        line-height: 24px;
    }

    .report__md h6 {
        font-size: 14px;
        line-height: 24px;
    }

    .wrapper__history__filter {
        flex-wrap: wrap;
        margin-top: 20px;
    }

    .onboarding__grid__left,
    .onboarding__grid__right {
        max-width: 100%;
        padding: 0px;
    }

    .onboarding__grid.custom__row {
        row-gap: 30px;
    }

    .onboarding__grid__right {
        order: -1;
    }

    .wrapper__agent__filter {
        flex-wrap: wrap;
        row-gap: 15px;
    }

    .sd-detail-score {
        text-align: left;
    }



}

@media(min-width:769px) and (max-width:1099px) {
    .wrapper__execution__history table {
        min-width: 1200px;
    }

    .wrapper__history__top {
        gap: 20px;
    }
}

@media(min-width:850px) and (max-width:1260px) {
    .wrapper__agents__col {
        max-width: calc(100% / 2);
        width: 100%;
    }

    .sd-link {
        font-size: 14px;
    }


}

@media(max-width:1260px) {
    .wrapper__history__top {
        flex-wrap: wrap;
    }

    .wrapper__project__left,
    .wrapper__project__right {
        max-width: 100%;
    }

    .wrapper__project__setting__grid {
        row-gap: 40px;
    }

    .wrapper__history__top {
        margin-bottom: 10px;
    }

    .wrapper__main {
        padding: 18px;
    }

}

@media(min-width: 1280px) {
    .sidebar__toggle {
        display: block;
        background: none;
        border: 0;
        padding: 0;
        cursor: pointer;
    }


    .sidebar__toggle[aria-expanded="false"] img  {
        transform: scaleX(-1);
    }

    .app-sidebar--collapsed .betaTag,
    .app-sidebar--collapsed .workSpace,
    .app-sidebar--collapsed .nav__title,
    .app-sidebar--collapsed .total__agents,
    .app-sidebar--collapsed .expand__icon {
        display: none;
    }

    .app-sidebar--collapsed .sidebar__top {
        gap: 8px;
        justify-content: initial;
    }

    .app-sidebar--collapsed .sidebar-nav-item {
        justify-content: center;
    }

    main.app-main.app-main--collapsed {
        margin-left: 78px;
        max-width: 100%;
    }
}

@media (min-width:769px) and (max-width:1260px) {
    .site__footer__inner {
        justify-content: flex-start;
    }

    .site__footer {
        margin-left: 257px;
    }
}

@media (min-width:769px) and (max-width:900px) {
    .site__footer__inner {
        max-width: 400px;
        padding: 0px;
        margin-left: 30px;
    }
}

@media(min-width:1199px) and (max-width:1365px) {
    .wrapper__execution__history table {
        min-width: 1200px;
    }
}

@media(min-width:1261px) and (max-width:1360px) {
    .wrapper__agent__card .agent__name {
        height: 45px;
    }

    .wrapper__agents__col {
        max-width: calc(100% / 3);
    }

    .wrapper__history__top {
        margin-bottom: 10px;
    }

    .wrapper__main {
        padding: 18px;
    }


}

@media(min-width:1520px) {

    .wrapper__execution__history table thead tr th:nth-child(2),
    .wrapper__execution__history table tbody tr td:nth-child(2) {
        width: 30%;
    }
}

@media (max-width: 768px) {
    .h3 {
        font-size: 20px;
        line-height: 30px;
    }

    .fb__13 {
        font-size: 12px;
        line-height: 21px;
    }

    main.app-main {
        margin-left: 0px;
        max-width: 100%;
    }

    .menu__toggle {
        display: block;
    }

    .app-sidebar {
        position: fixed;
        top: 0;
        left: 0;
        bottom: 0;
        width: 260px;
        z-index: 1000;
        background: #fff;
        transform: translateX(-100%);
        transition: transform .25s;
    }

    .app-sidebar--open {
        transform: translateX(0);
    }

    .wrapper__right {
        display: none;
    }

    .breadcrumb__list li.breadcrumb-item a,
    .breadcrumb-item .breadcrumb-current {
        font-size: 11px;
    }

    .wrapper__main {
        padding: 15px 15px;
    }

    .sidebar {
        position: fixed;
        top: 0;
        left: 0;
        bottom: 0;
        width: 260px;
        z-index: 1000;
        transform: translateX(-100%);
        transition: transform .25s;
    }

    .sidebar--open {
        transform: translateX(0);
    }

    .sidebar__overlay {
        position: fixed;
        inset: 0;
        background: rgba(0, 0, 0, .4);
        z-index: 4;
    }


    .main-content {
        margin-left: 0;
        width: 100%;
        padding: 16px;
    }

    .agent__new__design__grid {
        flex-direction: column-reverse;
    }

    .agent__exe__selection,
    .agent__exe__blackScreen {
        width: 100%;
    }

    .report__modal {
        width: 100%;
    }

    .report__score__grid {
        flex-wrap: wrap;
    }


    .report__score__col {
        flex: 0 0 50%;
    }


    .wrapper__reportos__head {
        flex-direction: column;
        gap: 16px;
    }

    .wrapper__common__header {
        padding: 12px 15px;
        justify-content: flex-start;
    }

    .agent__website__url {
        padding: 7px 10px;
    }

    .wrapper__generated__files .common__btn,
    .download__file__btn__groups .common__btn {
        font-size: 12px;
    }

    .wrapper__execution__history .table {
        min-width: 1200px;
    }

    .input__filter {
        width: 100%;
    }

    .input__filter input {
        min-width: 100%;
    }

    .wrapper__s__Filter___dropdown {
        right: initial;
    }
}

@media (max-width: 768px) {
    .hdr__project__switch {
        gap: 6px;
    }

    .hdr__project__btn {
        max-width: 150px;
        padding: 5px 10px;
    }

    .hdr__project__menu {
        min-width: 200px;
        left: 0;
    }

    .wrapper__header__area {
        row-gap: 7px;
    }

    .wrapper__header__area .hdr__project__switch {
        margin-right: auto;
        margin-left: 0px;
    }

    .table-col-hide {
        display: table-cell !important;
    }

    .wrapper__header__area nav.breadcrumb {
        width: 100%;
    }

    .report__score__grid {
        row-gap: 10px;
    }

    .report__score__col {
        flex: auto;
        max-width: calc(100% / 1);
    }

    .wrapper__reportos__head__left {
        max-width: 75%;
        width: 100%;
    }

    .wrapper__reportos__head__right {
        max-width: 25%;
        width: 100%;
    }

    .wrapper__reportos__head {
        flex-direction: row;
        flex-wrap: nowrap;
        margin-bottom: 16px;
    }
}

@media (max-width: 480px) {
    .fb__16 {
        font-size: 14px;
        line-height: 24px;
    }

    .hdr__project__eyebrow {
        display: none;
    }

    .breadcrumb__list li.breadcrumb-item a,
    .breadcrumb-item .breadcrumb-current {
        font-size: 10px;
    }

    li.breadcrumb-item {
        display: inline-flex;
    }

    .wrapper__header__area nav.breadcrumb {
        width: 100%;
    }

    .sd-detail-score {
        text-align: left !important;
    }

    .sd__cat__data {
        display: block;
        margin-top: 10px;
    }

    .report__head {
        padding: 10px;
    }

    .report__title {
        font-size: 12px;
    }

    .download__pdf {
        font-size: 12px;
        padding: 8px;
    }

    .download__pdf img {
        width: 12px;
    }

    .wrapper__report__border {
        padding: 10px;
    }


}

@media(max-width:320px) {
    .wrapper__common__header {
        gap: 5px;
    }

    button.menu__toggle img {
        width: 18px;
        height: 18px;
    }

    .breadcrumb__list li.breadcrumb-item a,
    .breadcrumb-item .breadcrumb-current {
        font-size: 9px;
    }


}`, "",{"version":3,"sources":["webpack://./src/styles/frontend-style.css"],"names":[],"mappings":"AAAA,wEAAwE;AACxE;IACI,UAAU;IACV,SAAS;IACT,sBAAsB;AAC1B;;AAEA;IACI,gCAAgC;IAChC,WAAW;IACX,+BAA+B;AACnC;;AAEA;IACI,uBAAuB;AAC3B;;AAEA;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;IAiFI,SAAS;IACT,UAAU;IACV,SAAS;IACT,eAAe;IACf,aAAa;IACb,wBAAwB;IACxB,6BAA6B;AACjC;;AAEA;;IAEI,qBAAqB;IACrB,UAAU;IACV,SAAS;AACb;;AAEA;IACI,gCAAgC;AACpC;;AAEA;IACI,sBAAsB;AAC1B;;AAEA;;IAEI,gBAAgB;IAChB,wBAAwB;AAC5B;;AAEA;;IAEI,gCAAgC;IAChC,+CAA+C;IAC/C,gDAAgD;IAChD,uBAAuB;IACvB,2BAA2B;IAC3B,uBAAuB;IACvB,uBAAuB;IACvB,uBAAuB;IACvB,uBAAuB;IACvB,uBAAuB;IACvB,uBAAuB;IACvB,uBAAuB;IACvB,uBAAuB;IACvB,uBAAuB;IACvB,uBAAuB;IACvB,uBAAuB;IACvB,uBAAuB;IACvB,uBAAuB;IACvB,uBAAuB;IACvB,uBAAuB;IACvB,uBAAuB;IACvB,uBAAuB;IACvB,uBAAuB;IACvB,sBAAsB;IACtB,uBAAuB;IACvB,sBAAsB;IACtB,oBAAoB;IACpB,yBAAyB;;AAE7B;;AAEA;IACI,qBAAqB;IACrB,oCAAoC;AACxC;;;AAGA,qBAAqB;AACrB;IACI,UAAU;IACV,WAAW;IACX,kBAAkB;AACtB;;AAEA;IACI,+BAA+B;IAC/B,kBAAkB;AACtB;;AAEA;IACI,0CAA0C;AAC9C;;AAEA;IACI,+BAA+B;AACnC;;AAEA,yDAAyD;;AAEzD;IACI,eAAe;IACf,iBAAiB;IACjB,oCAAoC;IACpC,uBAAuB;AAC3B;;AAEA;IACI,eAAe;IACf,iBAAiB;IACjB,oCAAoC;IACpC,uBAAuB;AAC3B;;AAEA;IACI,eAAe;IACf,iBAAiB;IACjB,oCAAoC;IACpC,sBAAsB;AAC1B;;AAEA;IACI,eAAe;IACf,iBAAiB;IACjB,oCAAoC;IACpC,uBAAuB;AAC3B;;AAEA;IACI,eAAe;IACf,iBAAiB;IACjB,oCAAoC;IACpC,sBAAsB;AAC1B;;AAEA;IACI,eAAe;IACf,iBAAiB;IACjB,6BAA6B;IAC7B,mBAAmB;AACvB;;AAEA;IACI,eAAe;IACf,iBAAiB;IACjB,6BAA6B;IAC7B,mBAAmB;AACvB;;AAEA;IACI,eAAe;IACf,iBAAiB;IACjB,6BAA6B;IAC7B,mBAAmB;AACvB;;AAEA;IACI,eAAe;IACf,iBAAiB;IACjB,6BAA6B;IAC7B,mBAAmB;AACvB;;AAEA;IACI,eAAe;IACf,iBAAiB;IACjB,6BAA6B;IAC7B,mBAAmB;AACvB;;AAEA;IACI,eAAe;IACf,iBAAiB;IACjB,6BAA6B;IAC7B,mBAAmB;AACvB;;AAEA;IACI,6BAA6B;AACjC;;AAEA;IACI,iBAAiB;IACjB,WAAW;IACX,iBAAiB;IACjB,kBAAkB;IAClB,iBAAiB;AACrB;;AAEA,uDAAuD;;AAEvD,uDAAuD;AACvD;IACI,0BAA0B;AAC9B;;AAEA;IACI,0BAA0B;AAC9B;;AAEA;IACI,0BAA0B;AAC9B;;AAEA;IACI,0BAA0B;AAC9B;;AAEA;IACI,0BAA0B;AAC9B;;AAEA;IACI,0BAA0B;AAC9B;;AAEA;IACI,0BAA0B;AAC9B;;AAEA;IACI,0BAA0B;AAC9B;;AAEA;IACI,0BAA0B;AAC9B;;AAEA;IACI,0BAA0B;AAC9B;;AAEA;IACI,0BAA0B;AAC9B;;AAEA;IACI,0BAA0B;AAC9B;;AAEA;IACI,0BAA0B;AAC9B;;AAEA;IACI,0BAA0B;AAC9B;;AAEA;IACI,0BAA0B;AAC9B;;AAEA,qDAAqD;;;AAGrD,mEAAmE;AACnE;IACI,qCAAqC;AACzC;;AAEA;IACI,qCAAqC;AACzC;;AAEA;IACI,qCAAqC;AACzC;;AAEA;IACI,qCAAqC;AACzC;;AAEA;IACI,qCAAqC;AACzC;;AAEA;IACI,qCAAqC;AACzC;;AAEA;IACI,qCAAqC;AACzC;;AAEA;IACI,qCAAqC;AACzC;;AAEA;IACI,qCAAqC;AACzC;;AAEA;IACI,qCAAqC;AACzC;;AAEA;IACI,qCAAqC;AACzC;;AAEA;IACI,qCAAqC;AACzC;;AAEA;IACI,qCAAqC;AACzC;;AAEA;IACI,uCAAuC;AAC3C;;AAEA;IACI,qCAAqC;AACzC;;AAEA,iEAAiE;;AAEjE,+BAA+B;AAC/B;IACI,2BAA2B;AAC/B;;AAEA;IACI,2BAA2B;AAC/B;;AAEA;IACI,2BAA2B;AAC/B;;AAEA;IACI,2BAA2B;AAC/B;;AAEA;IACI,2BAA2B;AAC/B;;AAEA;IACI,2BAA2B;AAC/B;;AAEA,yBAAyB;;AAEzB,kCAAkC;AAClC;IACI,gBAAgB;IAChB,iBAAiB;AACrB;;AAEA;IACI,gBAAgB;AACpB;;AAEA;IACI,kBAAkB;AACtB;;AAEA;IACI,kBAAkB;AACtB;;AAEA;IACI,kBAAkB;AACtB;;AAEA;IACI,kBAAkB;AACtB;;AAEA;IACI,mBAAmB;AACvB;;AAEA;IACI,mBAAmB;AACvB;;AAEA;IACI,mBAAmB;AACvB;;AAEA;IACI,mBAAmB;AACvB;;AAEA;IACI,mBAAmB;AACvB;;AAEA;IACI,mBAAmB;AACvB;;AAEA;IACI,mBAAmB;AACvB;;AAEA;IACI,mBAAmB;AACvB;;AAEA;IACI,mBAAmB;AACvB;;AAEA;IACI,mBAAmB;AACvB;;AAEA;IACI;AACJ;;AAEA;IACI;AACJ;;AAEA;IACI;AACJ;;AAEA;IACI,mBAAmB;AACvB;;AAEA;IACI,mBAAmB;AACvB;;AAEA;IACI,mBAAmB;AACvB;;AAEA;IACI,mBAAmB;AACvB;;AAEA;IACI,mBAAmB;AACvB;;AAEA;IACI,mBAAmB;AACvB;;AAEA;IACI,mBAAmB;AACvB;;AAEA;IACI,mBAAmB;AACvB;;AAEA;IACI,mBAAmB;AACvB;;AAEA;IACI,mBAAmB;AACvB;;AAEA;IACI,oBAAoB;AACxB;;AAEA;IACI,iBAAiB;AACrB;;AAEA;IACI,kBAAkB;AACtB;;AAEA;IACI,kBAAkB;AACtB;;AAEA;IACI,kBAAkB;AACtB;;AAEA;IACI,kBAAkB;AACtB;;AAEA;IACI,eAAe;AACnB;;AAEA;IACI,eAAe;AACnB;;AAEA;IACI,eAAe;AACnB;;AAEA;IACI,eAAe;AACnB;;AAEA;IACI,gBAAgB;AACpB;;AAEA;IACI,gBAAgB;AACpB;;AAEA;IACI,gBAAgB;AACpB;;AAEA;IACI,gBAAgB;AACpB;;AAEA;IACI,gBAAgB;AACpB;;AAEA;IACI,gBAAgB;AACpB;;AAEA;IACI,iBAAiB;AACrB;;AAEA;IACI,iBAAiB;AACrB;;AAEA;IACI,kBAAkB;AACtB;;AAEA;IACI,+BAA+B;AACnC;;AAEA,iCAAiC;AACjC;IACI,+BAA+B;AACnC;;AAEA;IACI,wBAAwB;AAC5B;;AAEA;IACI,iCAAiC;AACrC;;AAEA;IACI,0BAA0B;AAC9B;;AAEA;IACI,8BAA8B;AAClC;;AAEA;IACI,yCAAyC;AAC7C;;AAEA;IACI,kCAAkC;AACtC;;AAEA;IACI,sCAAsC;AAC1C;;AAEA;IACI,oCAAoC;AACxC;;AAEA;IACI,cAAc;AAClB;;AAEA;IACI,eAAe;IACf,YAAY;AAChB;;AAEA;IACI,cAAc;AAClB;;AAEA;IACI,gBAAgB;IAChB,WAAW;IACX,iBAAiB;IACjB,kBAAkB;AACtB;;AAEA;IACI,gBAAgB;AACpB;;AAEA;IACI,YAAY;IACZ,mBAAmB;IACnB,oBAAoB;IACpB,mBAAmB;IACnB,uBAAuB;IACvB,iBAAiB;IACjB,eAAe;IACf,iBAAiB;IACjB,6BAA6B;IAC7B,gBAAgB;IAChB,0BAA0B;IAC1B,yBAAyB;IACzB,eAAe;IACf,aAAa;IACb,gBAAgB;IAChB,mBAAmB;IACnB,kBAAkB;IAClB,YAAY;IACZ,UAAU;AACd;;AAEA;IACI,+BAA+B;IAC/B,0BAA0B;IAC1B,qCAAqC;IACrC,uCAAuC;AAC3C;;AAEA;IACI,uBAAuB;IACvB,0BAA0B;AAC9B;;AAEA;IACI,+BAA+B;IAC/B,0BAA0B;IAC1B,qCAAqC;AACzC;;AAEA;IACI,uBAAuB;IACvB,0BAA0B;AAC9B;;;AAGA;IACI,uBAAuB;IACvB,0BAA0B;IAC1B,qCAAqC;AACzC;;AAEA;IACI,+BAA+B;IAC/B,0BAA0B;IAC1B,qCAAqC;AACzC;;AAEA;IACI,uBAAuB;IACvB,uBAAuB;IACvB,YAAY;IACZ,0BAA0B;IAC1B,WAAW;IACX,YAAY;AAChB;;AAEA;;IAEI,WAAW;IACX,YAAY;IACZ,eAAe;AACnB;;AAEA;IACI,aAAa;IACb,eAAe;AACnB;;AAEA;IACI,gBAAgB;IAChB,iBAAiB;IACjB,kBAAkB;AACtB;;AAEA;IACI,kBAAkB;AACtB;;AAEA;IACI,WAAW;AACf;;AAEA;IACI,aAAa;AACjB;;AAEA;IACI,cAAc;AAClB;;AAEA;IACI,iBAAiB;AACrB;;AAEA;IACI,QAAQ;AACZ;;AAEA;IACI,QAAQ;AACZ;;AAEA;IACI,QAAQ;AACZ;;AAEA;IACI,SAAS;AACb;;AAEA;IACI,SAAS;AACb;;AAEA;IACI,SAAS;AACb;;AAEA;IACI,qCAAqC;AACzC;;AAEA;IACI,6BAA6B;AACjC;;AAEA;IACI,oCAAoC;AACxC;;AAEA;IACI,qCAAqC;AACzC;;AAEA;IACI,kBAAkB;AACtB;;AAEA;;IAEI,qBAAqB;IACrB,kBAAkB;AACtB;;AAEA,8BAA8B;AAC9B;IACI,kBAAkB;IAClB,WAAW;IACX,SAAS;IACT,UAAU;IACV,kBAAkB;IAClB,aAAa;IACb,mBAAmB;IACnB,uBAAuB;IACvB,QAAQ;IACR,eAAe;IACf,eAAe;IACf,0BAA0B;IAC1B,mCAAmC;IACnC,gCAAgC;IAChC,2BAA2B;AAC/B;;AAEA;IACI,qCAAqC;AACzC;;AAEA;IACI,wCAAwC;AAC5C;;AAEA;IACI,kBAAkB;IAClB,SAAS;IACT,YAAY;IACZ,wEAAwE;IACxE,yBAAyB;IACzB,cAAc;IACd,gBAAgB;IAChB,sBAAsB;IACtB,gBAAgB;IAChB,kBAAkB;IAClB,yBAAyB;IACzB,cAAc;AAClB;;AAEA;IACI,gBAAgB;IAChB,iBAAiB;IACjB,kBAAkB;AACtB;;AAEA;IACI,aAAa;IACb,oBAAoB;IACpB,mBAAmB;IACnB,iBAAiB;AACrB;;AAEA;IACI,iBAAiB;IACjB,aAAa;IACb,mBAAmB;IACnB,uBAAuB;IACvB,kBAAkB;IAClB,gBAAgB;IAChB,oBAAoB;IACpB,4BAA4B;IAC5B,WAAW;IACX,sBAAsB;AAC1B;;AAEA;IACI,kBAAkB;IAClB,mBAAmB;IACnB,gBAAgB;IAChB,WAAW;AACf;;AAEA;IACI,aAAa;AACjB;;AAEA;IACI,WAAW;IACX,kBAAkB;IAClB,QAAQ;;IAER,mBAAmB;;IAEnB;;;;2BAIuB;;IAEvB,YAAY;;IAEZ,8BAA8B;IAC9B;;iCAE6B;IAC7B,2BAA2B;;IAE3B;;iCAE6B;IAC7B,uBAAuB;;IAEvB,oCAAoC;IACpC,yCAAyC;AAC7C;;AAEA;IACI,YAAY;AAChB;;AAEA;IACI,aAAa;IACb,iBAAiB;IACjB,kBAAkB;AACtB;;AAEA;IACI,eAAe;IACf,YAAY;IACZ,OAAO;IACP,MAAM;IACN,WAAW;IACX,gBAAgB;IAChB,WAAW;IACX,+BAA+B;IAC/B,+BAA+B;AACnC;;AAEA;IACI,eAAe;AACnB;AACA;IACI,iBAAiB;AACrB;AACA;IACI,YAAY;IACZ,aAAa;IACb,sBAAsB;IACtB,8BAA8B;AAClC;;AAEA;IACI,6BAA6B;IAC7B,WAAW;IACX,kBAAkB;AACtB;;AAEA;IACI,qBAAqB;;AAEzB;;AAEA;IACI,6BAA6B;IAC7B,aAAa;;AAEjB;;AAEA;IACI,WAAW;IACX,qBAAqB;IACrB,eAAe;IACf,WAAW;IACX;;;cAGU;AACd;;AAEA;IACI,iBAAiB;IACjB,cAAc;IACd,eAAe;IACf,aAAa;IACb,mBAAmB;IACnB,uBAAuB;IACvB,SAAS;IACT,eAAe;AACnB;;AAEA;IACI,yBAAyB;IACzB,yBAAyB;AAC7B;;AAEA;IACI,qCAAqC;AACzC;;AAEA;IACI,aAAa;IACb,sBAAsB;IACtB,uBAAuB;AAC3B;;AAEA;IACI,WAAW;IACX,gBAAgB;IAChB,YAAY;IACZ,uBAAuB;IACvB,aAAa;IACb,mBAAmB;IACnB,kBAAkB;IAClB,mBAAmB;IACnB,yBAAyB;IACzB,eAAe;IACf,SAAS;IACT,aAAa;IACb,eAAe;IACf,gBAAgB;IAChB,6BAA6B;IAC7B,0BAA0B;AAC9B;;AAEA;IACI,yBAAyB;AAC7B;;AAEA;IACI,mBAAmB;IACnB,kBAAkB;IAClB,oBAAoB;IACpB,mBAAmB;IACnB,uBAAuB;IACvB,YAAY;IACZ,eAAe;IACf,gBAAgB;IAChB,cAAc;IACd,qCAAqC;IACrC,iBAAiB;AACrB;;AAEA;IACI,WAAW;IACX,YAAY;AAChB;;AAEA;;IAEI,qBAAqB;AACzB;;AAEA;IACI,4HAA4H;AAChI;;AAEA;;IAEI,0BAA0B;AAC9B;;AAEA;;IAEI,4HAA4H;AAChI;;AAEA;IACI,uBAAuB;AAC3B;;AAEA;IACI,kBAAkB;IAClB,gCAAgC;IAChC,gBAAgB;IAChB,MAAM;IACN,gBAAgB;IAChB,UAAU;IACV,aAAa;IACb,mBAAmB;IACnB,WAAW;IACX,SAAS;IACT,8BAA8B;AAClC;;AAEA;IACI,aAAa;IACb,mBAAmB;IACnB,QAAQ;AACZ;;AAEA;IACI,uBAAuB;IACvB,aAAa;IACb,WAAW;IACX,eAAe;AACnB;;AAEA;IACI,yBAAyB;IACzB,eAAe;IACf,gBAAgB;IAChB,iBAAiB;IACjB,qBAAqB;IACrB,6BAA6B;IAC7B,gBAAgB;IAChB,qBAAqB;IACrB,kBAAkB;AACtB;;AAEA;;GAEG;;AAEH;IACI,iBAAiB;IACjB,YAAY;IACZ,aAAa;IACb,sBAAsB;IACtB,mBAAmB;IACnB,uBAAuB;AAC3B;;AAEA;IACI,qGAAqG;IACrG,sBAAsB;IACtB,kBAAkB;AACtB;;AAEA;IACI,WAAW;IACX,YAAY;IACZ,aAAa;IACb,yCAAyC;IACzC,yBAAyB;IACzB,mBAAmB;IACnB,kBAAkB;IAClB,eAAe;IACf,gBAAgB;IAChB,0BAA0B;IAC1B,6BAA6B;IAC7B,kBAAkB;AACtB;;AAEA;IACI,kBAAkB;IAClB,UAAU;IACV,SAAS;IACT,uBAAuB;IACvB,YAAY;IACZ,aAAa;IACb,aAAa;IACb,mBAAmB;IACnB,eAAe;AACnB;;AAEA;IACI,aAAa;IACb,mBAAmB;AACvB;;AAEA;IACI,eAAe;IACf,gBAAgB;IAChB,iBAAiB;IACjB,0BAA0B;IAC1B,6BAA6B;AACjC;;AAEA;IACI,qBAAqB;IACrB,eAAe;IACf,cAAc;AAClB;;AAEA;IACI,eAAe;IACf,gBAAgB;IAChB,iBAAiB;IACjB,0BAA0B;IAC1B,6BAA6B;AACjC;;AAEA;IACI,oBAAoB;IACpB,mBAAmB;IACnB,SAAS;IACT,YAAY;IACZ,uBAAuB;IACvB,eAAe;AACnB;;AAEA;IACI,qBAAqB;IACrB,0BAA0B;IAC1B,YAAY;IACZ,yBAAyB;IACzB,eAAe;IACf,gBAAgB;IAChB,6BAA6B;IAC7B,iBAAiB;IACjB,oBAAoB;IACpB,mBAAmB;IACnB,uBAAuB;IACvB,WAAW;IACX,YAAY;IACZ,kBAAkB;AACtB;;AAEA;IACI,+BAA+B;IAC/B,UAAU;IACV,WAAW;IACX,qBAAqB;IACrB,kBAAkB;IAClB,eAAe;AACnB;;AAEA;IACI,kBAAkB;IAClB,OAAO;IACP,qBAAqB;IACrB,YAAY;IACZ,mBAAmB;IACnB,yCAAyC;IACzC,aAAa;IACb,gBAAgB;IAChB,kBAAkB;IAClB,+BAA+B;AACnC;;AAEA;IACI,WAAW;IACX,YAAY;IACZ,kBAAkB;IAClB,+BAA+B;IAC/B,aAAa;IACb,mBAAmB;IACnB,uBAAuB;IACvB,eAAe;IACf,gBAAgB;IAChB,YAAY;IACZ,cAAc;AAClB;;AAEA;IACI,gBAAgB;IAChB,uBAAuB;IACvB,mBAAmB;AACvB;;AAEA;IACI,eAAe;AACnB;;AAEA;IACI,eAAe;IACf,gBAAgB;IAChB,gBAAgB;IAChB,kBAAkB;IAClB,qCAAqC;IACrC,0CAA0C;IAC1C,yBAAyB;IACzB,yBAAyB;IACzB,sBAAsB;AAC1B;;AAEA;IACI,qCAAqC;IACrC,qCAAqC;IACrC,0BAA0B;IAC1B,eAAe;IACf,gBAAgB;IAChB,gBAAgB;IAChB,kBAAkB;IAClB,yBAAyB;IACzB,sBAAsB;IACtB,qCAAqC;AACzC;;AAEA;IACI,0BAA0B;IAC1B,oCAAoC;IACpC,qCAAqC;AACzC;;AAEA;IACI,0BAA0B;IAC1B,qCAAqC;IACrC,sCAAsC;AAC1C;;AAEA;IACI,eAAe;IACf,gBAAgB;IAChB,gBAAgB;IAChB,kBAAkB;IAClB,yBAAyB;IACzB,sBAAsB;AAC1B;;AAEA;IACI,aAAa;IACb,mBAAmB;IACnB,SAAS;IACT,WAAW;IACX,kBAAkB;IAClB,kBAAkB;IAClB,YAAY;IACZ,uBAAuB;IACvB,0BAA0B;IAC1B,iDAAiD;IACjD,eAAe;IACf,gBAAgB;IAChB,eAAe;IACf,gBAAgB;IAChB,qBAAqB;AACzB;;AAEA;;IAEI,mBAAmB;IACnB,WAAW;AACf;;AAEA,uBAAuB;AACvB;IACI,aAAa;AACjB;;AAEA;IACI,aAAa;IACb,iBAAiB;IACjB,kBAAkB;AACtB;;AAEA;IACI,yBAAyB;IACzB,WAAW;IACX,gBAAgB;AACpB;;AAEA;IACI,yBAAyB;IACzB,mBAAmB;IACnB,aAAa;IACb,+BAA+B;IAC/B,YAAY;IACZ,yBAAyB;AAC7B;;AAEA;IACI,mEAAmE;IACnE,2BAA2B;AAC/B;;AAEA;IACI,eAAe;AACnB;;AAEA;IACI,yBAAyB;IACzB,iBAAiB;IACjB,oBAAoB;IACpB,uBAAuB;IACvB,oBAAoB;IACpB,mBAAmB;IACnB,uBAAuB;IACvB,eAAe;IACf,gBAAgB;IAChB,iBAAiB;IACjB,eAAe;IACf,0BAA0B;IAC1B,6BAA6B;IAC7B,yBAAyB;IACzB,eAAe;AACnB;;AAEA;IACI,eAAe;IACf,gBAAgB;IAChB,0BAA0B;IAC1B,qCAAqC;IACrC,yBAAyB;IACzB,YAAY;AAChB;;AAEA;IACI,+BAA+B;IAC/B,0BAA0B;IAC1B,iCAAiC;AACrC;;AAEA;IACI,cAAc;AAClB;;AAEA;IACI,oBAAoB;IACpB,mBAAmB;IACnB,QAAQ;IACR,iBAAiB;IACjB,kBAAkB;IAClB,eAAe;IACf,eAAe;IACf,gBAAgB;IAChB,mBAAmB;IACnB,iBAAiB;IACjB,+BAA+B;IAC/B,qCAAqC;IACrC,wBAAwB;AAC5B;;AAEA;IACI,wCAAwC;IACxC,mCAAmC;IACnC,cAAc;AAClB;;AAEA,2BAA2B;;AAE3B;IACI,kBAAkB;IAClB,qBAAqB;IACrB,SAAS;IACT,gBAAgB;IAChB,+BAA+B;IAC/B,2BAA2B;IAC3B,+BAA+B;IAC/B,mBAAmB;IACnB,2CAA2C;IAC3C,YAAY;IACZ,gBAAgB;AACpB;;AAEA;IACI,gBAAgB;IAChB,sCAAsC;IACtC,iBAAiB;IACjB,gBAAgB;AACpB;;AAEA;IACI,iBAAiB;IACjB,+BAA+B;AACnC;;AAEA;IACI,WAAW;IACX,gBAAgB;IAChB,iBAAiB;IACjB,uBAAuB;IACvB,oBAAoB;IACpB,kBAAkB;IAClB,0BAA0B;IAC1B,kBAAkB;IAClB,kBAAkB;IAClB,eAAe;IACf,eAAe;IACf,gBAAgB;IAChB,0BAA0B;IAC1B,aAAa;IACb,mBAAmB;IACnB,QAAQ;IACR,iDAAiD;AACrD;;AAEA;IACI,gBAAgB;AACpB;;AAEA;;IAEI,mBAAmB;IACnB,0BAA0B;AAC9B;;AAEA;;;;IAII,0BAA0B;AAC9B;;AAEA;;IAEI,+BAA+B;AACnC;;;AAGA;IACI,SAAY;IACZ,cAAc;IACd,gBAAgB;AACpB;;AAEA;IACI,cAAc;IACd,gBAAgB;IAChB,uBAAuB;IACvB,mBAAmB;AACvB;;AAEA;IACI,cAAc;IACd,eAAe;IACf,gBAAgB;IAChB,uBAAuB;IACvB,mBAAmB;AACvB;;;;;AAKA;IACI,qBAAqB;IACrB,eAAe;IACf,gBAAgB;IAChB,gBAAgB;IAChB,0BAA0B;IAC1B,6BAA6B;IAC7B,yBAAyB;IACzB,kBAAkB;IAClB,qCAAqC;IACrC,YAAY;;AAEhB;;AAEA;IACI,aAAa;IACb;;4CAEwC;AAC5C;;AAEA;IACI,cAAc;IACd,gBAAgB;IAChB,qBAAqB;IACrB,yBAAyB;IACzB,cAAc;IACd,gBAAgB;IAChB,mCAAmC;IACnC,yCAAyC;IACzC,kBAAkB;IAClB,mBAAmB;AACvB;;AAEA;IACI,iBAAiB;IACjB,6BAA6B;IAC7B,gBAAgB;AACpB;;AAEA;IACI,qBAAqB;IACrB,gBAAgB;IAChB,oBAAoB;IACpB,4BAA4B;AAChC;AACA;IACI,qBAAqB;IACrB,gBAAgB;IAChB,oBAAoB;IACpB,4BAA4B;IAC5B,kBAAkB;AACtB;;AAEA;IACI,YAAY;IACZ,0BAA0B;IAC1B,uBAAuB;IACvB,oBAAoB;IACpB,mBAAmB;IACnB,uBAAuB;IACvB,QAAQ;IACR,eAAe;AACnB;;AAEA;IACI;mBACe;AACnB;;AAEA;IACI,QAAQ;AACZ;;AAEA;IACI,WAAW;IACX,kBAAkB;AACtB;;AAEA;IACI,mCAAmC;IACnC,qBAAqB;IACrB,mBAAmB;IACnB,WAAW;IACX,YAAY;IACZ,oBAAoB;IACpB,mBAAmB;IACnB,uBAAuB;IACvB,0BAA0B;IAC1B,yBAAyB;;AAE7B;;AAEA;IACI,aAAa;IACb,mBAAmB;IACnB,SAAS;AACb;;AAEA;IACI,sBAAsB;AAC1B;;AAEA;IACI,yBAAyB;IACzB,YAAY;IACZ,mBAAmB;IACnB,gBAAgB;IAChB,WAAW;IACX,YAAY;IACZ,kBAAkB;IAClB,aAAa;AACjB;;AAEA;IACI,eAAe;IACf,gBAAgB;IAChB,iBAAiB;IACjB,0BAA0B;IAC1B,6BAA6B;AACjC;;AAEA;;IAEI,kBAAkB;AACtB;;AAEA;;IAEI,kBAAkB;IAClB,UAAU;IACV,SAAS;AACb;;AAEA;IACI,QAAQ;AACZ;;AAEA;IACI,yBAAyB;IACzB,aAAa;IACb,kBAAkB;IAClB,uBAAuB;IACvB,mBAAmB;IACnB,aAAa;IACb,eAAe;AACnB;;AAEA;IACI,SAAS;AACb;;AAEA;IACI,oBAAoB;IACpB,mBAAmB;IACnB,QAAQ;IACR,iBAAiB;IACjB,kBAAkB;IAClB,wCAAwC;IACxC,mCAAmC;IACnC,yBAAyB;IACzB,eAAe;IACf,eAAe;IACf,gBAAgB;IAChB,mBAAmB;IACnB,iBAAiB;AACrB;;AAEA;IACI,oBAAoB;IACpB,mBAAmB;IACnB,QAAQ;IACR,0BAA0B;IAC1B,gBAAgB;IAChB,kBAAkB;IAClB,mCAAmC;IACnC,wCAAwC;AAC5C;;AAEA;IACI,QAAQ;AACZ;;AAEA;;IAEI,kBAAkB;IAClB,qBAAqB;IACrB,UAAU;IACV,gBAAgB;IAChB,gBAAgB;IAChB,2BAA2B;IAC3B,YAAY;IACZ,mBAAmB;IACnB,yCAAyC;IACzC,YAAY;IACZ,gBAAgB;IAChB,gBAAgB;AACpB;;AAEA;;IAEI,WAAW;IACX,gBAAgB;IAChB,kBAAkB;IAClB,kBAAkB;IAClB,eAAe;IACf,eAAe;IACf,gBAAgB;IAChB,aAAa;IACb,mBAAmB;IACnB,QAAQ;IACR,YAAY;IACZ,uBAAuB;IACvB,0BAA0B;IAC1B,yBAAyB;AAC7B;;AAEA;;;;IAII,mCAAmC;IACnC,0BAA0B;AAC9B;;AAEA;;IAEI,kBAAkB;AACtB;;AAEA;IACI,oBAAoB;IACpB,mBAAmB;IACnB,QAAQ;IACR,eAAe;IACf,gBAAgB;IAChB,0BAA0B;IAC1B,gBAAgB;IAChB,kBAAkB;IAClB,mCAAmC;IACnC,wCAAwC;IACxC,mBAAmB;AACvB;;AAEA;IACI,eAAe;IACf,yBAAyB;IACzB,iBAAiB;IACjB,mBAAmB;IACnB,yBAAyB;AAC7B;;AAEA;;GAEG;AACH;;IAEI,gCAAgC;IAChC,gBAAgB;AACpB;;;AAGA;IACI,4BAA4B;AAChC;;AAEA;IACI,6BAA6B;AACjC;;AAEA;IACI,qBAAqB;IACrB,eAAe;IACf,gBAAgB;IAChB,iBAAiB;IACjB,yBAAyB;IACzB,0BAA0B;IAC1B,kBAAkB;IAClB,sBAAsB;IACtB,mBAAmB;AACvB;;AAEA;IACI,aAAa;IACb,eAAe;IACf,gBAAgB;IAChB,iBAAiB;AACrB;;AAEA;IACI,kBAAkB;AACtB;;AAEA;IACI,+BAA+B;AACnC;;AAEA;IACI,gCAAgC;AACpC;;AAEA;IACI,iBAAiB;IACjB,eAAe;IACf,gBAAgB;IAChB,iBAAiB;IACjB,kBAAkB;IAClB,oBAAoB;IACpB,mBAAmB;IACnB,uBAAuB;IACvB,eAAe;IACf,iDAAiD;IACjD,qBAAqB;IACrB,6BAA6B;IAC7B,YAAY;AAChB;;AAEA;IACI,4BAA4B;IAC5B,0BAA0B;AAC9B;;AAEA;IACI,mCAAmC;IACnC,0BAA0B;AAC9B;;AAEA;IACI,mCAAmC;IACnC,yBAAyB;AAC7B;;AAEA;IACI,sBAAsB;IACtB,kCAAkC;IAClC,uBAAuB;IACvB,YAAY;AAChB;;AAEA;IACI,YAAY;AAChB;;AAEA;IACI,kBAAkB;AACtB;;AAEA;IACI,kBAAkB;AACtB;;AAEA;IACI,oBAAoB;IACpB,mBAAmB;IACnB,gBAAgB;IAChB,oBAAoB;IACpB,eAAe;IACf,iBAAiB;IACjB,gBAAgB;IAChB,mBAAmB;IACnB,yBAAyB;IACzB,qCAAqC;IACrC,kBAAkB;AACtB;;AAEA;IACI,UAAU;IACV,WAAW;IACX,kBAAkB;IAClB,qBAAqB;IACrB,iBAAiB;AACrB;;AAEA;IACI,qBAAqB;IACrB,0BAA0B;IAC1B,qCAAqC;AACzC;;AAEA;IACI,+BAA+B;AACnC;;AAEA;IACI,cAAc;IACd,qBAAqB;IACrB,qCAAqC;AACzC;;AAEA;IACI,mBAAmB;AACvB;;AAEA;IACI,cAAc;IACd,qBAAqB;IACrB,qCAAqC;AACzC;;AAEA;IACI,mBAAmB;AACvB;;AAEA;IACI,cAAc;IACd,qBAAqB;IACrB,qCAAqC;;AAEzC;;AAEA;IACI,mBAAmB;AACvB;;AAEA;IACI,kBAAkB;IAClB,iBAAiB;IACjB,gBAAgB;AACpB;;AAEA;IACI,eAAe;IACf,gBAAgB;IAChB,WAAW;AACf;;AAEA;IACI,eAAe;IACf,0BAA0B;IAC1B,gBAAgB;AACpB;;AAEA;IACI,kBAAkB;IAClB,aAAa;IACb,sBAAsB;IACtB,mBAAmB;IACnB,SAAS;IACT,kBAAkB;IAClB,qFAAqF;IACrF,mBAAmB;IACnB,+BAA+B;IAC/B,yBAAyB;AAC7B;;AAEA;IACI,gBAAgB;IAChB,WAAW;IACX,mBAAmB;AACvB;;AAEA;IACI,6BAA6B;IAC7B,WAAW;AACf;;AAEA;IACI,yBAAyB;IACzB,YAAY;IACZ,mBAAmB;IACnB,aAAa;AACjB;;AAEA;IACI,qBAAqB;AACzB;;AAEA;IACI,kBAAkB;IAClB,iBAAiB;AACrB;;AAEA;IACI,uBAAuB;IACvB,aAAa;IACb,sBAAsB;IACtB,uBAAuB;IACvB,mBAAmB;IACnB,YAAY;IACZ,QAAQ;IACR,WAAW;IACX,yBAAyB;IACzB,aAAa;IACb,gBAAgB;IAChB,eAAe;AACnB;;AAEA;IACI,gBAAgB;IAChB,0BAA0B;IAC1B,qBAAqB;AACzB;;AAEA;IACI,eAAe;IACf,iBAAiB;IACjB,6BAA6B;IAC7B,mBAAmB;IACnB,0BAA0B;AAC9B;;AAEA;;IAEI,0BAA0B;AAC9B;;AAEA;IACI,aAAa;IACb,sBAAsB;IACtB,SAAS;IACT,mBAAmB;IACnB,iBAAiB;IACjB,gBAAgB;AACpB;;AAEA;IACI,iBAAiB;IACjB,6BAA6B;AACjC;;AAEA;IACI,qBAAqB;IACrB,aAAa;IACb,mBAAmB;IACnB,WAAW;IACX,aAAa;IACb,gBAAgB;IAChB,eAAe;IACf,mBAAmB;IACnB,kBAAkB;IAClB,eAAe;IACf,iBAAiB;IACjB,6BAA6B;IAC7B,mBAAmB;IACnB,0BAA0B;IAC1B,gBAAgB;IAChB,2BAA2B;AAC/B;;AAEA;IACI,+BAA+B;IAC/B,0BAA0B;AAC9B;;AAEA;IACI,yBAAyB;IACzB,aAAa;IACb,+BAA+B;IAC/B,mBAAmB;AACvB;;AAEA;IACI,eAAe;AACnB;;AAEA;IACI,yBAAyB;AAC7B;;AAEA;IACI,0BAA0B;AAC9B;;AAEA;IACI,eAAe;IACf,iBAAiB;IACjB,gBAAgB;IAChB,6BAA6B;IAC7B,mBAAmB;IACnB,0BAA0B;IAC1B,yBAAyB;IACzB,kBAAkB;IAClB,cAAc;AAClB;;AAEA;IACI,eAAe;IACf,0BAA0B;IAC1B,gBAAgB;IAChB,mBAAmB;AACvB;;AAEA;IACI,kBAAkB;IAClB,+BAA+B;IAC/B,WAAW;IACX,mBAAmB;IACnB,yBAAyB;IACzB,aAAa;IACb,eAAe;IACf,iBAAiB;IACjB,6BAA6B;IAC7B,mBAAmB;IACnB;AACJ;;AAEA;IACI,gBAAgB;IAChB,eAAe;AACnB;;AAEA;IACI,oCAAoC;AACxC;;AAEA;IACI,aAAa;AACjB;;AAEA;IACI,aAAa;IACb,gBAAgB;AACpB;;AAEA;IACI,YAAY;IACZ,eAAe;AACnB;;AAEA;IACI,iCAAiC;AACrC;;AAEA;IACI,gBAAgB;IAChB,mBAAmB;AACvB;;AAEA;IACI,qCAAqC;IACrC,qCAAqC;IACrC,YAAY;IACZ,kBAAkB;AACtB;;AAEA;;IAEI,qCAAqC;IACrC,sBAAsB;IACtB,eAAe;AACnB;;AAEA;IACI,aAAa;IACb,8BAA8B;IAC9B,mBAAmB;IACnB,SAAS;IACT,mBAAmB;AACvB;;AAEA;IACI,oBAAoB;IACpB,mBAAmB;IACnB,QAAQ;IACR,sBAAsB;IACtB,0BAA0B;AAC9B;;AAEA;IACI,gBAAgB;IAChB,uBAAuB;IACvB,mBAAmB;AACvB;;AAEA;IACI,gBAAgB;IAChB,kBAAkB;IAClB,6BAA6B;IAC7B,eAAe;IACf,oBAAoB;IACpB,mBAAmB;IACnB,QAAQ;IACR,0BAA0B;IAC1B,eAAe;AACnB;;AAEA;IACI,kBAAkB;IAClB,kBAAkB;IAClB,6BAA6B;IAC7B,mCAAmC;IACnC,0BAA0B;AAC9B;;AAEA;IACI,eAAe;IACf,0BAA0B;IAC1B,6BAA6B;IAC7B,iBAAiB;IACjB,eAAe;AACnB;;AAEA;IACI,aAAa;IACb,sBAAsB;IACtB,SAAS;AACb;;AAEA;IACI,oBAAoB;IACpB,mBAAmB;IACnB,QAAQ;IACR,eAAe;IACf,0BAA0B;IAC1B,YAAY;IACZ,uBAAuB;IACvB,aAAa;AACjB;;AAEA;IACI,WAAW;IACX,YAAY;IACZ,eAAe;AACnB;;AAEA;IACI,aAAa;IACb,yBAAyB;IACzB,mBAAmB;IACnB,+BAA+B;AACnC;;AAEA;IACI,0BAA0B;AAC9B;;AAEA,wBAAwB;AACxB;IACI,eAAe;IACf,UAAU;IACV,+BAA+B;IAC/B,0BAA0B;IAC1B,aAAa;IACb,aAAa;IACb,mBAAmB;IACnB,uBAAuB;IACvB,aAAa;AACjB;;AAEA;IACI,+BAA+B;IAC/B,+BAA+B;IAC/B,mBAAmB;IACnB,WAAW;IACX,gBAAgB;IAChB,gBAAgB;IAChB,cAAc;IACd,4CAA4C;AAChD;;AAEA;IACI,uBAAuB;IACvB,sCAAsC;IACtC,aAAa;IACb,uBAAuB;IACvB,8BAA8B;IAC9B,SAAS;AACb;;AAEA;IACI,kBAAkB;AACtB;;AAEA;IACI,kBAAkB;IAClB,WAAW;IACX,YAAY;IACZ,WAAW;IACX,YAAY;IACZ,mBAAmB;IACnB,eAAe;IACf,uBAAuB;IACvB,0BAA0B;IAC1B,qCAAqC;IACrC,oBAAoB;IACpB,mBAAmB;IACnB,uBAAuB;IACvB,gBAAgB;IAChB,8CAA8C;AAClD;;AAEA;IACI,+BAA+B;IAC/B,0BAA0B;IAC1B,iCAAiC;IACjC,uCAAuC;IACvC,eAAe;AACnB;;AAEA;IACI,gBAAgB;IAChB,0BAA0B;IAC1B,mBAAmB;IACnB,yBAAyB;IACzB,YAAY;IACZ,eAAe;IACf,eAAe;IACf,iBAAiB;IACjB,YAAY;AAChB;;AAEA;IACI,0BAA0B;IAC1B,qBAAqB;AACzB;;AAEA,+BAA+B;AAC/B;IACI,uBAAuB;IACvB,YAAY;IACZ,aAAa;IACb,eAAe;IACf,eAAe;AACnB;;AAEA;IACI,gBAAgB;IAChB,WAAW;AACf;;AAEA;IACI,mBAAmB;IACnB,gBAAgB;IAChB,kBAAkB;IAClB,qCAAqC;IACrC,yBAAyB;IACzB,0BAA0B;AAC9B;;AAEA;IACI,WAAW;IACX,eAAe;IACf,YAAY;IACZ,eAAe;IACf,mBAAmB;IACnB,gBAAgB;IAChB,iBAAiB;AACrB;;AAEA;IACI,iBAAiB;IACjB,yBAAyB;IACzB,mBAAmB;IACnB,oBAAoB;IACpB,mBAAmB;IACnB,uBAAuB;AAC3B;;AAEA;IACI,uBAAuB;AAC3B;;AAEA;IACI,mBAAmB;IACnB,yBAAyB;IACzB,iBAAiB;IACjB,QAAQ;AACZ;;AAEA;IACI,iBAAiB;IACjB,mBAAmB;IACnB,qBAAqB;IACrB,0BAA0B;IAC1B,eAAe;IACf,gBAAgB;IAChB,iBAAiB;IACjB,oBAAoB;IACpB,mBAAmB;IACnB,uBAAuB;AAC3B;;AAEA;IACI,gBAAgB;IAChB,WAAW;IACX,mBAAmB;AACvB;;AAEA;IACI,6BAA6B;IAC7B,WAAW;AACf;;AAEA;;IAEI,yBAAyB;IACzB,aAAa;IACb,mBAAmB;IACnB,+BAA+B;AACnC;;AAEA;IACI,aAAa;IACb,sBAAsB;IACtB,SAAS;IACT,gBAAgB;IAChB,SAAS;AACb;;AAEA;IACI,mBAAmB;IACnB,gBAAgB;IAChB,uBAAuB;IACvB,WAAW;AACf;;AAEA;IACI,8BAA8B;AAClC;;AAEA;IACI,eAAe;IACf,WAAW;AACf;;AAEA;IACI,eAAe;IACf,WAAW;AACf;;AAEA;IACI,aAAa;IACb,yBAAyB;IACzB,mBAAmB;AACvB;;AAEA;IACI,2BAA2B;IAC3B,qBAAqB;IACrB,aAAa;IACb,mBAAmB;IACnB,gBAAgB;AACpB;;;AAGA;IACI,mBAAmB;IACnB,aAAa;IACb,uBAAuB;IACvB,QAAQ;IACR,qCAAqC;IACrC,4BAA4B;IAC5B,iBAAiB;IACjB,mBAAmB;AACvB;;AAEA;IACI,0BAA0B;IAC1B,0BAA0B;AAC9B;;AAEA;IACI,4BAA4B;IAC5B,iBAAiB;IACjB,mBAAmB;IACnB,mBAAmB;AACvB;;AAEA;IACI,qBAAqB;AACzB;;AAEA;IACI,eAAe;AACnB;;AAEA;IACI,eAAe;IACf,iBAAiB;IACjB,6BAA6B;IAC7B,mBAAmB;IACnB,eAAe;IACf,0BAA0B;IAC1B,qBAAqB;AACzB;;AAEA;IACI,YAAY;AAChB;;AAEA;IACI,2BAA2B;IAC3B,aAAa;IACb,QAAQ;IACR,mBAAmB;IACnB,qBAAqB;AACzB;;AAEA;IACI,YAAY;IACZ,QAAQ;AACZ;;AAEA;IACI,oBAAoB;AACxB;;AAEA;IACI,yBAAyB;AAC7B;;AAEA;IACI,2HAA2H;IAC3H,yBAAyB;AAC7B;;AAEA;IACI,kBAAkB;IAClB,mBAAmB;IACnB,mBAAmB;AACvB;;AAEA;IACI,iBAAiB;AACrB;;AAEA,8BAA8B;AAC9B;IACI,WAAW;AACf;;AAEA,kCAAkC;AAClC;;IAEI,UAAU;AACd;;AAEA,kCAAkC;AAClC;;IAEI,cAAc;AAClB;;AAEA,kCAAkC;AAClC;;IAEI,UAAU;AACd;;AAEA,kCAAkC;AAClC;;IAEI,UAAU;AACd;;AAEA;IACI,kBAAkB;IAClB,mBAAmB;AACvB;;AAEA;IACI,mBAAmB;IACnB,aAAa;IACb,uBAAuB;IACvB,SAAS;IACT,kBAAkB;IAClB,+BAA+B;IAC/B,2BAA2B;IAC3B,mBAAmB;IACnB,eAAe;IACf,0BAA0B;IAC1B,iBAAiB;IACjB,gBAAgB;IAChB,cAAc;IACd,WAAW;IACX,iBAAiB;IACjB,kBAAkB;AACtB;;AAEA;IACI,SAAY;AAChB;;AAEA;IACI,2HAA2H;AAC/H;;AAEA;IACI,oBAAoB;IACpB,mBAAmB;IACnB,QAAQ;AACZ;;AAEA;IACI,YAAY;AAChB;;AAEA;IACI,iBAAiB;IACjB,aAAa;IACb,sBAAsB;IACtB,mBAAmB;IACnB,uBAAuB;IACvB,kBAAkB;IAClB,SAAS;IACT,aAAa;AACjB;;AAEA;IACI,kBAAkB;IAClB,SAAS;IACT,kBAAkB;IAClB,eAAe;AACnB;;AAEA;IACI,qBAAqB;IACrB,2BAA2B;IAC3B,mBAAmB;IACnB,kBAAkB;AACtB;;AAEA;IACI,iBAAiB;IACjB,WAAW;IACX,iBAAiB;IACjB,kBAAkB;IAClB,SAAS;IACT,uBAAuB;IACvB,mBAAmB;AACvB;;AAEA;IACI,WAAW;IACX,YAAY;IACZ,kBAAkB;IAClB,qBAAqB;IACrB,aAAa;IACb,mBAAmB;IACnB,uBAAuB;IACvB,eAAe;IACf,gBAAgB;IAChB,0BAA0B;IAC1B,cAAc;IACd,uBAAuB;IACvB,yBAAyB;AAC7B;;AAEA;IACI,mBAAmB;IACnB,yCAAyC;IACzC,yBAAyB;IACzB,mBAAmB;IACnB,aAAa;IACb,wCAAwC;IACxC,eAAe;IACf,iBAAiB;IACjB,cAAc;IACd,mBAAmB;IACnB,2BAA2B;AAC/B;;AAEA;IACI,oBAAoB;AACxB;;AAEA;IACI,sBAAsB;IACtB,eAAe;IACf,gBAAgB;IAChB,iBAAiB;IACjB,gBAAgB;IAChB,qCAAqC;IACrC,yBAAyB;IACzB,SAAS;AACb;;AAEA;IACI,eAAe;IACf,iBAAiB;IACjB,6BAA6B;IAC7B,mBAAmB;AACvB;;AAEA;IACI,kBAAkB;IAClB,oBAAoB;IACpB,mBAAmB;IACnB,QAAQ;AACZ;;AAEA;IACI,WAAW;IACX,qBAAqB;IACrB,UAAU;IACV,WAAW;IACX,kBAAkB;IAClB,gBAAgB;AACpB;;AAEA;IACI,0BAA0B;AAC9B;;AAEA;IACI,0BAA0B;IAC1B,eAAe;IACf,aAAa;IACb,mBAAmB;IACnB,QAAQ;AACZ;;AAEA;IACI,0BAA0B;IAC1B,gBAAgB;IAChB,qBAAqB;IACrB,mBAAmB;IACnB,yBAAyB;IACzB,gBAAgB;IAChB,qCAAqC;;AAEzC;;AAEA;IACI,0BAA0B;IAC1B,gBAAgB;IAChB,qCAAqC;IACrC,gBAAgB;IAChB,mBAAmB;IACnB,yBAAyB;IACzB,4BAA4B;AAChC;;AAEA;IACI,+BAA+B;IAC/B,uCAAuC;;AAE3C;;AAEA;IACI,iCAAiC;AACrC;;AAEA;IACI,WAAW;IACX,YAAY;IACZ,oBAAoB;IACpB,kBAAkB;AACtB;;AAEA;IACI,+BAA+B;AACnC;;AAEA;IACI,+BAA+B;AACnC;;AAEA;IACI,qBAAqB;AACzB;;AAEA;IACI,qBAAqB;;AAEzB;;AAEA;IACI,qBAAqB;;AAEzB;;AAEA;IACI,mCAAmC;IACnC,yCAAyC;IACzC,kBAAkB;IAClB,iBAAiB;IACjB,mBAAmB;IACnB,eAAe;IACf,4BAA4B;IAC5B,aAAa;IACb,mBAAmB;IACnB,QAAQ;AACZ;;AAEA;IACI,kBAAkB;IAClB,+BAA+B;IAC/B,2BAA2B;IAC3B,mBAAmB;IACnB,eAAe;IACf,0BAA0B;IAC1B,iBAAiB;IACjB,gBAAgB;AACpB;;AAEA;IACI,eAAe;IACf,QAAQ;IACR,MAAM;IACN,SAAS;IACT,uBAAuB;IACvB,aAAa;IACb,cAAc;IACd,uCAAuC;IACvC,aAAa;IACb,mBAAmB;IACnB,yBAAyB;IACzB,kBAAkB;IAClB,gBAAgB;IAChB,UAAU;AACd;;AAEA;IACI,mBAAmB;IACnB,gBAAgB;IAChB,gBAAgB;IAChB,uBAAuB;IACvB,WAAW;AACf;;AAEA;IACI,sBAAsB;IACtB,gBAAgB;IAChB,MAAM;IACN,UAAU;IACV,mBAAmB;AACvB;;AAEA;IACI,yBAAyB;IACzB,aAAa;IACb,uBAAuB;IACvB,kBAAkB;IAClB,mBAAmB;IACnB,eAAe;AACnB;;AAEA;IACI,yBAAyB;IACzB,qCAAqC;IACrC,mBAAmB;IACnB,kBAAkB;AACtB;;AAEA;IACI,WAAW;IACX,gBAAgB;IAChB,iBAAiB;IACjB,kBAAkB;IAClB,oBAAoB;AACxB;;AAEA;IACI,iBAAiB;IACjB,kBAAkB;AACtB;;AAEA;IACI,yBAAyB;IACzB,WAAW;IACX,gBAAgB;AACpB;;AAEA;IACI,yBAAyB;IACzB,+BAA+B;IAC/B,mBAAmB;IACnB,kBAAkB;IAClB,YAAY;AAChB;;AAEA;IACI,0BAA0B;IAC1B,+BAA+B;IAC/B,mBAAmB;IACnB,kBAAkB;AACtB;;AAEA;IACI,QAAQ;AACZ;;AAEA;IACI,yBAAyB;AAC7B;;AAEA;IACI,2HAA2H;AAC/H;;AAEA;IACI,gBAAgB;IAChB,mBAAmB;IACnB,2BAA2B;IAC3B,qBAAqB;IACrB,kBAAkB;IAClB,mBAAmB;AACvB;;AAEA;;IAEI,eAAe;IACf,gBAAgB;IAChB,qBAAqB;IACrB,2BAA2B;IAC3B,gBAAgB;IAChB,0BAA0B;IAC1B,gBAAgB;IAChB,YAAY;IACZ,QAAQ;AACZ;;AAEA;IACI,qBAAqB;IACrB,gBAAgB;IAChB,kBAAkB;AACtB;;AAEA;IACI,aAAa;IACb,qBAAqB;IACrB,SAAS;IACT,WAAW;IACX,eAAe;IACf,eAAe;AACnB;;AAEA;IACI,yBAAyB;IACzB,yBAAyB;IACzB,kBAAkB;IAClB,kBAAkB;IAClB,WAAW;IACX,uBAAuB;IACvB,aAAa;IACb,eAAe;IACf,yBAAyB;AAC7B;;AAEA;IACI,uBAAuB;AAC3B;;AAEA;IACI,0BAA0B;IAC1B,oCAAoC;IACpC,sBAAsB;IACtB,eAAe;IACf,gBAAgB;IAChB,kBAAkB;IAClB,eAAe;AACnB;;AAEA;IACI,0BAA0B;IAC1B,oCAAoC;IACpC,sBAAsB;IACtB,eAAe;IACf,qBAAqB;IACrB,yBAAyB;IACzB,cAAc;IACd,mBAAmB;AACvB;;AAEA;IACI,0BAA0B;IAC1B,oCAAoC;IACpC,sBAAsB;IACtB,eAAe;IACf,gBAAgB;IAChB,kBAAkB;AACtB;;AAEA;IACI,0BAA0B;IAC1B,oCAAoC;IACpC,sBAAsB;IACtB,eAAe;IACf,gBAAgB;IAChB,kBAAkB;AACtB;;AAEA;IACI,0BAA0B;IAC1B,oCAAoC;IACpC,sBAAsB;IACtB,eAAe;IACf,gBAAgB;IAChB,kBAAkB;AACtB;;AAEA;IACI,0BAA0B;IAC1B,oCAAoC;IACpC,sBAAsB;IACtB,eAAe;IACf,gBAAgB;IAChB,kBAAkB;AACtB;;AAEA;IACI,mBAAmB;IACnB,cAAc;IACd,eAAe;IACf,gBAAgB;IAChB,iBAAiB;IACjB,6BAA6B;AACjC;;AAEA;IACI,gBAAgB;IAChB,UAAU;IACV,mBAAmB;AACvB;;AAEA;IACI,uBAAuB;IACvB,cAAc;IACd,kBAAkB;IAClB,kBAAkB;IAClB,SAAS;IACT,mBAAmB;IACnB,eAAe;IACf,6BAA6B;IAC7B,0BAA0B;AAC9B;;AAEA;IACI,sBAAsB;IACtB,cAAc;IACd,WAAW;IACX,YAAY;IACZ,kBAAkB;IAClB,mBAAmB;IACnB,cAAc;IACd,aAAa;IACb,mBAAmB;IACnB,eAAe;IACf,6BAA6B;IAC7B,0BAA0B;IAC1B,kBAAkB;IAClB,OAAO;IACP,MAAM;AACV;;AAEA;IACI,kBAAkB;IAClB,mBAAmB;AACvB;;AAEA;IACI,qBAAqB;IACrB,eAAe;IACf,gBAAgB;IAChB,iBAAiB;IACjB,6BAA6B;IAC7B,0BAA0B;AAC9B;;AAEA;IACI,SAAS;IACT,0BAA0B;IAC1B,cAAc;AAClB;;AAEA;IACI,cAAc;IACd,0BAA0B;AAC9B;;AAEA;IACI,WAAW;IACX,yBAAyB;IACzB,cAAc;IACd,eAAe;IACf,6BAA6B;AACjC;;AAEA;;IAEI,yBAAyB;IACzB,gBAAgB;IAChB,gBAAgB;IAChB,mBAAmB;IACnB,0BAA0B;AAC9B;;AAEA;IACI,qBAAqB;IACrB,0BAA0B;IAC1B,gBAAgB;AACpB;;AAEA;;IAEI,+BAA+B;IAC/B,yBAAyB;IACzB,kBAAkB;IAClB,kBAAkB;IAClB,cAAc;IACd,eAAe;IACf,iBAAiB;IACjB,0BAA0B;IAC1B,qBAAqB;IACrB,sBAAsB;IACtB,gBAAgB;AACpB;;AAEA;IACI,SAAS;AACb;;AAEA;IACI,gCAAgC;IAChC,cAAc;IACd,uBAAuB;IACvB,eAAe;IACf,0BAA0B;AAC9B;;AAEA,0EAA0E;AAC1E;;IAEI,qBAAqB;IACrB,iCAAiC;AACrC;;AAEA;IACI,gBAAgB;IAChB,mBAAmB;AACvB;;AAEA;IACI,QAAQ;AACZ;;AAEA;IACI,4BAA4B;IAC5B,iBAAiB;IACjB,mBAAmB;AACvB;;AAEA;IACI,0BAA0B;IAC1B,gBAAgB;IAChB,iBAAiB;IACjB,QAAQ;AACZ;;AAEA;;IAEI,yBAAyB;IACzB,mBAAmB;IACnB,aAAa;IACb,+BAA+B;AACnC;;AAEA;IACI,wBAAwB;IACxB,iBAAiB;AACrB;;AAEA;IACI,kBAAkB;AACtB;;AAEA;IACI,gBAAgB;AACpB;;AAEA;IACI,aAAa;IACb,uBAAuB;IACvB,YAAY;IACZ;yBACqB;IACrB,eAAe;AACnB;;AAEA,qEAAqE;AACrE;;;;;;;wEAOwE;;AAExE;IACI,iBAAiB;IACjB,oBAAoB;IACpB,mBAAmB;IACnB,QAAQ;IACR,cAAc;AAClB;;AAEA;IACI,eAAe;IACf,gBAAgB;IAChB,iBAAiB;IACjB,6BAA6B;IAC7B,0BAA0B;IAC1B,yBAAyB;IACzB,sBAAsB;IACtB,mBAAmB;AACvB;;AAEA;IACI,oBAAoB;IACpB,mBAAmB;IACnB,QAAQ;IACR,gBAAgB;IAChB,iBAAiB;IACjB,kBAAkB;IAClB,qCAAqC;IACrC,+BAA+B;IAC/B,0BAA0B;IAC1B,eAAe;IACf,eAAe;IACf,gBAAgB;IAChB,6BAA6B;IAC7B,iBAAiB;IACjB,mBAAmB;IACnB,0BAA0B;AAC9B;;AAEA;IACI,eAAe;AACnB;;AAEA;IACI,uBAAuB;IACvB,qBAAqB;IACrB,0BAA0B;AAC9B;;AAEA;IACI,uBAAuB;IACvB,qBAAqB;IACrB,0BAA0B;AAC9B;;AAEA;IACI,iCAAiC;IACjC,qCAAqC;AACzC;;AAEA;IACI,gBAAgB;IAChB,uBAAuB;IACvB,mBAAmB;AACvB;;AAEA;IACI,kBAAkB;IAClB,qBAAqB;IACrB,UAAU;IACV,gBAAgB;IAChB,+BAA+B;IAC/B,qCAAqC;IACrC,mBAAmB;IACnB,6CAA6C;IAC7C,YAAY;IACZ,gBAAgB;AACpB;;AAEA;IACI,gBAAgB;IAChB,iBAAiB;IACjB,gBAAgB;AACpB;;AAEA;IACI,WAAW;IACX,gBAAgB;IAChB,iBAAiB;IACjB,YAAY;IACZ,kBAAkB;IAClB,uBAAuB;IACvB,eAAe;IACf,aAAa;IACb,mBAAmB;IACnB,QAAQ;IACR,0BAA0B;IAC1B,mDAAmD;AACvD;;AAEA;;IAEI,qBAAqB;IACrB,0BAA0B;AAC9B;;AAEA;IACI,+BAA+B;IAC/B,iCAAiC;AACrC;;AAEA;;IAEI,+BAA+B;AACnC;;AAEA;IACI,cAAc;IACd,0BAA0B;AAC9B;;AAEA;IACI,cAAc;IACd,eAAe;IACf,0BAA0B;AAC9B;;AAEA;;IAEI,0BAA0B;AAC9B;;AAEA;IACI,YAAY;IACZ,gBAAgB;AACpB;;AAEA;;IAEI,gBAAgB;IAChB,uBAAuB;IACvB,mBAAmB;AACvB;;AAEA;IACI,WAAW;IACX,gBAAgB;IAChB,iBAAiB;IACjB,YAAY;IACZ,yCAAyC;IACzC,qBAAqB;IACrB,eAAe;IACf,eAAe;IACf,gBAAgB;IAChB,6BAA6B;IAC7B,0BAA0B;IAC1B,aAAa;IACb,mBAAmB;IACnB,QAAQ;IACR,mDAAmD;AACvD;;AAEA;IACI,+BAA+B;IAC/B,0BAA0B;AAC9B;;AAEA;IACI,iBAAiB;IACjB,yCAAyC;AAC7C;;;AAGA,sBAAsB;AACtB;IACI,kBAAkB;AACtB;;AAEA;IACI,oBAAoB;AACxB;;AAEA;IACI,cAAc;IACd,eAAe;IACf,uBAAuB;IACvB,qBAAqB;IACrB,kBAAkB;AACtB;;AAEA;IACI,aAAa;IACb,8BAA8B;IAC9B,mBAAmB;AACvB;;AAEA;IACI,gBAAgB;AACpB;;AAEA;IACI,iBAAiB;AACrB;;AAEA;IACI,eAAe;IACf,gBAAgB;AACpB;;AAEA;IACI,iBAAiB;AACrB;;AAEA;IACI,aAAa;IACb,mBAAmB;IACnB,8BAA8B;IAC9B,WAAW;IACX,eAAe;AACnB;;AAEA;IACI,aAAa;AACjB;;AAEA;IACI,aAAa;AACjB;;AAEA;IACI,aAAa;IACb,mBAAmB;IACnB,8BAA8B;AAClC;;AAEA;;IAEI,aAAa;AACjB;;AAEA;IACI,uBAAuB;IACvB,YAAY;AAChB;AACA;IACI,UAAU;AACd;AACA;IACI,YAAY;IACZ,OAAO;AACX;;AAEA;IACI,WAAW;IACX,YAAY;AAChB;AACA;IACI,wBAAwB;IACxB,qBAAqB;IACrB,yDAAsT;IACtT,4BAA4B;IAC5B,wCAAwC;IACxC,0BAA0B;IAC1B,mBAAmB;AACvB;;AAEA,iCAAiC;;;;;AAKjC;IACI;QACI,yBAAyB;QACzB,WAAW;IACf;;IAEA;;QAEI,eAAe;IACnB;;IAEA;;QAEI,eAAe;IACnB;;IAEA;QACI,aAAa;IACjB;;IAEA;;QAEI,eAAe;QACf,WAAW;IACf;;IAEA;;QAEI,aAAa;IACjB;;IAEA;;QAEI,WAAW;QACX,eAAe;IACnB;;IAEA;QACI,eAAe;IACnB;;IAEA;;QAEI,eAAe;QACf,WAAW;IACf;;IAEA;QACI,WAAW;QACX,uBAAqB;IACzB;;IAEA;QACI,eAAe;QACf,kCAAkC;QAClC,sBAAsB;QACtB,aAAa;IACjB;;IAEA;QACI,eAAe;IACnB;;IAEA;QACI,eAAe;QACf,iBAAiB;IACrB;;IAEA;QACI,eAAe;QACf,iBAAiB;IACrB;;IAEA;QACI,eAAe;QACf,iBAAiB;IACrB;;IAEA;QACI,eAAe;QACf,iBAAiB;IACrB;;IAEA;QACI,eAAe;QACf,iBAAiB;IACrB;;IAEA;QACI,eAAe;QACf,iBAAiB;IACrB;;IAEA;QACI,eAAe;QACf,gBAAgB;IACpB;;IAEA;;QAEI,eAAe;QACf,YAAY;IAChB;;IAEA;QACI,aAAa;IACjB;;IAEA;QACI,SAAS;IACb;;IAEA;QACI,eAAe;QACf,aAAa;IACjB;;IAEA;QACI,gBAAgB;IACpB;;;;AAIJ;;AAEA;IACI;QACI,iBAAiB;IACrB;;IAEA;QACI,SAAS;IACb;AACJ;;AAEA;IACI;QACI,yBAAyB;QACzB,WAAW;IACf;;IAEA;QACI,eAAe;IACnB;;;AAGJ;;AAEA;IACI;QACI,eAAe;IACnB;;IAEA;;QAEI,eAAe;IACnB;;IAEA;QACI,aAAa;IACjB;;IAEA;QACI,mBAAmB;IACvB;;IAEA;QACI,aAAa;IACjB;;AAEJ;;AAEA;IACI;QACI,cAAc;QACd,gBAAgB;QAChB,SAAS;QACT,UAAU;QACV,eAAe;IACnB;;;IAGA;QACI,qBAAqB;IACzB;;IAEA;;;;;QAKI,aAAa;IACjB;;IAEA;QACI,QAAQ;QACR,wBAAwB;IAC5B;;IAEA;QACI,uBAAuB;IAC3B;;IAEA;QACI,iBAAiB;QACjB,eAAe;IACnB;AACJ;;AAEA;IACI;QACI,2BAA2B;IAC/B;;IAEA;QACI,kBAAkB;IACtB;AACJ;;AAEA;IACI;QACI,gBAAgB;QAChB,YAAY;QACZ,iBAAiB;IACrB;AACJ;;AAEA;IACI;QACI,iBAAiB;IACrB;AACJ;;AAEA;IACI;QACI,YAAY;IAChB;;IAEA;QACI,yBAAyB;IAC7B;;IAEA;QACI,mBAAmB;IACvB;;IAEA;QACI,aAAa;IACjB;;;AAGJ;;AAEA;;IAEI;;QAEI,UAAU;IACd;AACJ;;AAEA;IACI;QACI,eAAe;QACf,iBAAiB;IACrB;;IAEA;QACI,eAAe;QACf,iBAAiB;IACrB;;IAEA;QACI,gBAAgB;QAChB,eAAe;IACnB;;IAEA;QACI,cAAc;IAClB;;IAEA;QACI,eAAe;QACf,MAAM;QACN,OAAO;QACP,SAAS;QACT,YAAY;QACZ,aAAa;QACb,gBAAgB;QAChB,4BAA4B;QAC5B,0BAA0B;IAC9B;;IAEA;QACI,wBAAwB;IAC5B;;IAEA;QACI,aAAa;IACjB;;IAEA;;QAEI,eAAe;IACnB;;IAEA;QACI,kBAAkB;IACtB;;IAEA;QACI,eAAe;QACf,MAAM;QACN,OAAO;QACP,SAAS;QACT,YAAY;QACZ,aAAa;QACb,4BAA4B;QAC5B,0BAA0B;IAC9B;;IAEA;QACI,wBAAwB;IAC5B;;IAEA;QACI,eAAe;QACf,QAAQ;QACR,6BAA6B;QAC7B,UAAU;IACd;;;IAGA;QACI,cAAc;QACd,WAAW;QACX,aAAa;IACjB;;IAEA;QACI,8BAA8B;IAClC;;IAEA;;QAEI,WAAW;IACf;;IAEA;QACI,WAAW;IACf;;IAEA;QACI,eAAe;IACnB;;;IAGA;QACI,aAAa;IACjB;;;IAGA;QACI,sBAAsB;QACtB,SAAS;IACb;;IAEA;QACI,kBAAkB;QAClB,2BAA2B;IAC/B;;IAEA;QACI,iBAAiB;IACrB;;IAEA;;QAEI,eAAe;IACnB;;IAEA;QACI,iBAAiB;IACrB;;IAEA;QACI,WAAW;IACf;;IAEA;QACI,eAAe;IACnB;;IAEA;QACI,cAAc;IAClB;AACJ;;AAEA;IACI;QACI,QAAQ;IACZ;;IAEA;QACI,gBAAgB;QAChB,iBAAiB;IACrB;;IAEA;QACI,gBAAgB;QAChB,OAAO;IACX;;IAEA;QACI,YAAY;IAChB;;IAEA;QACI,kBAAkB;QAClB,gBAAgB;IACpB;;IAEA;QACI,8BAA8B;IAClC;;IAEA;QACI,WAAW;IACf;;IAEA;QACI,aAAa;IACjB;;IAEA;QACI,UAAU;QACV,yBAAyB;IAC7B;;IAEA;QACI,cAAc;QACd,WAAW;IACf;;IAEA;QACI,cAAc;QACd,WAAW;IACf;;IAEA;QACI,mBAAmB;QACnB,iBAAiB;QACjB,mBAAmB;IACvB;AACJ;;AAEA;IACI;QACI,eAAe;QACf,iBAAiB;IACrB;;IAEA;QACI,aAAa;IACjB;;IAEA;;QAEI,eAAe;IACnB;;IAEA;QACI,oBAAoB;IACxB;;IAEA;QACI,WAAW;IACf;;IAEA;QACI,2BAA2B;IAC/B;;IAEA;QACI,cAAc;QACd,gBAAgB;IACpB;;IAEA;QACI,aAAa;IACjB;;IAEA;QACI,eAAe;IACnB;;IAEA;QACI,eAAe;QACf,YAAY;IAChB;;IAEA;QACI,WAAW;IACf;;IAEA;QACI,aAAa;IACjB;;;AAGJ;;AAEA;IACI;QACI,QAAQ;IACZ;;IAEA;QACI,WAAW;QACX,YAAY;IAChB;;IAEA;;QAEI,cAAc;IAClB;;;AAGJ","sourcesContent":["/* ###------------------CSS BASED ON FIGMA START-------------------### */\n* {\n    padding: 0;\n    margin: 0;\n    box-sizing: border-box;\n}\n\nbody {\n    font-family: \"Inter\", sans-serif;\n    margin: 0px;\n    background: var(--color-FDFCFA);\n}\n\nhtml {\n    scroll-behavior: smooth;\n}\n\nhtml,\nbody,\ndiv,\nspan,\napplet,\nobject,\niframe,\nh1,\nh2,\nh3,\nh4,\nh5,\nh6,\np,\nblockquote,\npre,\na,\nabbr,\nacronym,\naddress,\nbig,\ncite,\ncode,\ndel,\ndfn,\nem,\nimg,\nins,\nkbd,\nq,\ns,\nsamp,\nsmall,\nstrike,\nstrong,\nsub,\nsup,\ntt,\nvar,\nb,\nu,\ni,\ncenter,\ndl,\ndt,\ndd,\nol,\nul,\nli,\nfieldset,\nform,\nlabel,\nlegend,\ntable,\ncaption,\ntbody,\ntfoot,\nthead,\ntr,\nth,\ntd,\narticle,\naside,\ncanvas,\ndetails,\nembed,\nfigure,\nfigcaption,\nfooter,\nheader,\nhgroup,\nmenu,\nnav,\noutput,\nruby,\nsection,\nsummary,\ntime,\nmark,\naudio,\nvideo {\n    margin: 0;\n    padding: 0;\n    border: 0;\n    font-size: 100%;\n    font: inherit;\n    vertical-align: baseline;\n    font-family: var(--fontInter);\n}\n\nol,\nul {\n    list-style-type: none;\n    padding: 0;\n    margin: 0;\n}\n\na {\n    text-decoration: none !important;\n}\n\nimg {\n    vertical-align: middle;\n}\n\nhtml,\nbody {\n    overflow-x: clip;\n    scrollbar-gutter: stable;\n}\n\n:root {\n\n    --fontInter: \"Inter\", sans-serif;\n    --fontSpaceGroTesk: \"Space Grotesk\", sans-serif;\n    --fontJetBrainsMono: \"JetBrains Mono\", monospace;\n    --color-E57600: #E57600;\n    --color-E5760014: #E5760014;\n    --color-0E1218: #0E1218;\n    --color-5F636A: #5F636A;\n    --color-FDFCFA: #FDFCFA;\n    --color-0069A8: #0069A8;\n    --color-007A55: #007A55;\n    --color-24A965: #24A965;\n    --color-ECAA0B: #ECAA0B;\n    --color-a78bfa: #a78bfa;\n    --color-D4D2D2: #D4D2D2;\n    --color-161616: #161616;\n    --color-1A1A1A: #1A1A1A;\n    --color-5F6567: #5F6567;\n    --color-EFEFEF: #EFEFEF;\n    --color-ffffff: #ffffff;\n    --color-E7E4E0: #E7E4E0;\n    --color-06b6d4: #06b6d4;\n    --color-F5F3F0: #F5F3F0;\n    --color-E52F0F: #E52F0F;\n    --orange-bg: #E5760014;\n    --success-bg: #24A9651A;\n    --failed-bg: #ef444414;\n    --info-bg: #3b82f61a;\n    --darkGreen-bg: #007A551A;\n\n}\n\n* {\n    scrollbar-width: auto;\n    scrollbar-color: var(--color-E57600);\n}\n\n\n/* ## common css ## */\n::-webkit-scrollbar {\n    width: 5px;\n    height: 6px;\n    border-radius: 5px;\n}\n\n::-webkit-scrollbar-thumb {\n    background: var(--color-E57600);\n    border-radius: 6px;\n}\n\n::-webkit-scrollbar-thumb:hover {\n    background: var(--color-E57600) !important;\n}\n\n::-webkit-scrollbar-track {\n    background: var(--color-ffffff);\n}\n\n/* ############## Heading css class Start ##############*/\n\n.h1 {\n    font-size: 34px;\n    line-height: 41px;\n    font-family: var(--fontSpaceGroTesk);\n    letter-spacing: -0.85px;\n}\n\n.h2 {\n    font-size: 30px;\n    line-height: 36px;\n    font-family: var(--fontSpaceGroTesk);\n    letter-spacing: -0.75px;\n}\n\n.h3 {\n    font-size: 24px;\n    line-height: 32px;\n    font-family: var(--fontSpaceGroTesk);\n    letter-spacing: -0.6px;\n}\n\n.h4 {\n    font-size: 16px;\n    line-height: 24px;\n    font-family: var(--fontSpaceGroTesk);\n    letter-spacing: -0.38px;\n}\n\n.fb__20 {\n    font-size: 20px;\n    line-height: 30px;\n    font-family: var(--fontSpaceGroTesk);\n    letter-spacing: -0.6px;\n}\n\n.fb__16 {\n    font-size: 16px;\n    line-height: 20px;\n    font-family: var(--fontInter);\n    letter-spacing: 0px;\n}\n\n.fb__14 {\n    font-size: 14px;\n    line-height: 18px;\n    font-family: var(--fontInter);\n    letter-spacing: 0px;\n}\n\n.fb__13 {\n    font-size: 13px;\n    line-height: 20px;\n    font-family: var(--fontInter);\n    letter-spacing: 0px;\n}\n\n.fb__12 {\n    font-size: 12px;\n    line-height: 16px;\n    font-family: var(--fontInter);\n    letter-spacing: 0px;\n}\n\n.fb__11 {\n    font-size: 11px;\n    line-height: 16px;\n    font-family: var(--fontInter);\n    letter-spacing: 0px;\n}\n\n.fb__10 {\n    font-size: 10px;\n    line-height: 16px;\n    font-family: var(--fontInter);\n    letter-spacing: 0px;\n}\n\np {\n    font-family: var(--fontInter);\n}\n\n.wrapper__container__1010 {\n    max-width: 1040px;\n    width: 100%;\n    margin-left: auto;\n    margin-right: auto;\n    padding: 0px 15px;\n}\n\n/* ############## Heading css class End ##############*/\n\n/* ############## color css class start ##############*/\n.fc__E57600 {\n    color: var(--color-E57600);\n}\n\n.fc__0E1218 {\n    color: var(--color-0E1218);\n}\n\n.fc__5F636A {\n    color: var(--color-5F636A);\n}\n\n.fc__FDFCFA {\n    color: var(--color-FDFCFA);\n}\n\n.fc__0069A8 {\n    color: var(--color-0069A8);\n}\n\n.fc__007A55 {\n    color: var(--color-007A55);\n}\n\n.fc__ECAA0B {\n    color: var(--color-ECAA0B);\n}\n\n.fc__D4D2D2 {\n    color: var(--color-D4D2D2);\n}\n\n.fc__161616 {\n    color: var(--color-161616);\n}\n\n.fc__1A1A1A {\n    color: var(--color-1A1A1A);\n}\n\n.fc__5F6567 {\n    color: var(--color-5F6567);\n}\n\n.fc__FFFFFF {\n    color: var(--color-ffffff);\n}\n\n.fc__EFEFEF {\n    color: var(--color-EFEFEF);\n}\n\n.fc__06b6d4 {\n    color: var(--color-06b6d4);\n}\n\n.fc__E52F0F {\n    color: var(--color-E52F0F);\n}\n\n/* ############## color css class End ##############*/\n\n\n/* ############## Back ground color css class start ##############*/\n.bg__E57600 {\n    background-color: var(--color-E57600);\n}\n\n.bg__0E1218 {\n    background-color: var(--color-0E1218);\n}\n\n.bg__5F636A {\n    background-color: var(--color-5F636A);\n}\n\n.bg__FDFCFA {\n    background-color: var(--color-FDFCFA);\n}\n\n.bg__0069A8 {\n    background-color: var(--color-0069A8);\n}\n\n.bg__007A55 {\n    background-color: var(--color-007A55);\n}\n\n.bg__ECAA0B {\n    background-color: var(--color-ECAA0B);\n}\n\n.bg__D4D2D2 {\n    background-color: var(--color-D4D2D2);\n}\n\n.bg__161616 {\n    background-color: var(--color-161616);\n}\n\n.bg__1A1A1A {\n    background-color: var(--color-1A1A1A);\n}\n\n.bg__5F6567 {\n    background-color: var(--color-5F6567);\n}\n\n.bg__FFFFFF {\n    background-color: var(--color-ffffff);\n}\n\n.bg__EFEFEF {\n    background-color: var(--color-EFEFEF);\n}\n\n.bg__E5760014 {\n    background-color: var(--color-E5760014);\n}\n\n.bg__F5F3F0 {\n    background-color: var(--color-F5F3F0);\n}\n\n/* ############## Back ground color css class End ##############*/\n\n/* ## common fonts weights ## */\n.fw__300 {\n    font-weight: 300 !important;\n}\n\n.fw__400 {\n    font-weight: 400 !important;\n}\n\n.fw__500 {\n    font-weight: 500 !important;\n}\n\n.fw__600 {\n    font-weight: 600 !important;\n}\n\n.fw__700 {\n    font-weight: 700 !important;\n}\n\n.fw__800 {\n    font-weight: 800 !important;\n}\n\n/* ## common spacing ## */\n\n/* Margin Common Css Class Start */\n.mlr__5 {\n    margin-left: 5px;\n    margin-right: 5px;\n}\n\n.mb__0 {\n    margin-bottom: 0;\n}\n\n.mb__2 {\n    margin-bottom: 2px;\n}\n\n.mb__4 {\n    margin-bottom: 4px;\n}\n\n.mb__6 {\n    margin-bottom: 6px;\n}\n\n.mb__8 {\n    margin-bottom: 8px;\n}\n\n.mb__10 {\n    margin-bottom: 10px;\n}\n\n.mb__12 {\n    margin-bottom: 12px;\n}\n\n.mb__14 {\n    margin-bottom: 14px;\n}\n\n.mb__16 {\n    margin-bottom: 16px;\n}\n\n.mb__17 {\n    margin-bottom: 17px;\n}\n\n.mb__18 {\n    margin-bottom: 18px;\n}\n\n.mb__20 {\n    margin-bottom: 20px;\n}\n\n.mb__21 {\n    margin-bottom: 21px;\n}\n\n.mb__22 {\n    margin-bottom: 22px;\n}\n\n.mb__24 {\n    margin-bottom: 24px;\n}\n\n.mb__25 {\n    margin-bottom: 25px\n}\n\n.mb__26 {\n    margin-bottom: 26px\n}\n\n.mb__28 {\n    margin-bottom: 28px\n}\n\n.mb__30 {\n    margin-bottom: 30px;\n}\n\n.mb__32 {\n    margin-bottom: 32px;\n}\n\n.mb__40 {\n    margin-bottom: 40px;\n}\n\n.mb__44 {\n    margin-bottom: 44px;\n}\n\n.mb__50 {\n    margin-bottom: 50px;\n}\n\n.mb__52 {\n    margin-bottom: 52px;\n}\n\n.mb__60 {\n    margin-bottom: 60px;\n}\n\n.mb__64 {\n    margin-bottom: 64px;\n}\n\n.mb__70 {\n    margin-bottom: 70px;\n}\n\n.mb__80 {\n    margin-bottom: 80px;\n}\n\n.mb__102 {\n    margin-bottom: 102px;\n}\n\n.mr__4 {\n    margin-right: 4px;\n}\n\n.mr__12 {\n    margin-right: 12px;\n}\n\n.mr__14 {\n    margin-right: 14px;\n}\n\n.mr__16 {\n    margin-right: 16px;\n}\n\n.mr__18 {\n    margin-right: 18px;\n}\n\n.mt__4 {\n    margin-top: 4px;\n}\n\n.mt__8 {\n    margin-top: 8px;\n}\n\n.mt__9 {\n    margin-top: 9px;\n}\n\n.mt__5 {\n    margin-top: 5px;\n}\n\n.mt__16 {\n    margin-top: 16px;\n}\n\n.mt__18 {\n    margin-top: 18px;\n}\n\n.mt__24 {\n    margin-top: 24px;\n}\n\n.mt__38 {\n    margin-top: 38px;\n}\n\n.mt__40 {\n    margin-top: 40px;\n}\n\n.mt__44 {\n    margin-top: 44px;\n}\n\n.ml__12 {\n    margin-left: 12px;\n}\n\n.ml__18 {\n    margin-left: 18px;\n}\n\n.text__center {\n    text-align: center;\n}\n\n.transform__none {\n    text-transform: none !important;\n}\n\n/* Padding Common Css Class End */\n.in-flex {\n    display: inline-flex !important;\n}\n\n.d-flex {\n    display: flex !important;\n}\n\n.flex-column {\n    flex-direction: column !important;\n}\n\n.flex-wrap {\n    flex-wrap: wrap !important;\n}\n\n.align-items-center {\n    align-items: center !important;\n}\n\n.justify-content-between {\n    justify-content: space-between !important;\n}\n\n.justify-content-center {\n    justify-content: center !important;\n}\n\n.flex-start {\n    justify-content: flex-start !important;\n}\n\n.flex-end {\n    justify-content: flex-end !important;\n}\n\n.flex-srink-0 {\n    flex-shrink: 0;\n}\n\n.img-fluid {\n    max-width: 100%;\n    height: auto;\n}\n\n.mx__auto {\n    margin: 0 auto;\n}\n\n.mw__672 {\n    max-width: 672px;\n    width: 100%;\n    margin-left: auto;\n    margin-right: auto;\n}\n\n.mw__230 {\n    max-width: 230px;\n}\n\n.common__btn {\n    height: 32px;\n    border-radius: 12px;\n    display: inline-flex;\n    align-items: center;\n    justify-content: center;\n    padding: 8px 16px;\n    font-size: 14px;\n    line-height: 24px;\n    font-family: var(--fontInter);\n    font-weight: 600;\n    color: var(--color-ffffff);\n    transition: all 0.3s ease;\n    cursor: pointer;\n    outline: none;\n    overflow: hidden;\n    white-space: nowrap;\n    position: relative;\n    border: none;\n    z-index: 1;\n}\n\n.common__org__btn {\n    background: var(--color-E57600);\n    color: var(--color-ffffff);\n    border: 1px solid var(--color-E57600);\n    box-shadow: 0px 6px 20px -6px #E5760080;\n}\n\n.common__org__btn:hover {\n    background: transparent;\n    color: var(--color-E57600);\n}\n\n.common__blk__btn {\n    background: var(--color-0E1218);\n    color: var(--color-ffffff);\n    border: 1px solid var(--color-0E1218);\n}\n\n.common__blk__btn:hover {\n    background: transparent;\n    color: var(--color-0E1218);\n}\n\n\n.common__transp__btn {\n    background: transparent;\n    color: var(--color-0E1218);\n    border: 1px solid var(--color-E7E4E0);\n}\n\n.common__transp__btn:hover {\n    background: var(--color-0E1218);\n    color: var(--color-ffffff);\n    border: 1px solid var(--color-0E1218);\n}\n\n.close__btn {\n    background: transparent;\n    border: none !important;\n    padding: 0px;\n    color: var(--color-0E1218);\n    width: 20px;\n    height: 20px;\n}\n\n.ntf__button__area .close__btn img,\n.close__btn img {\n    width: 12px;\n    height: 12px;\n    cursor: pointer;\n}\n\n.custom__row {\n    display: flex;\n    flex-wrap: wrap;\n}\n\n.mw__900 {\n    max-width: 900px;\n    margin-left: auto;\n    margin-right: auto;\n}\n\n.pos__rel {\n    position: relative;\n}\n\n.w__100 {\n    width: 100%;\n}\n\n.d__none {\n    display: none;\n}\n\n.d__block {\n    display: block;\n}\n\n.text__right {\n    text-align: right;\n}\n\n.gap__4 {\n    gap: 4px;\n}\n\n.gap__5 {\n    gap: 5px;\n}\n\n.gap__8 {\n    gap: 8px;\n}\n\n.gap__12 {\n    gap: 12px;\n}\n\n.gap__16 {\n    gap: 16px;\n}\n\n.gap__20 {\n    gap: 20px;\n}\n\ncode {\n    font-family: var(--fontJetBrainsMono);\n}\n\n.ff__inter {\n    font-family: var(--fontInter);\n}\n\n.ff__spaceGrotesk {\n    font-family: var(--fontSpaceGroTesk);\n}\n\n.ff__jetBrainsMono {\n    font-family: var(--fontJetBrainsMono);\n}\n\n.pos__rel {\n    position: relative;\n}\n\nbody::before,\nbody::after {\n    opacity: 0 !important;\n    visibility: hidden;\n}\n\n/* ## Login/Register Page ## */\n.login__footer {\n    position: absolute;\n    bottom: 0px;\n    left: 0px;\n    right: 0px;\n    padding: 16px 24px;\n    display: flex;\n    align-items: center;\n    justify-content: center;\n    gap: 6px;\n    flex-wrap: wrap;\n    font-size: 11px;\n    color: var(--color-FDFCFA);\n    border-top: 1px solid var(--border);\n    background: rgba(8, 17, 31, 0.6);\n    backdrop-filter: blur(12px);\n}\n\n.login__footer a:hover {\n    color: var(--color-E57600) !important;\n}\n\n.login__form input {\n    border: 1px solid rgba(6, 182, 212, 0.2);\n}\n\n.betaTag {\n    position: absolute;\n    top: -6px;\n    right: -34px;\n    background: linear-gradient(135deg, rgb(6, 182, 212), rgb(139, 92, 246));\n    color: rgb(255, 255, 255);\n    font-size: 9px;\n    font-weight: 700;\n    letter-spacing: 0.08em;\n    padding: 2px 6px;\n    border-radius: 4px;\n    text-transform: uppercase;\n    line-height: 1;\n}\n\n.login__logo__col {\n    max-width: 170px;\n    margin-left: auto;\n    margin-right: auto;\n}\n\n.sidebar__brand {\n    outline: none;\n    display: inline-flex;\n    align-items: center;\n    padding-left: 8px;\n}\n\n.wrapper__root__page {\n    min-height: 100vh;\n    display: flex;\n    align-items: center;\n    justify-content: center;\n    position: relative;\n    overflow: hidden;\n    padding-bottom: 56px;\n    background-repeat: no-repeat;\n    width: 100%;\n    background-size: cover;\n}\n\n.wrapper__login__card {\n    position: relative;\n    border-radius: 24px;\n    overflow: hidden;\n    border: 0px;\n}\n\n.wrapper__login__card::before {\n    display: none;\n}\n\n.wrapper__login__card::after {\n    content: \"\";\n    position: absolute;\n    inset: 0;\n\n    border-radius: 24px;\n\n    background: linear-gradient(270deg,\n            #06B2D0 0%,\n            #E57600 37.98%,\n            #E57600 63.46%,\n            #00F0FF 94.71%);\n\n    padding: 2px;\n\n    /* Keep only the border area */\n    -webkit-mask:\n        linear-gradient(#fff 0 0) content-box,\n        linear-gradient(#fff 0 0);\n    -webkit-mask-composite: xor;\n\n    mask:\n        linear-gradient(#fff 0 0) content-box,\n        linear-gradient(#fff 0 0);\n    mask-composite: exclude;\n\n    /* Show only top + rounded corners */\n    clip-path: inset(0 0 calc(100% - 26px) 0);\n}\n\n.wrapper__login__card .common__btn {\n    height: 45px;\n}\n\n.wrapper__app__main {\n    display: flex;\n    min-height: 100vh;\n    position: relative;\n}\n\naside.app-sidebar {\n    position: fixed;\n    height: 100%;\n    left: 0;\n    top: 0;\n    z-index: 99;\n    max-width: 257px;\n    width: 100%;\n    border-right: 1px solid #E7E4E0;\n    background: var(--color-ffffff);\n}\n\naside.app-sidebar.app-sidebar--collapsed {\n    max-width: 78px;\n}\naside.app-sidebar.app-sidebar--collapsed nav.sidebar-nav {\n    padding-top: 40px;\n}\n.wrapper__app__side__left {\n    height: 100%;\n    display: flex;\n    flex-direction: column;\n    justify-content: space-between;\n}\n\nmain.app-main {\n    max-width: calc(100% - 257px);\n    width: 100%;\n    margin-left: 257px;\n}\n\n.wrapper__side__navigation {\n    padding: 16px 8px 0px;\n\n}\n\n.sidebar-footer {\n    border-top: 1px solid #E7E4E0;\n    padding: 12px;\n\n}\n\n.site__footer {\n    border: 0px;\n    background: #E5760014;\n    padding: 18px 0;\n    width: 100%;\n    /* position: absolute;\n    right: 0;\n    z-index: 99;\n    left: 0; */\n}\n\n.site__footer__inner {\n    max-width: 1280px;\n    margin: 0 auto;\n    padding: 0 28px;\n    display: flex;\n    align-items: center;\n    justify-content: center;\n    gap: 16px;\n    flex-wrap: wrap;\n}\n\n.site__footer__inner>* {\n    color: #5F636A !important;\n    opacity: unset !important;\n}\n\n.site-footer-link:hover {\n    color: var(--color-E57600) !important;\n}\n\nnav.sidebar-nav {\n    display: flex;\n    flex-direction: column;\n    align-items: flex-start;\n}\n\nnav.sidebar-nav .sidebar-nav-item {\n    width: 100%;\n    text-align: left;\n    border: none;\n    background: transparent;\n    display: flex;\n    align-items: center;\n    padding: 10px 12px;\n    border-radius: 12px;\n    transition: all 0.3s ease;\n    cursor: pointer;\n    gap: 12px;\n    outline: none;\n    font-size: 16px;\n    font-weight: 500;\n    font-family: var(--fontInter);\n    color: var(--color-5F636A);\n}\n\nnav.sidebar-nav .sidebar-nav-item .nav__title {\n    transition: all 0.3s ease;\n}\n\n.sidebar-nav-item .total__agents {\n    background: #F5F3F0;\n    border-radius: 4px;\n    display: inline-flex;\n    align-items: center;\n    justify-content: center;\n    padding: 6px;\n    font-size: 14px;\n    font-weight: 700;\n    color: #5F636A;\n    font-family: var(--fontJetBrainsMono);\n    margin-left: auto;\n}\n\n.wrapper__sidenav__item a img {\n    width: 20px;\n    height: 20px;\n}\n\n.wrapper__sidenav__item a.active,\n.wrapper__sidenav__item a:hover {\n    background: #E5760014;\n}\n\n.wrapper__sidenav__item a.active svg {\n    filter: brightness(0) saturate(100%) invert(44%) sepia(61%) saturate(2190%) hue-rotate(10deg) brightness(99%) contrast(102%);\n}\n\n.wrapper__sidenav__item a.active .nav__title,\n.wrapper__sidenav__item a:hover .nav__title {\n    color: var(--color-E57600);\n}\n\n.wrapper__sidenav__item a.active img,\n.wrapper__sidenav__item a:hover img {\n    filter: brightness(0) saturate(100%) invert(46%) sepia(89%) saturate(2430%) hue-rotate(10deg) brightness(99%) contrast(101%);\n}\n\n.sidebar-nav-item.active .total__agents {\n    background: transparent;\n}\n\n.wrapper__common__header {\n    padding: 12px 32px;\n    border-bottom: 1px solid #E7E4E0;\n    position: sticky;\n    top: 0;\n    background: #fff;\n    z-index: 3;\n    display: flex;\n    align-items: center;\n    width: 100%;\n    gap: 15px;\n    justify-content: space-between;\n}\n\n.wrapper__right {\n    display: flex;\n    align-items: center;\n    gap: 8px;\n}\n\n.wrapper__notify__btn {\n    background: transparent;\n    outline: none;\n    border: 0px;\n    cursor: pointer;\n}\n\n.workSpace {\n    text-transform: uppercase;\n    font-size: 14px;\n    font-weight: 600;\n    line-height: 24px;\n    letter-spacing: 1.2px;\n    font-family: var(--fontInter);\n    color: #5F636AB2;\n    padding: 16px 0px 8px;\n    padding-left: 12px;\n}\n\n/* .wrapper__app__main__content {\n    height: 100%;\n} */\n\nsection.wrapper__os__mainScreen {\n    padding: 32px 0px;\n    height: 100%;\n    display: flex;\n    flex-direction: column;\n    align-items: center;\n    justify-content: center;\n}\n\n.wrapper__search__input {\n    background: radial-gradient(50% 50% at 50% 50%, rgba(229, 118, 0, 0.18) 0%, rgba(229, 118, 0, 0) 70%);\n    padding: 10px 0px 64px;\n    position: relative;\n}\n\n.wrapper__search__input input {\n    width: 100%;\n    height: 53px;\n    outline: none;\n    box-shadow: 0px 24px 60px -30px #00000040;\n    border: 1px solid #E7E4E0;\n    border-radius: 20px;\n    padding: 10px 12px;\n    font-size: 16px;\n    font-weight: 400;\n    color: var(--color-0E1218);\n    font-family: var(--fontInter);\n    padding-left: 50px;\n}\n\n.wrapper__search__input button.btn-pick-assistant {\n    position: absolute;\n    left: 12px;\n    top: 21px;\n    background: transparent;\n    border: none;\n    outline: none;\n    display: flex;\n    align-items: center;\n    cursor: pointer;\n}\n\n.breadcrumb__list {\n    display: flex;\n    align-items: center;\n}\n\n.breadcrumb__list li.breadcrumb-item a {\n    font-size: 12px;\n    font-weight: 400;\n    line-height: 22px;\n    color: var(--color-5F636A);\n    font-family: var(--fontInter);\n}\n\n.breadcrumb__list .breadcrumb-sep {\n    display: inline-block;\n    margin: 0px 6px;\n    color: #E7E4E0;\n}\n\n.breadcrumb-item .breadcrumb-current {\n    font-size: 13px;\n    font-weight: 500;\n    line-height: 20px;\n    color: var(--color-0E1218);\n    font-family: var(--fontInter);\n}\n\n.userDropdown__btn {\n    display: inline-flex;\n    align-items: center;\n    gap: 12px;\n    border: none;\n    background: transparent;\n    cursor: pointer;\n}\n\n.username__initial {\n    background: #E576001A;\n    color: var(--color-E57600);\n    padding: 8px;\n    text-transform: uppercase;\n    font-size: 14px;\n    font-weight: 600;\n    font-family: var(--fontInter);\n    line-height: 22px;\n    display: inline-flex;\n    align-items: center;\n    justify-content: center;\n    width: 32px;\n    height: 32px;\n    border-radius: 50%;\n}\n\n.grayDot {\n    background: var(--color-5F636A);\n    width: 5px;\n    height: 5px;\n    display: inline-block;\n    border-radius: 50%;\n    margin: 0px 5px;\n}\n\n.wrapper__dropdown__menu {\n    position: absolute;\n    left: 0;\n    top: calc(100% + 6px);\n    width: 220px;\n    border-radius: 12px;\n    box-shadow: 0 8px 32px rgba(0, 0, 0, 0.5);\n    z-index: 1000;\n    overflow: hidden;\n    visibility: hidden;\n    background: var(--color-ffffff);\n}\n\n.userInitial {\n    width: 36px;\n    height: 36px;\n    border-radius: 50%;\n    background: var(--gradient-btn);\n    display: flex;\n    align-items: center;\n    justify-content: center;\n    font-size: 15px;\n    font-weight: 700;\n    color: white;\n    flex-shrink: 0;\n}\n\n.fc__ellipse {\n    overflow: hidden;\n    text-overflow: ellipsis;\n    white-space: nowrap;\n}\n\n.userRole {\n    margin-top: 8px;\n}\n\n.subAdmin {\n    font-size: 10px;\n    font-weight: 700;\n    padding: 2px 8px;\n    border-radius: 5px;\n    background: rgba(167, 139, 250, 0.12);\n    border: 1px solid rgba(167, 139, 250, 0.3);\n    color: rgb(167, 139, 250);\n    text-transform: uppercase;\n    letter-spacing: 0.06em;\n}\n\n.role__badge {\n    border: 1px solid var(--color-5F636A);\n    background-color: var(--color-F5F3F0);\n    color: var(--color-5F636A);\n    font-size: 12px;\n    font-weight: 400;\n    padding: 2px 8px;\n    border-radius: 5px;\n    text-transform: uppercase;\n    letter-spacing: 0.06em;\n    font-family: var(--fontJetBrainsMono);\n}\n\n.role__badge__admin {\n    color: var(--color-ECAA0B);\n    background: rgba(245, 158, 11, 0.12);\n    border-color: rgba(245, 158, 11, 0.3);\n}\n\n.role__badge__subadmin {\n    color: var(--color-a78bfa);\n    background: rgba(167, 139, 250, 0.12);\n    border-color: rgba(167, 139, 250, 0.3);\n}\n\n.userRole span {\n    font-size: 10px;\n    font-weight: 700;\n    padding: 2px 8px;\n    border-radius: 5px;\n    text-transform: uppercase;\n    letter-spacing: 0.06em;\n}\n\n.dropdown__listing .dropdown__btn {\n    display: flex;\n    align-items: center;\n    gap: 10px;\n    width: 100%;\n    padding: 10px 16px;\n    border-radius: 0px;\n    border: none;\n    background: transparent;\n    color: var(--color-0E1218);\n    transition: background 0.1s ease, color 0.1s ease;\n    font-size: 13px;\n    font-weight: 500;\n    cursor: pointer;\n    text-align: left;\n    text-decoration: none;\n}\n\n.dropdown__listing .dropdown__btn--active,\n.dropdown__listing .dropdown__btn:hover {\n    background: #06b6d4;\n    color: #fff;\n}\n\n/* ## agent library ##*/\n.wrapper__main {\n    padding: 32px;\n}\n\n.wrapper__agents__row {\n    row-gap: 12px;\n    margin-left: -6px;\n    margin-right: -6px;\n}\n\n.wrapper__agents__col {\n    max-width: calc(100% / 4);\n    width: 100%;\n    padding: 0px 6px;\n}\n\n.wrapper__agent__card {\n    border: 1px solid #E7E4E0;\n    border-radius: 16px;\n    padding: 21px;\n    background: var(--color-ffffff);\n    height: 100%;\n    transition: all 0.3s ease;\n}\n\n.wrapper__agent__card:hover {\n    /* box-shadow: var(--shadow-md), 0 0 28px rgba(6, 182, 212, 0.1); */\n    transform: translateY(-3px);\n}\n\n.col__gap__6 {\n    column-gap: 6px;\n}\n\n.wrapper__ag__filter {\n    border: 1px solid #E7E4E0;\n    padding: 5px 11px;\n    border-radius: 100px;\n    background: transparent;\n    display: inline-flex;\n    align-items: center;\n    justify-content: center;\n    font-size: 13px;\n    font-weight: 500;\n    line-height: 20px;\n    column-gap: 4px;\n    color: var(--color-5F636A);\n    font-family: var(--fontInter);\n    transition: all 0.3s ease;\n    cursor: pointer;\n}\n\n.wrapper__ag__filter .filter__value {\n    font-size: 12px;\n    font-weight: 500;\n    color: var(--color-5F636A);\n    font-family: var(--fontJetBrainsMono);\n    transition: all 0.3s ease;\n    opacity: 70%;\n}\n\n.wrapper__ag__filter.active {\n    background: var(--color-0E1218);\n    color: var(--color-ffffff);\n    border-color: var(--color-0E1218);\n}\n\n.wrapper__ag__filter.active .filter__value {\n    color: #FDFCFA;\n}\n\n.project__run__btn {\n    display: inline-flex;\n    align-items: center;\n    gap: 6px;\n    padding: 6px 12px;\n    border-radius: 8px;\n    cursor: pointer;\n    font-size: 12px;\n    font-weight: 600;\n    white-space: nowrap;\n    transition: 0.15s;\n    border: 1px solid var(--border);\n    background: rgba(255, 255, 255, 0.04);\n    color: var(--text-muted);\n}\n\n.project__run__btn.selected {\n    border: 1px solid rgba(6, 182, 212, 0.4);\n    background: rgba(6, 182, 212, 0.08);\n    color: #06b6d4;\n}\n\n.project__run__btn.active {}\n\n.project__run__btn__dropdown {\n    position: absolute;\n    top: calc(100% + 6px);\n    left: 0px;\n    min-width: 210px;\n    background: var(--color-ffffff);\n    backdrop-filter: blur(20px);\n    border: 1px solid var(--border);\n    border-radius: 10px;\n    box-shadow: rgba(0, 0, 0, 0.5) 0px 8px 32px;\n    z-index: 100;\n    overflow: hidden;\n}\n\n.wrapper__projects__total {\n    padding: 6px 4px;\n    border-bottom: 1px solid var(--border);\n    max-height: 220px;\n    overflow-y: auto;\n}\n\n.wrapper__ProjectLimit {\n    padding: 9px 12px;\n    border-top: 1px solid #5f636a33;\n}\n\n.runProject {\n    width: 100%;\n    text-align: left;\n    padding: 7px 12px;\n    background: transparent;\n    border-width: medium;\n    border-style: none;\n    border-color: currentcolor;\n    border-image: none;\n    border-radius: 6px;\n    cursor: pointer;\n    font-size: 12px;\n    font-weight: 500;\n    color: var(--color-5F636A);\n    display: flex;\n    align-items: center;\n    gap: 8px;\n    transition: background 0.1s ease, color 0.1s ease;\n}\n\n.runProject:last-child {\n    margin-top: 10px;\n}\n\n.runProject:hover,\n.runProject.active {\n    background: #06b6d4;\n    color: var(--color-ffffff);\n}\n\n.runProject:hover .p__name,\n.runProject.active .p__name,\n.runProject:hover .p__domain__comp,\n.runProject.active .p__domain__comp {\n    color: var(--color-ffffff);\n}\n\n.runProject:hover .dots::before,\n.runProject.active .dots::before {\n    background: var(--color-ffffff);\n}\n\n\n.wrapper__inner {\n    flex: 1 1 0%;\n    min-width: 0px;\n    overflow: hidden;\n}\n\n.p__name {\n    display: block;\n    overflow: hidden;\n    text-overflow: ellipsis;\n    white-space: nowrap;\n}\n\n.p__domain__comp {\n    display: block;\n    margin-top: 1px;\n    overflow: hidden;\n    text-overflow: ellipsis;\n    white-space: nowrap;\n}\n\n\n\n\n.wrapper__ag__cardCat .wrapper__category {\n    background: #E576001A;\n    font-size: 12px;\n    font-weight: 700;\n    padding: 2px 6px;\n    color: var(--color-E57600);\n    font-family: var(--fontInter);\n    text-transform: uppercase;\n    border-radius: 4px;\n    box-shadow: 0px 0px 0px 1px #E5760026;\n    opacity: 50%;\n\n}\n\n.wrapper__ag__cardCat .wrapper__category.flt__selected {\n    opacity: 100%;\n    /* color: var(--color-0069A8);\n    background: #F0F9FF;\n    box-shadow: 0px 0px 0px 1px #B8E6FE99; */\n}\n\n.agent__beta {\n    font-size: 9px;\n    font-weight: 800;\n    letter-spacing: 0.1em;\n    text-transform: uppercase;\n    color: #f59e0b;\n    padding: 2px 7px;\n    background: rgba(245, 158, 11, 0.1);\n    border: 1px solid rgba(245, 158, 11, 0.3);\n    border-radius: 5px;\n    white-space: nowrap;\n}\n\n.wrapper__ag__footer {\n    padding-top: 12px;\n    border-top: 1px solid #EDEBE7;\n    margin-top: 20px;\n}\n\n.wrapper__agent__card .agent__desc {\n    -webkit-line-clamp: 2;\n    overflow: hidden;\n    display: -webkit-box;\n    -webkit-box-orient: vertical;\n}\n.wrapper__agent__card .agent__name {\n    -webkit-line-clamp: 1;\n    overflow: hidden;\n    display: -webkit-box;\n    -webkit-box-orient: vertical;\n    margin-bottom: 6px;\n}\n\n.agent__launch__btn {\n    border: none;\n    text-transform: capitalize;\n    background: transparent;\n    display: inline-flex;\n    align-items: center;\n    justify-content: center;\n    gap: 4px;\n    cursor: pointer;\n}\n\n.btn__arrow {\n    /* width: 14px;\n    height: 14px; */\n}\n\n.badge__category {\n    gap: 6px;\n}\n\n.badge__icon {\n    width: 12px;\n    /* height: 12px; */\n}\n\n.agent__icon__wrap {\n    box-shadow: 0px 0px 0px 1px #E7E4E0;\n    background: #FFFFFF01;\n    border-radius: 12px;\n    width: 40px;\n    height: 40px;\n    display: inline-flex;\n    align-items: center;\n    justify-content: center;\n    transition: all 0.25s ease;\n    border: 1px solid #F5F3F0;\n\n}\n\n.wrapper__ag__cardCat {\n    display: flex;\n    align-items: center;\n    gap: 10px;\n}\n\n.wrapper__execution__history__inner {\n    /* background: #000; */\n}\n\n.input__filter input {\n    border: 1px solid #E7E4E0;\n    height: 46px;\n    border-radius: 12px;\n    min-width: 256px;\n    width: 100%;\n    padding: 9px;\n    padding-left: 36px;\n    outline: none;\n}\n\n.input__filter input::-webkit-input-placeholder {\n    font-size: 12px;\n    font-weight: 700;\n    line-height: 16px;\n    color: var(--color-5F636A);\n    font-family: var(--fontInter);\n}\n\n.input__filter,\n.wrapper___status__filter {\n    position: relative;\n}\n\n.input__filter .serachIcon,\n.status__filter__btn .statusIcon {\n    position: absolute;\n    left: 12px;\n    top: 14px;\n}\n\n.wrapper__history__filter {\n    gap: 8px;\n}\n\n.status__filter__btn {\n    border: 1px solid #E7E4E0;\n    padding: 12px;\n    padding-left: 36px;\n    background: transparent;\n    border-radius: 12px;\n    outline: none;\n    cursor: pointer;\n}\n\n.status__filter__btn .statusIcon {\n    top: 15px;\n}\n\n.projectDropdown__btn {\n    display: inline-flex;\n    align-items: center;\n    gap: 6px;\n    padding: 6px 12px;\n    border-radius: 8px;\n    border: 1px solid rgba(6, 182, 212, 0.4);\n    background: rgba(6, 182, 212, 0.08);\n    color: var(--teal-bright);\n    cursor: pointer;\n    font-size: 12px;\n    font-weight: 600;\n    white-space: nowrap;\n    transition: 0.15s;\n}\n\n.recent__label {\n    display: inline-flex;\n    align-items: center;\n    gap: 4px;\n    color: var(--color-06b6d4);\n    padding: 2px 8px;\n    border-radius: 4px;\n    background: rgba(6, 182, 212, 0.08);\n    border: 1px solid rgba(6, 182, 212, 0.2);\n}\n\n.recent__left {\n    gap: 5px;\n}\n\n.wrapper__project___dropdown,\n.wrapper__s__Filter___dropdown {\n    position: absolute;\n    top: calc(100% + 6px);\n    right: 0px;\n    min-width: 180px;\n    background: #fff;\n    backdrop-filter: blur(20px);\n    border: none;\n    border-radius: 10px;\n    box-shadow: 0 8px 32px rgba(0, 0, 0, 0.5);\n    z-index: 100;\n    overflow: hidden;\n    padding: 6px 4px;\n}\n\n.p__dropdwn__btn,\n.wrapper__s__Filter___dropdown ul li {\n    width: 100%;\n    text-align: left;\n    padding: 10px 12px;\n    border-radius: 6px;\n    cursor: pointer;\n    font-size: 12px;\n    font-weight: 500;\n    display: flex;\n    align-items: center;\n    gap: 8px;\n    border: none;\n    background: transparent;\n    color: var(--color-0E1218);\n    transition: all 0.3s ease;\n}\n\nbutton.p__dropdwn__btn.active,\n.p__dropdwn__btn:hover,\n.wrapper__s__Filter___dropdown ul li:hover,\n.wrapper__s__Filter___dropdown ul li.s__Filter__active {\n    background: rgba(6, 182, 212, 0.08);\n    color: var(--color-06b6d4);\n}\n\n.p__dropdwn__btn:not(:last-child),\n.wrapper__s__Filter___dropdown ul li:not(:last-child) {\n    margin-bottom: 8px;\n}\n\n.wrapper__backlight__10__600 {\n    display: inline-flex;\n    align-items: center;\n    gap: 3px;\n    font-size: 10px;\n    font-weight: 600;\n    color: var(--color-06b6d4);\n    padding: 2px 7px;\n    border-radius: 4px;\n    background: rgba(6, 182, 212, 0.08);\n    border: 1px solid rgba(6, 182, 212, 0.2);\n    white-space: nowrap;\n}\n\n.wrapper__execution__history table {\n    margin-top: 0px;\n    border-collapse: separate;\n    border-spacing: 0;\n    border-radius: 12px;\n    border: 1px solid #E7E4E0;\n}\n\n/* .wrapper__execution__history table th:not(:last-child){\n    border-right: 1px solid #E7E4E0;\n} */\n.wrapper__execution__history table thead tr th,\n.wrapper__execution__history table tbody tr td {\n    border-bottom: 1px solid #E7E4E0;\n    background: #fff;\n}\n\n\n.wrapper__execution__history table thead tr th:first-child {\n    border-top-left-radius: 12px;\n}\n\n.wrapper__execution__history table thead tr th:last-child {\n    border-top-right-radius: 12px;\n}\n\n.wrapper__execution__history table thead tr th {\n    background: #F5F3F066;\n    font-size: 12px;\n    font-weight: 600;\n    line-height: 16px;\n    text-transform: uppercase;\n    color: var(--color-5F636A);\n    padding: 12px 20px;\n    vertical-align: middle;\n    letter-spacing: 0px;\n}\n\n.wrapper__execution__history table tbody tr td {\n    padding: 16px;\n    font-size: 14px;\n    font-weight: 700;\n    line-height: 18px;\n}\n\n.wrapper__execution__history table tbody tr:last-child td {\n    border-bottom: 0px;\n}\n\n.wrapper__execution__history table tbody tr:last-child td:first-child {\n    border-bottom-left-radius: 12px;\n}\n\n.wrapper__execution__history table tbody tr:last-child td:last-child {\n    border-bottom-right-radius: 12px;\n}\n\n.history__btn {\n    padding: 6px 12px;\n    font-size: 12px;\n    font-weight: 400;\n    line-height: 20px;\n    border-radius: 6px;\n    display: inline-flex;\n    align-items: center;\n    justify-content: center;\n    cursor: pointer;\n    transition: all 0.2s cubic-bezier(0.4, 0, 0.2, 1);\n    text-decoration: none;\n    font-family: var(--fontInter);\n    border: none;\n}\n\n.history__btn.open {\n    background: var(--orange-bg);\n    color: var(--color-E57600);\n}\n\n.history__btn.view {\n    background: rgba(59, 130, 246, 0.1);\n    color: var(--color-06b6d4);\n}\n\n.history__btn.delete {\n    background: rgba(239, 68, 68, 0.08);\n    color: rgb(248, 113, 113);\n}\n\n.wrapper__agent__td {\n    flex-direction: column;\n    align-items: flex-start !important;\n    justify-content: center;\n    row-gap: 4px;\n}\n\n.py__5 {\n    padding: 5px;\n}\n\n.py__80__20 {\n    padding: 80px 20px;\n}\n\n.br__4 {\n    border-radius: 4px;\n}\n\n.status__badge {\n    display: inline-flex;\n    align-items: center;\n    padding: 2px 8px;\n    border-radius: 100px;\n    font-size: 12px;\n    line-height: 16px;\n    font-weight: 700;\n    letter-spacing: 0px;\n    text-transform: uppercase;\n    font-family: var(--fontJetBrainsMono);\n    position: relative;\n}\n\n.badgeDot {\n    width: 6px;\n    height: 6px;\n    border-radius: 50%;\n    display: inline-block;\n    margin-right: 4px;\n}\n\n.badge__success {\n    background: #24A9651A;\n    color: var(--color-24A965);\n    box-shadow: 0px 0px 0px 1px #24A96533;\n}\n\n.badge__success.badgeDot {\n    background: var(--color-24A965);\n}\n\n.badge__danger {\n    color: #E52F0F;\n    background: #E52F0F1A;\n    box-shadow: 0px 0px 0px 1px #E52F0F33;\n}\n\n.badge__danger.badgeDot {\n    background: #E52F0F;\n}\n\n.badg__info {\n    color: #3C8DFF;\n    background: #3C8DFF1A;\n    box-shadow: 0px 0px 0px 1px #3C8DFF33;\n}\n\n.badg__info.badgeDot {\n    background: #3C8DFF;\n}\n\n.badge__warning {\n    color: #FF8C25;\n    background: #FF8C251A;\n    box-shadow: 0px 0px 0px 1px #FF8C2533;\n\n}\n\n.badge__warning.badgeDot {\n    background: #FF8C25;\n}\n\n.wrapper__execution__history .table-responsive {\n    padding-right: 6px;\n    max-height: 700px;\n    overflow-y: auto;\n}\n\n.empty__state__title {\n    font-size: 18px;\n    font-weight: 600;\n    color: #000;\n}\n\n.empty__state__desc {\n    font-size: 14px;\n    color: var(--color-5F636A);\n    max-width: 320px;\n}\n\n.empty__state {\n    padding: 56px 24px;\n    display: flex;\n    flex-direction: column;\n    align-items: center;\n    gap: 10px;\n    text-align: center;\n    box-shadow: 0 1px 2px rgba(14, 18, 24, 0.04), 0 8px 20px -14px rgba(14, 18, 24, 0.18);\n    border-radius: 12px;\n    background: var(--color-ffffff);\n    border: 1px solid #E7E4E0;\n}\n\n.wrapper__project__left {\n    max-width: 264px;\n    width: 100%;\n    padding-right: 24px;\n}\n\n.wrapper__project__right {\n    max-width: calc(100% - 264px);\n    width: 100%;\n}\n\n.wrapper__project__listing {\n    border: 1px solid #E7E4E0;\n    height: 100%;\n    border-radius: 16px;\n    padding: 12px;\n}\n\n.ls__1__2 {\n    letter-spacing: 1.2px;\n}\n\n.wraper__noProject {\n    text-align: center;\n    padding: 16px 0px;\n}\n\n.project__btn {\n    background: transparent;\n    display: flex;\n    flex-direction: column;\n    align-items: flex-start;\n    border-radius: 12px;\n    padding: 8px;\n    gap: 3px;\n    width: 100%;\n    border: 1px solid #E7E4E0;\n    outline: none;\n    text-align: left;\n    cursor: pointer;\n}\n\n.project__btn.selected {\n    font-weight: 600;\n    color: var(--color-E57600);\n    background: #E576000D;\n}\n\n.project__name {\n    font-size: 13px;\n    line-height: 20px;\n    font-family: var(--fontInter);\n    letter-spacing: 0px;\n    color: var(--color-1A1A1A);\n}\n\n.project__name.active,\n.project__btn.selected .domian {\n    color: var(--color-E57600);\n}\n\n.wrapper__buttons {\n    display: flex;\n    flex-direction: column;\n    gap: 10px;\n    margin-bottom: 20px;\n    max-height: 300px;\n    overflow-y: auto;\n}\n\n.project__quota.active {\n    padding-top: 10px;\n    border-top: 1px solid #E7E4E0;\n}\n\n.wrapper__createProject {\n    background: #E576000D;\n    display: flex;\n    align-items: center;\n    width: 100%;\n    outline: none;\n    text-align: left;\n    cursor: pointer;\n    border-radius: 12px;\n    padding: 12px 10px;\n    font-size: 13px;\n    line-height: 20px;\n    font-family: var(--fontInter);\n    letter-spacing: 0px;\n    color: var(--color-E57600);\n    font-weight: 500;\n    border: var(--color-E57600);\n}\n\n.wrapper__createProject.active {\n    background: var(--color-E57600);\n    color: var(--color-ffffff);\n}\n\n.wrapper__project__details {\n    border: 1px solid #E7E4E0;\n    padding: 24px;\n    background: var(--color-ffffff);\n    border-radius: 16px;\n}\n\n.gap__8 {\n    column-gap: 8px;\n}\n\n.uppercase {\n    text-transform: uppercase;\n}\n\n.captalize {\n    text-transform: capitalize;\n}\n\n.form__label {\n    font-size: 12px;\n    line-height: 16px;\n    font-weight: 700;\n    font-family: var(--fontInter);\n    letter-spacing: 0px;\n    color: var(--color-5F636A);\n    text-transform: uppercase;\n    margin-bottom: 6px;\n    display: block;\n}\n\n.fb__hint {\n    font-size: 12px;\n    color: var(--color-5F636A);\n    line-height: 1.6;\n    margin: 0px 0px 8px;\n}\n\n.form__input {\n    padding: 10px 12px;\n    background: var(--color-FDFCFA);\n    width: 100%;\n    border-radius: 12px;\n    border: 1px solid #E7E4E0;\n    outline: none;\n    font-size: 14px;\n    line-height: 18px;\n    font-family: var(--fontInter);\n    letter-spacing: 0px;\n    color: var(--color-0E1218)\n}\n\n.form__input::placeholder {\n    color: #0E121880;\n    font-size: 12px;\n}\n\n.form__input.error {\n    border-color: rgba(239, 68, 68, 0.5);\n}\n\n.form__input.dimmed {\n    opacity: 0.55;\n}\n\ntextarea.form__input {\n    height: 116px;\n    resize: vertical;\n}\n\n.form__input.read-only {\n    opacity: 0.5;\n    cursor: default;\n}\n\n.form__input:focus {\n    border-color: var(--color-5F636A);\n}\n\n.wrapper__fb__content textarea.form__input {\n    min-height: 92px;\n    padding-right: 54px;\n}\n\n.code {\n    font-family: var(--fontJetBrainsMono);\n    background-color: var(--color-F5F3F0);\n    padding: 5px;\n    border-radius: 4px;\n}\n\n.code__input,\n.code__input::placeholder {\n    font-family: var(--fontJetBrainsMono);\n    /* color: #0E121880; */\n    font-size: 12px;\n}\n\n.locked__input {\n    display: flex;\n    justify-content: space-between;\n    align-items: center;\n    gap: 10px;\n    cursor: not-allowed;\n}\n\n.wrapper__locked {\n    display: inline-flex;\n    align-items: center;\n    gap: 4px;\n    letter-spacing: 0.06px;\n    color: var(--color-5F6567);\n}\n\n.txt__ellipsis {\n    overflow: hidden;\n    text-overflow: ellipsis;\n    white-space: nowrap;\n}\n\n.successConfigure {\n    padding: 3px 6px;\n    border-radius: 4px;\n    background: var(--success-bg);\n    margin-top: 5px;\n    display: inline-flex;\n    align-items: center;\n    gap: 4px;\n    color: var(--color-007A55);\n    font-size: 11px;\n}\n\n.successMsg {\n    padding: 10px 14px;\n    border-radius: 8px;\n    background: var(--success-bg);\n    border: 1px solid var(--success-bg);\n    color: var(--color-007A55);\n}\n\n.validateError {\n    font-size: 12px;\n    color: var(--color-E52F0F);\n    font-family: var(--fontInter);\n    line-height: 18px;\n    margin-top: 5px;\n}\n\n.wrapper__competitors {\n    display: flex;\n    flex-direction: column;\n    gap: 10px;\n}\n\n.wrapper__back__link {\n    display: inline-flex;\n    align-items: center;\n    gap: 4px;\n    cursor: pointer;\n    text-transform: capitalize;\n    border: none;\n    background: transparent;\n    outline: none;\n}\n\n.profile__details .username__initial {\n    width: 56px;\n    height: 56px;\n    font-size: 16px;\n}\n\n.wrapper__profile__card {\n    padding: 24px;\n    border: 1px solid #E7E4E0;\n    border-radius: 16px;\n    background: var(--color-ffffff);\n}\n\n.display__name {\n    text-transform: capitalize;\n}\n\n/* ## feedback model## */\n.wrapper__feedback__model {\n    position: fixed;\n    inset: 0px;\n    background: rgba(0, 0, 0, 0.65);\n    backdrop-filter: blur(6px);\n    z-index: 9000;\n    display: flex;\n    align-items: center;\n    justify-content: center;\n    padding: 16px;\n}\n\n.feedback__model__inner {\n    background: var(--color-ffffff);\n    border: 1px solid var(--border);\n    border-radius: 16px;\n    width: 100%;\n    max-width: 460px;\n    max-height: 90vh;\n    overflow: auto;\n    box-shadow: rgba(0, 0, 0, 0.6) 0px 24px 64px;\n}\n\n.wrapper__fb__head {\n    padding: 20px 24px 16px;\n    border-bottom: 1px solid var(--border);\n    display: flex;\n    align-items: flex-start;\n    justify-content: space-between;\n    gap: 12px;\n}\n\n.wrapper__fb__content {\n    padding: 20px 24px;\n}\n\n.fb__send {\n    position: absolute;\n    right: 10px;\n    bottom: 10px;\n    width: 32px;\n    height: 32px;\n    border-radius: 10px;\n    cursor: default;\n    background: transparent;\n    color: var(--color-5F636A);\n    border: 1px solid var(--color-5F636A);\n    display: inline-flex;\n    align-items: center;\n    justify-content: center;\n    box-shadow: none;\n    transition: background 0.15s, box-shadow 0.15s;\n}\n\n.fb__send.sendBtnActive {\n    background: var(--color-E57600);\n    color: var(--color-ffffff);\n    border-color: var(--color-E57600);\n    box-shadow: 0px 6px 20px -6px #E5760080;\n    cursor: pointer;\n}\n\n.fb__star__rating {\n    background: none;\n    color: var(--color-0E1218);\n    transform: scale(1);\n    transition: all 0.2s ease;\n    border: none;\n    cursor: pointer;\n    font-size: 26px;\n    line-height: 36px;\n    padding: 2px;\n}\n\n.fb__star__rating.active {\n    color: var(--color-007A55);\n    transform: scale(1.2);\n}\n\n/* ## Agent Execution Page ## */\n.wrapper__back__btn {\n    background: transparent;\n    border: none;\n    outline: none;\n    column-gap: 6px;\n    cursor: pointer;\n}\n\n.wrapper__agents__nameTags {\n    max-width: 683px;\n    width: 100%;\n}\n\n.agentCat {\n    background: #F5F3F0;\n    padding: 2px 6px;\n    border-radius: 4px;\n    font-family: var(--fontJetBrainsMono);\n    text-transform: uppercase;\n    color: var(--color-5F636A);\n}\n\n.agentInitials {\n    width: auto;\n    min-width: 56px;\n    height: 56px;\n    font-size: 16px;\n    border-radius: 16px;\n    font-weight: 700;\n    line-height: 26px;\n}\n\n.agentTag {\n    padding: 2px 10px;\n    border: 1px solid #E7E4E0;\n    border-radius: 50px;\n    display: inline-flex;\n    align-items: center;\n    justify-content: center;\n}\n\n.wrapper__agent__header {\n    align-items: flex-start;\n}\n\n.wrapper__pin {\n    border-radius: 12px;\n    border: 1px solid #E7E4E0;\n    padding: 7px 11px;\n    gap: 5px;\n}\n\n.steps__circle {\n    padding: 2px 10px;\n    border-radius: 50px;\n    background: #E576001A;\n    color: var(--color-E57600);\n    font-size: 16px;\n    font-weight: 500;\n    line-height: 26px;\n    display: inline-flex;\n    align-items: center;\n    justify-content: center;\n}\n\n.onboarding__grid__left {\n    max-width: 750px;\n    width: 100%;\n    padding-right: 24px;\n}\n\n.onboarding__grid__right {\n    max-width: calc(100% - 750px);\n    width: 100%;\n}\n\n.wrapper__onbaording__form,\n.onboarding__grid__right aside {\n    border: 1px solid #E7E4E0;\n    padding: 24px;\n    border-radius: 16px;\n    background: var(--color-ffffff);\n}\n\n.onboarding__grid__right aside {\n    display: flex;\n    flex-direction: column;\n    gap: 18px;\n    position: sticky;\n    top: 10px;\n}\n\n.wrapper__project {\n    white-space: nowrap;\n    overflow: hidden;\n    text-overflow: ellipsis;\n    width: 70px;\n}\n\n.agent__new__design__grid {\n    flex-direction: column-reverse;\n}\n\n.agent__exe__selection {\n    max-width: 100%;\n    width: 100%;\n}\n\n.agent__exe__blackScreen {\n    max-width: 100%;\n    width: 100%;\n}\n\n.wrapper__selection__inner {\n    padding: 20px;\n    border: 1px solid #E7E4E0;\n    border-radius: 16px;\n}\n\n.wrapper__ai__disclaimer {\n    border: 1px solid #ECAA0B33;\n    background: #ECAA0B0D;\n    padding: 16px;\n    border-radius: 16px;\n    margin-top: 11px;\n}\n\n\n.wrapper__credentials__warning {\n    margin-bottom: 12px;\n    display: flex;\n    align-items: flex-start;\n    gap: 9px;\n    border: 1px solid var(--color-E52F0F);\n    background: var(--failed-bg);\n    padding: 4px 10px;\n    border-radius: 16px;\n}\n\n.link {\n    color: var(--color-E57600);\n    text-decoration: underline;\n}\n\n.project__details__run {\n    background: var(--orange-bg);\n    padding: 8px 10px;\n    border-radius: 16px;\n    margin-bottom: 12px;\n}\n\n.list__none {\n    list-style-type: none;\n}\n\n.cursor {\n    cursor: pointer;\n}\n\n.hasContext {\n    font-size: 12px;\n    line-height: 16px;\n    font-family: var(--fontInter);\n    letter-spacing: 0px;\n    margin-top: 9px;\n    color: var(--color-5F636A);\n    white-space: pre-wrap;\n}\n\n.hasContext.hasOpacity {\n    opacity: 0.5;\n}\n\n.wrapper__aiRun__warning {\n    border: 1px solid #ECAA0B33;\n    padding: 12px;\n    gap: 4px;\n    border-radius: 12px;\n    background: #ECAA0B0F;\n}\n\n.execution__btn button {\n    height: 42px;\n    gap: 8px;\n}\n\n.execution__btn button:disabled {\n    pointer-events: none;\n}\n\n.execution__btn button img {\n    transition: all 0.3s ease;\n}\n\n.execution__btn button:hover img {\n    filter: brightness(0) saturate(100%) invert(52%) sepia(80%) saturate(2763%) hue-rotate(6deg) brightness(95%) contrast(101%);\n    transition: all 0.3s ease;\n}\n\n.chat__form__row {\n    margin-left: -10px;\n    margin-right: -10px;\n    margin-bottom: 24px;\n}\n\n.wrapper__input__col {\n    padding: 0px 10px;\n}\n\n/* When there's only 1 input */\n.wrapper__input__col:first-child:nth-last-child(1) {\n    width: 100%;\n}\n\n/* When there are 2 inputs total */\n.wrapper__input__col:first-child:nth-last-child(2),\n.wrapper__input__col:first-child:nth-last-child(2)~.wrapper__input__col {\n    width: 50%;\n}\n\n/* When there are 3 inputs total */\n.wrapper__input__col:first-child:nth-last-child(3),\n.wrapper__input__col:first-child:nth-last-child(3)~.wrapper__input__col {\n    width: 33.333%;\n}\n\n/* When there are 4 inputs total */\n.wrapper__input__col:first-child:nth-last-child(4),\n.wrapper__input__col:first-child:nth-last-child(4)~.wrapper__input__col {\n    width: 25%;\n}\n\n/* When there are 5 inputs total */\n.wrapper__input__col:first-child:nth-last-child(5),\n.wrapper__input__col:first-child:nth-last-child(5)~.wrapper__input__col {\n    width: 20%;\n}\n\n.wrapper__doamin__list {\n    margin-left: -10px;\n    margin-right: -10px;\n}\n\n.wrapper__agent__notification__window {\n    margin-bottom: 12px;\n    display: flex;\n    align-items: flex-start;\n    gap: 12px;\n    padding: 10px 13px;\n    background: var(--darkGreen-bg);\n    border: 1px solid #007A5533;\n    border-radius: 12px;\n    font-size: 12px;\n    color: var(--color-0E1218);\n    line-height: 20px;\n    font-weight: 400;\n    max-width: 90%;\n    width: 100%;\n    margin-left: auto;\n    margin-right: auto;\n}\n\n.flex__1 {\n    flex: 1 1 0%;\n}\n\n.execution__btn .common__transp__btn img {\n    filter: brightness(0) saturate(100%) invert(4%) sepia(10%) saturate(2610%) hue-rotate(177deg) brightness(92%) contrast(94%);\n}\n\n.execution__btn button span {\n    display: inline-flex;\n    align-items: center;\n    gap: 8px;\n}\n\n.execution__btn .common__transp__btn:hover img {\n    filter: none;\n}\n\n.error-page {\n    min-height: 100vh;\n    display: flex;\n    flex-direction: column;\n    align-items: center;\n    justify-content: center;\n    text-align: center;\n    gap: 12px;\n    padding: 24px;\n}\n\n.error-page button {\n    padding: 10px 20px;\n    border: 0;\n    border-radius: 6px;\n    cursor: pointer;\n}\n\n.agent__website__url {\n    background: #E576001A;\n    border: 1px solid #E576004D;\n    border-radius: 20px;\n    padding: 10px 16px;\n}\n\n.wrapper__execution__screen__div {\n    max-width: 1010px;\n    width: 100%;\n    margin-left: auto;\n    margin-right: auto;\n    gap: 12px;\n    align-items: flex-start;\n    margin-bottom: 28px;\n}\n\n.runTech {\n    width: 32px;\n    height: 32px;\n    border-radius: 50%;\n    background: #E5760026;\n    display: flex;\n    align-items: center;\n    justify-content: center;\n    font-size: 11px;\n    font-weight: 700;\n    color: var(--color-E57600);\n    flex-shrink: 0;\n    letter-spacing: -0.02em;\n    text-transform: uppercase;\n}\n\n.wrapper__screen__map {\n    background: #0A0D12;\n    box-shadow: 0px 24px 60px -30px #00000066;\n    border: 1px solid #E7E4E0;\n    border-radius: 16px;\n    padding: 20px;\n    font-family: \"JetBrains Mono\", monospace;\n    font-size: 11px;\n    max-height: 620px;\n    overflow: auto;\n    margin-bottom: 24px;\n    transition: max-height 0.2s;\n}\n\n.wrapper__screen__map__header {\n    padding-bottom: 30px;\n}\n\n.screen__run__data {\n    letter-spacing: 1.58px;\n    font-size: 11px;\n    font-weight: 400;\n    line-height: 20px;\n    color: #FFFFFF80;\n    font-family: var(--fontJetBrainsMono);\n    text-transform: uppercase;\n    gap: 11px;\n}\n\n.runStatus {\n    font-size: 12px;\n    line-height: 16px;\n    font-family: var(--fontInter);\n    letter-spacing: 0px;\n}\n\n.dots {\n    position: relative;\n    display: inline-flex;\n    align-items: center;\n    gap: 6px;\n}\n\n.dots::before {\n    content: \"\";\n    display: inline-block;\n    width: 6px;\n    height: 6px;\n    border-radius: 50%;\n    background: #000;\n}\n\n.Run__in__Queue {\n    color: var(--color-0069A8);\n}\n\n.run__In__running {\n    color: var(--color-E57600);\n    font-size: 12px;\n    display: flex;\n    align-items: center;\n    gap: 6px;\n}\n\n.run__Completed {\n    color: var(--color-007A55);\n    padding: 2px 8px;\n    background: #24A9651A;\n    border-radius: 35px;\n    text-transform: uppercase;\n    font-weight: 700;\n    font-family: var(--fontJetBrainsMono);\n\n}\n\n.run__Failed {\n    color: var(--color-E52F0F);\n    font-weight: 700;\n    font-family: var(--fontJetBrainsMono);\n    padding: 2px 8px;\n    border-radius: 35px;\n    text-transform: uppercase;\n    background: var(--failed-bg);\n}\n\n.run__In__running .pulse-dot {\n    background: var(--color-E57600);\n    box-shadow: 0 0 8px var(--color-E57600);\n\n}\n\n.run__In__running .pulse-dot::after {\n    border-color: var(--color-E57600);\n}\n\n.screen__static__controls .controls {\n    width: 10px;\n    height: 10px;\n    display: inline-flex;\n    border-radius: 50%;\n}\n\n.run__Completed.dots::before {\n    background: var(--color-007A55);\n}\n\n.run__Failed.dots::before {\n    background: var(--color-E52F0F);\n}\n\n.controls.red {\n    background: #FF2056B2;\n}\n\n.controls.orange {\n    background: #FE9A00B2;\n\n}\n\n.controls.green {\n    background: #00BC7DB2;\n\n}\n\n.notify__activated {\n    background: rgba(6, 182, 212, 0.06);\n    border: 1px solid rgba(6, 182, 212, 0.15);\n    border-radius: 8px;\n    padding: 9px 13px;\n    margin-bottom: 10px;\n    font-size: 12px;\n    color: var(--text-secondary);\n    display: flex;\n    align-items: center;\n    gap: 8px;\n}\n\n.wrapper__report__section {\n    padding: 10px 13px;\n    background: var(--darkGreen-bg);\n    border: 1px solid #007A5533;\n    border-radius: 12px;\n    font-size: 12px;\n    color: var(--color-0E1218);\n    line-height: 20px;\n    font-weight: 400;\n}\n\n.report__modal {\n    position: fixed;\n    right: 0;\n    top: 0;\n    bottom: 0;\n    width: min(100%, 772px);\n    height: 100vh;\n    height: 100dvh;\n    box-shadow: -2px 4px 54px 0px #00000040;\n    z-index: 1050;\n    background: #FDFCFA;\n    transition: all 0.3s ease;\n    overflow-x: hidden;\n    overflow-y: auto;\n    outline: 0;\n}\n\n.report__modal__inner {\n    background: #FDFCFA;\n    max-width: 766px;\n    min-height: 100%;\n    padding: 20px 20px 33px;\n    width: 100%;\n}\n\n.report__head {\n    padding: 10px 0px 20px;\n    position: sticky;\n    top: 0;\n    z-index: 2;\n    background: #FDFCFA;\n}\n\n.download__pdf {\n    border: 1px solid #E7E4E0;\n    outline: none;\n    background: transparent;\n    padding: 10px 16px;\n    border-radius: 12px;\n    cursor: pointer;\n}\n\n.wrapper__report__border {\n    border: 1px solid #E7E4E0;\n    box-shadow: 0px 2px 8px 0px #00000014;\n    border-radius: 12px;\n    padding: 30px 20px;\n}\n\n.report__model__body {\n    width: 100%;\n    max-width: 712px;\n    margin-left: auto;\n    margin-right: auto;\n    padding-bottom: 33px;\n}\n\n.report__scores {\n    margin-left: -7px;\n    margin-right: -7px;\n}\n\n.report__score__col {\n    max-width: calc(100% / 4);\n    width: 100%;\n    padding: 0px 7px;\n}\n\n.report__score__col__inner {\n    border: 1px solid #E7E4E0;\n    background: var(--color-ffffff);\n    border-radius: 14px;\n    padding: 12px 16px;\n    height: 100%;\n}\n\n.wrapper__demo__output {\n    border: 1px dashed #E7E4E0;\n    background: var(--color-ffffff);\n    border-radius: 12px;\n    padding: 12px 13px;\n}\n\n.wrapper__report__section button.common__btn {\n    gap: 4px;\n}\n\n.wrapper__report__section button.common__btn img {\n    transition: all 0.3s ease;\n}\n\n.wrapper__report__section button.common__btn:hover img {\n    filter: brightness(0) saturate(100%) invert(62%) sepia(44%) saturate(7316%) hue-rotate(9deg) brightness(98%) contrast(101%);\n}\n\n.report__md {\n    overflow-x: auto;\n    margin-bottom: 30px;\n    border: 1px solid #ECAA0B33;\n    background: #ECAA0B0D;\n    padding: 15px 12px;\n    border-radius: 12px;\n}\n\n.wrapper__generated__files .common__btn,\n.download__file__btn__groups .common__btn {\n    font-size: 13px;\n    font-weight: 500;\n    background: #E576001A;\n    border: 1px solid #E576004D;\n    box-shadow: none;\n    color: var(--color-E57600);\n    padding: 9px 9px;\n    height: auto;\n    gap: 6px;\n}\n\n.d__fileType {\n    background: #E5760033;\n    padding: 2px 6px;\n    border-radius: 4px;\n}\n\n.wrapper__generated__files {\n    display: flex;\n    align-items: flex-end;\n    gap: 12px;\n    width: 100%;\n    margin-top: 8px;\n    flex-wrap: wrap;\n}\n\n.download__pdf__stdoutContent {\n    border: 1px solid #E7E4E0;\n    border-color: transparent;\n    border-radius: 8px;\n    padding: 10px 12px;\n    margin: 0px;\n    background: transparent;\n    outline: none;\n    cursor: pointer;\n    transition: all 0.3s ease;\n}\n\n.download__pdf__stdoutContent:hover {\n    border-color: #E576004D;\n}\n\n.report__md h1 {\n    color: var(--color-0E1218);\n    font-family: var(--fontSpaceGroTesk);\n    letter-spacing: -0.6px;\n    font-size: 30px;\n    font-weight: 700;\n    margin-bottom: 8px;\n    margin-top: 0px;\n}\n\n.report__md h2 {\n    color: var(--color-0E1218);\n    font-family: var(--fontSpaceGroTesk);\n    letter-spacing: -0.6px;\n    font-size: 26px;\n    letter-spacing: .08em;\n    text-transform: uppercase;\n    color: #E57600;\n    margin: 24px 0 12px;\n}\n\n.report__md h3 {\n    color: var(--color-0E1218);\n    font-family: var(--fontSpaceGroTesk);\n    letter-spacing: -0.6px;\n    font-size: 22px;\n    font-weight: 700;\n    margin: 16px 0 8px;\n}\n\n.report__md h4 {\n    color: var(--color-0E1218);\n    font-family: var(--fontSpaceGroTesk);\n    letter-spacing: -0.6px;\n    font-size: 20px;\n    font-weight: 700;\n    margin: 16px 0 8px;\n}\n\n.report__md h5 {\n    color: var(--color-0E1218);\n    font-family: var(--fontSpaceGroTesk);\n    letter-spacing: -0.6px;\n    font-size: 18px;\n    font-weight: 700;\n    margin: 16px 0 8px;\n}\n\n.report__md h6 {\n    color: var(--color-0E1218);\n    font-family: var(--fontSpaceGroTesk);\n    letter-spacing: -0.6px;\n    font-size: 16px;\n    font-weight: 700;\n    margin: 16px 0 8px;\n}\n\n.report__md p {\n    margin-bottom: 12px;\n    color: #5F636A;\n    font-size: 12px;\n    font-weight: 400;\n    line-height: 20px;\n    font-family: var(--fontInter);\n}\n\n.report__md ol {\n    list-style: none;\n    padding: 0;\n    counter-reset: item;\n}\n\n.report__md ol li {\n    counter-increment: item;\n    display: block;\n    position: relative;\n    padding-left: 40px;\n    gap: 12px;\n    margin-bottom: 14px;\n    font-size: 12px;\n    font-family: var(--fontInter);\n    color: var(--color-5F636A);\n}\n\n.report__md ol li::before {\n    content: counter(item);\n    flex: 0 0 28px;\n    width: 28px;\n    height: 28px;\n    border-radius: 50%;\n    background: #FDEBD9;\n    color: #E57600;\n    display: grid;\n    place-items: center;\n    font-size: 12px;\n    font-family: var(--fontInter);\n    color: var(--color-5F636A);\n    position: absolute;\n    left: 0;\n    top: 0;\n}\n\n.report__md ul {\n    padding-left: 20px;\n    margin-bottom: 12px;\n}\n\n.report__md ul li {\n    list-style-type: disc;\n    font-size: 12px;\n    font-weight: 400;\n    line-height: 20px;\n    font-family: var(--fontInter);\n    color: var(--color-5F636A);\n}\n\n.report__md hr {\n    border: 0;\n    border-top: 1px solid #eee;\n    margin: 20px 0;\n}\n\n.report__md a {\n    color: #E57600;\n    text-decoration: underline;\n}\n\n.report__md table {\n    width: 100%;\n    border-collapse: collapse;\n    margin: 12px 0;\n    font-size: 12px;\n    font-family: var(--fontInter);\n}\n\n.report__md th,\n.report__md td {\n    border: 1px solid #E7E4E0;\n    padding: 6px 8px;\n    text-align: left;\n    vertical-align: top;\n    color: var(--color-5F636A);\n}\n\n.report__md th {\n    background: #E576001A;\n    color: var(--color-0E1218);\n    font-weight: 600;\n}\n\n.report__md pre,\n.report__raw {\n    background: var(--color-ffffff);\n    border: 1px solid #E7E4E0;\n    border-radius: 8px;\n    padding: 10px 12px;\n    margin: 10px 0;\n    font-size: 11px;\n    line-height: 18px;\n    color: var(--color-5F636A);\n    white-space: pre-wrap;\n    word-break: break-word;\n    overflow-x: auto;\n}\n\n.report__raw {\n    margin: 0;\n}\n\n.report__md blockquote {\n    border-left: 3px solid #E5760066;\n    margin: 10px 0;\n    padding: 2px 0 2px 12px;\n    font-size: 12px;\n    color: var(--color-5F636A);\n}\n\n/* The generated-file button whose report is currently open in the panel */\n.wrapper__generated__files .common__btn.is__active,\n.download__file__btn__groups .common__btn.is__active {\n    background: #E5760033;\n    border-color: var(--color-E57600);\n}\n\n.report__files {\n    margin-top: 24px;\n    margin-bottom: 24px;\n}\n\n.report__files button {\n    gap: 6px;\n}\n\n.noGeneratedFiles {\n    background: var(--orange-bg);\n    padding: 8px 10px;\n    border-radius: 16px;\n}\n\n.report__footer {\n    border-top: 1px solid #eee;\n    margin-top: 24px;\n    padding-top: 12px;\n    gap: 6px;\n}\n\n.wrapper__history__card,\n.wrapper__findings__card {\n    border: 1px solid #E7E4E0;\n    border-radius: 16px;\n    padding: 20px;\n    background: var(--color-FDFCFA);\n}\n\n.history__priorities li {\n    list-style-type: decimal;\n    margin-left: 15px;\n}\n\n.history__priorities li:not(:last-child) {\n    margin-bottom: 7px;\n}\n\n.history__priorities .sev {\n    font-weight: 600;\n}\n\n.menu__toggle {\n    display: none;\n    background: transparent;\n    border: none;\n    /* border: 1px solid #E7E4E0;\n    border-radius: 8px; */\n    cursor: pointer;\n}\n\n/* ###------------------CSS BASED ON FIGMA END------------------### */\n/* ── Header project switcher ─────────────────────────────────────────────\n   The one project picker for Overview, Agent Library, Execution History and\n   the agent chat. Sits between the breadcrumb and the right-hand actions,\n   and stays outside .wrapper__right so it survives on phones, where that\n   container is hidden.\n\n   Accent is the site orange (--color-E57600) over its two tints, the same\n   pairing the settings project list and the agent category chips use. */\n\n.hdr__project__switch {\n    margin-left: auto;\n    display: inline-flex;\n    align-items: center;\n    gap: 8px;\n    flex-shrink: 0;\n}\n\n.hdr__project__eyebrow {\n    font-size: 11px;\n    font-weight: 600;\n    line-height: 20px;\n    font-family: var(--fontInter);\n    color: var(--color-5F636A);\n    text-transform: uppercase;\n    letter-spacing: 0.07em;\n    white-space: nowrap;\n}\n\n.hdr__project__btn {\n    display: inline-flex;\n    align-items: center;\n    gap: 6px;\n    max-width: 240px;\n    padding: 6px 12px;\n    border-radius: 8px;\n    border: 1px solid var(--color-E7E4E0);\n    background: var(--color-ffffff);\n    color: var(--color-5F636A);\n    cursor: pointer;\n    font-size: 12px;\n    font-weight: 600;\n    font-family: var(--fontInter);\n    line-height: 20px;\n    white-space: nowrap;\n    transition: all 0.15s ease;\n}\n\n.hdr__project__btn.is__static {\n    cursor: default;\n}\n\n.hdr__project__btn:hover {\n    border-color: #E5760033;\n    background: #E576000D;\n    color: var(--color-E57600);\n}\n\n.hdr__project__btn.selected {\n    border-color: #E5760033;\n    background: #E576000D;\n    color: var(--color-E57600);\n}\n\n.hdr__project__btn.active {\n    border-color: var(--color-E57600);\n    box-shadow: 0px 0px 0px 1px #E5760026;\n}\n\n.hdr__project__label {\n    overflow: hidden;\n    text-overflow: ellipsis;\n    white-space: nowrap;\n}\n\n.hdr__project__menu {\n    position: absolute;\n    top: calc(100% + 6px);\n    right: 0px;\n    min-width: 230px;\n    background: var(--color-ffffff);\n    border: 1px solid var(--color-E7E4E0);\n    border-radius: 10px;\n    box-shadow: 0 8px 32px rgba(14, 18, 24, 0.12);\n    z-index: 100;\n    overflow: hidden;\n}\n\n.hdr__project__list {\n    padding: 6px 4px;\n    max-height: 260px;\n    overflow-y: auto;\n}\n\n.hdr__project__item {\n    width: 100%;\n    text-align: left;\n    padding: 7px 12px;\n    border: none;\n    border-radius: 6px;\n    background: transparent;\n    cursor: pointer;\n    display: flex;\n    align-items: center;\n    gap: 8px;\n    color: var(--color-0E1218);\n    transition: background 0.15s ease, color 0.15s ease;\n}\n\n.hdr__project__item:hover,\n.hdr__project__item.active {\n    background: #E576000D;\n    color: var(--color-E57600);\n}\n\n.hdr__project__item .dots::before {\n    background: var(--color-5F636A);\n    transition: background 0.15s ease;\n}\n\n.hdr__project__item:hover .dots::before,\n.hdr__project__item.active .dots::before {\n    background: var(--color-E57600);\n}\n\n.hdr__project__item .p__name {\n    display: block;\n    color: var(--color-0E1218);\n}\n\n.hdr__project__item .p__domain__comp {\n    display: block;\n    margin-top: 1px;\n    color: var(--color-5F636A);\n}\n\n.hdr__project__item:hover .p__name,\n.hdr__project__item.active .p__name {\n    color: var(--color-E57600);\n}\n\n.hdr__project__item__inner {\n    min-width: 0;\n    overflow: hidden;\n}\n\n.hdr__project__item__inner .p__name,\n.hdr__project__item__inner .p__domain__comp {\n    overflow: hidden;\n    text-overflow: ellipsis;\n    white-space: nowrap;\n}\n\n.hdr__project__new {\n    width: 100%;\n    text-align: left;\n    padding: 9px 12px;\n    border: none;\n    border-top: 1px solid var(--color-E7E4E0);\n    background: #E576000D;\n    cursor: pointer;\n    font-size: 12px;\n    font-weight: 600;\n    font-family: var(--fontInter);\n    color: var(--color-E57600);\n    display: flex;\n    align-items: center;\n    gap: 6px;\n    transition: background 0.15s ease, color 0.15s ease;\n}\n\n.hdr__project__new:hover {\n    background: var(--color-E57600);\n    color: var(--color-ffffff);\n}\n\n.hdr__project__limit {\n    padding: 9px 12px;\n    border-top: 1px solid var(--color-E7E4E0);\n}\n\n\n/* ## UI FEEDBACK ## */\nnav.sidebar-nav ul li:not(:last-child) {\n    margin-bottom: 6px;\n}\n\nnav.sidebar-nav {\n    align-items: initial;\n}\n\nspan.fb__12.fw__700.fc__5F636A.ff__jetBrainsMono.bg__F5F3F0.py__5.br__4 {\n    display: block;\n    max-width: 100%;\n    overflow-wrap: anywhere;\n    word-break: break-all;\n    width: fit-content;\n}\n\n.sd-row.sd-empty .sd-row-main {\n    display: flex;\n    justify-content: space-between;\n    align-items: center;\n}\n\n.sd-row.sd-empty {\n    min-height: 60px;\n}\n\n.wrapper__recents__head .recent__left>span {\n    line-height: 20px;\n}\n\n.wrapper__userDropdown .userName {\n    font-size: 12px;\n    text-align: left;\n}\n\n.wrapper__sidenav__item .expand__icon {\n    margin-left: auto;\n}\n\n.wrapper__header__area {\n    display: flex;\n    align-items: center;\n    justify-content: space-between;\n    width: 100%;\n    flex-wrap: wrap;\n}\n\n.report__score__grid {\n    row-gap: 14px;\n}\n\n.sidebar__toggle {\n    display: none;\n}\n\n.sidebar__top {\n    display: flex;\n    align-items: center;\n    justify-content: space-between;\n}\n\n.app-sidebar--collapsed .userDetails,\n.app-sidebar--collapsed .userMenu__accordion {\n    display: none;\n}\n\n.app-sidebar--collapsed .userDropdown__btn {\n    justify-content: center;\n    padding: 8px;\n}\naside.app-sidebar.app-sidebar--collapsed .sidebar__brand {\n    padding: 0;\n}\n.app-sidebar--collapsed .wrapper__dropdown__menu {\n    width: 260px;\n    left: 0;\n}\n\n.app-sidebar--collapsed .sidebar__brand .logo-img--short {\n    width: 24px;\n    height: 24px;\n}\n.app__shell select{\n    -webkit-appearance: none;\n    -moz-appearance: none;\n    background-image: url('data:image/svg+xml,<svg xmlns=\"http://www.w3.org/2000/svg\" width=\"24\" height=\"24\" viewBox=\"0 0 24 24\" fill=\"none\" stroke=\"%230E1218\" stroke-width=\"2\" stroke-linecap=\"round\" stroke-linejoin=\"round\" class=\"feather feather-chevron-down\"><polyline points=\"6 9 12 15 18 9\"></polyline></svg>');\n    background-repeat: no-repeat;\n    background-position: right .75rem center;\n    background-size: 16px 24px;\n    padding-right: 30px;\n}\n\n/* ### RESPONSIVE BEHAVIOUR ### */\n\n\n\n\n@media(max-width:850px) {\n    .wrapper__agents__col {\n        max-width: calc(100% / 1);\n        width: 100%;\n    }\n\n    .wrapper__project__left,\n    .wrapper__project__right {\n        max-width: 100%;\n    }\n\n    .wrapper__agent__header,\n    .wrapper__agents__nameTags {\n        flex-wrap: wrap;\n    }\n\n    .wrapper__agent__header {\n        row-gap: 20px;\n    }\n\n    .wrapper__input__col:first-child:nth-last-child(2),\n    .wrapper__input__col:first-child:nth-last-child(2)~.wrapper__input__col {\n        max-width: 100%;\n        width: 100%;\n    }\n\n    .wrapper__doamin__list,\n    .chat__form__row {\n        row-gap: 20px;\n    }\n\n    .wrapper__input__col:first-child:nth-last-child(3),\n    .wrapper__input__col:first-child:nth-last-child(3)~.wrapper__input__col {\n        width: 100%;\n        max-width: 100%;\n    }\n\n    .breadcrumb__list .breadcrumb-sep {\n        margin: 0px 2px;\n    }\n\n    .wrapper__input__col:first-child:nth-last-child(4),\n    .wrapper__input__col:first-child:nth-last-child(4)~.wrapper__input__col {\n        max-width: 100%;\n        width: 100%;\n    }\n\n    .wrapper__execution__screen__inner {\n        width: 100%;\n        flex: 100% !important;\n    }\n\n    .wrapper__report__section {\n        flex-wrap: wrap;\n        justify-content: center !important;\n        flex-direction: column;\n        row-gap: 15px;\n    }\n\n    .wrapper__execution__screen__div {\n        flex-wrap: wrap;\n    }\n\n    .report__md h1 {\n        font-size: 24px;\n        line-height: 34px;\n    }\n\n    .report__md h2 {\n        font-size: 22px;\n        line-height: 32px;\n    }\n\n    .report__md h3 {\n        font-size: 20px;\n        line-height: 30px;\n    }\n\n    .report__md h4 {\n        font-size: 18px;\n        line-height: 28px;\n    }\n\n    .report__md h5 {\n        font-size: 16px;\n        line-height: 24px;\n    }\n\n    .report__md h6 {\n        font-size: 14px;\n        line-height: 24px;\n    }\n\n    .wrapper__history__filter {\n        flex-wrap: wrap;\n        margin-top: 20px;\n    }\n\n    .onboarding__grid__left,\n    .onboarding__grid__right {\n        max-width: 100%;\n        padding: 0px;\n    }\n\n    .onboarding__grid.custom__row {\n        row-gap: 30px;\n    }\n\n    .onboarding__grid__right {\n        order: -1;\n    }\n\n    .wrapper__agent__filter {\n        flex-wrap: wrap;\n        row-gap: 15px;\n    }\n\n    .sd-detail-score {\n        text-align: left;\n    }\n\n\n\n}\n\n@media(min-width:769px) and (max-width:1099px) {\n    .wrapper__execution__history table {\n        min-width: 1200px;\n    }\n\n    .wrapper__history__top {\n        gap: 20px;\n    }\n}\n\n@media(min-width:850px) and (max-width:1260px) {\n    .wrapper__agents__col {\n        max-width: calc(100% / 2);\n        width: 100%;\n    }\n\n    .sd-link {\n        font-size: 14px;\n    }\n\n\n}\n\n@media(max-width:1260px) {\n    .wrapper__history__top {\n        flex-wrap: wrap;\n    }\n\n    .wrapper__project__left,\n    .wrapper__project__right {\n        max-width: 100%;\n    }\n\n    .wrapper__project__setting__grid {\n        row-gap: 40px;\n    }\n\n    .wrapper__history__top {\n        margin-bottom: 10px;\n    }\n\n    .wrapper__main {\n        padding: 18px;\n    }\n\n}\n\n@media(min-width: 1280px) {\n    .sidebar__toggle {\n        display: block;\n        background: none;\n        border: 0;\n        padding: 0;\n        cursor: pointer;\n    }\n\n\n    .sidebar__toggle[aria-expanded=\"false\"] img  {\n        transform: scaleX(-1);\n    }\n\n    .app-sidebar--collapsed .betaTag,\n    .app-sidebar--collapsed .workSpace,\n    .app-sidebar--collapsed .nav__title,\n    .app-sidebar--collapsed .total__agents,\n    .app-sidebar--collapsed .expand__icon {\n        display: none;\n    }\n\n    .app-sidebar--collapsed .sidebar__top {\n        gap: 8px;\n        justify-content: initial;\n    }\n\n    .app-sidebar--collapsed .sidebar-nav-item {\n        justify-content: center;\n    }\n\n    main.app-main.app-main--collapsed {\n        margin-left: 78px;\n        max-width: 100%;\n    }\n}\n\n@media (min-width:769px) and (max-width:1260px) {\n    .site__footer__inner {\n        justify-content: flex-start;\n    }\n\n    .site__footer {\n        margin-left: 257px;\n    }\n}\n\n@media (min-width:769px) and (max-width:900px) {\n    .site__footer__inner {\n        max-width: 400px;\n        padding: 0px;\n        margin-left: 30px;\n    }\n}\n\n@media(min-width:1199px) and (max-width:1365px) {\n    .wrapper__execution__history table {\n        min-width: 1200px;\n    }\n}\n\n@media(min-width:1261px) and (max-width:1360px) {\n    .wrapper__agent__card .agent__name {\n        height: 45px;\n    }\n\n    .wrapper__agents__col {\n        max-width: calc(100% / 3);\n    }\n\n    .wrapper__history__top {\n        margin-bottom: 10px;\n    }\n\n    .wrapper__main {\n        padding: 18px;\n    }\n\n\n}\n\n@media(min-width:1520px) {\n\n    .wrapper__execution__history table thead tr th:nth-child(2),\n    .wrapper__execution__history table tbody tr td:nth-child(2) {\n        width: 30%;\n    }\n}\n\n@media (max-width: 768px) {\n    .h3 {\n        font-size: 20px;\n        line-height: 30px;\n    }\n\n    .fb__13 {\n        font-size: 12px;\n        line-height: 21px;\n    }\n\n    main.app-main {\n        margin-left: 0px;\n        max-width: 100%;\n    }\n\n    .menu__toggle {\n        display: block;\n    }\n\n    .app-sidebar {\n        position: fixed;\n        top: 0;\n        left: 0;\n        bottom: 0;\n        width: 260px;\n        z-index: 1000;\n        background: #fff;\n        transform: translateX(-100%);\n        transition: transform .25s;\n    }\n\n    .app-sidebar--open {\n        transform: translateX(0);\n    }\n\n    .wrapper__right {\n        display: none;\n    }\n\n    .breadcrumb__list li.breadcrumb-item a,\n    .breadcrumb-item .breadcrumb-current {\n        font-size: 11px;\n    }\n\n    .wrapper__main {\n        padding: 15px 15px;\n    }\n\n    .sidebar {\n        position: fixed;\n        top: 0;\n        left: 0;\n        bottom: 0;\n        width: 260px;\n        z-index: 1000;\n        transform: translateX(-100%);\n        transition: transform .25s;\n    }\n\n    .sidebar--open {\n        transform: translateX(0);\n    }\n\n    .sidebar__overlay {\n        position: fixed;\n        inset: 0;\n        background: rgba(0, 0, 0, .4);\n        z-index: 4;\n    }\n\n\n    .main-content {\n        margin-left: 0;\n        width: 100%;\n        padding: 16px;\n    }\n\n    .agent__new__design__grid {\n        flex-direction: column-reverse;\n    }\n\n    .agent__exe__selection,\n    .agent__exe__blackScreen {\n        width: 100%;\n    }\n\n    .report__modal {\n        width: 100%;\n    }\n\n    .report__score__grid {\n        flex-wrap: wrap;\n    }\n\n\n    .report__score__col {\n        flex: 0 0 50%;\n    }\n\n\n    .wrapper__reportos__head {\n        flex-direction: column;\n        gap: 16px;\n    }\n\n    .wrapper__common__header {\n        padding: 12px 15px;\n        justify-content: flex-start;\n    }\n\n    .agent__website__url {\n        padding: 7px 10px;\n    }\n\n    .wrapper__generated__files .common__btn,\n    .download__file__btn__groups .common__btn {\n        font-size: 12px;\n    }\n\n    .wrapper__execution__history .table {\n        min-width: 1200px;\n    }\n\n    .input__filter {\n        width: 100%;\n    }\n\n    .input__filter input {\n        min-width: 100%;\n    }\n\n    .wrapper__s__Filter___dropdown {\n        right: initial;\n    }\n}\n\n@media (max-width: 768px) {\n    .hdr__project__switch {\n        gap: 6px;\n    }\n\n    .hdr__project__btn {\n        max-width: 150px;\n        padding: 5px 10px;\n    }\n\n    .hdr__project__menu {\n        min-width: 200px;\n        left: 0;\n    }\n\n    .wrapper__header__area {\n        row-gap: 7px;\n    }\n\n    .wrapper__header__area .hdr__project__switch {\n        margin-right: auto;\n        margin-left: 0px;\n    }\n\n    .table-col-hide {\n        display: table-cell !important;\n    }\n\n    .wrapper__header__area nav.breadcrumb {\n        width: 100%;\n    }\n\n    .report__score__grid {\n        row-gap: 10px;\n    }\n\n    .report__score__col {\n        flex: auto;\n        max-width: calc(100% / 1);\n    }\n\n    .wrapper__reportos__head__left {\n        max-width: 75%;\n        width: 100%;\n    }\n\n    .wrapper__reportos__head__right {\n        max-width: 25%;\n        width: 100%;\n    }\n\n    .wrapper__reportos__head {\n        flex-direction: row;\n        flex-wrap: nowrap;\n        margin-bottom: 16px;\n    }\n}\n\n@media (max-width: 480px) {\n    .fb__16 {\n        font-size: 14px;\n        line-height: 24px;\n    }\n\n    .hdr__project__eyebrow {\n        display: none;\n    }\n\n    .breadcrumb__list li.breadcrumb-item a,\n    .breadcrumb-item .breadcrumb-current {\n        font-size: 10px;\n    }\n\n    li.breadcrumb-item {\n        display: inline-flex;\n    }\n\n    .wrapper__header__area nav.breadcrumb {\n        width: 100%;\n    }\n\n    .sd-detail-score {\n        text-align: left !important;\n    }\n\n    .sd__cat__data {\n        display: block;\n        margin-top: 10px;\n    }\n\n    .report__head {\n        padding: 10px;\n    }\n\n    .report__title {\n        font-size: 12px;\n    }\n\n    .download__pdf {\n        font-size: 12px;\n        padding: 8px;\n    }\n\n    .download__pdf img {\n        width: 12px;\n    }\n\n    .wrapper__report__border {\n        padding: 10px;\n    }\n\n\n}\n\n@media(max-width:320px) {\n    .wrapper__common__header {\n        gap: 5px;\n    }\n\n    button.menu__toggle img {\n        width: 18px;\n        height: 18px;\n    }\n\n    .breadcrumb__list li.breadcrumb-item a,\n    .breadcrumb-item .breadcrumb-current {\n        font-size: 9px;\n    }\n\n\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
